<template>
  <div id="post" v-if="showPage() && isShowPage" ref="post">
    <!-- 头部 -->
    <van-nav-bar :title="getTitle()" :left-arrow="!$route.query.fromapp" @click-left="prev">
      <template #right>
        <img src="../../assets/studyIcon.png" alt="" class="study-icon" @click="jumpStudy">
      </template>
    </van-nav-bar>
    <div class="consulting-box">
      <div>{{ lang.consultingText1 }}</div>
      <div>{{ lang.consultingText2 }}</div>
    </div>
    <!-- 樓盤資料标题 -->
    <div class="dis-warp">
      <!-- 弹出层,刊登楼盘前 当前用户必须已绑定邮箱 -->
      <van-popup class="set-email-index" v-model="showSetEmail" :close-on-click-overlay="false">
        <p>{{ lang.setEmailNotice }}</p>
        <van-button type="info" @click="$router.go(-1)">{{ lang.cancel }}</van-button>
        <van-button type="danger" @click="$router.push('/edit-user/')">{{ lang.setNow }}</van-button>
      </van-popup>
      <!-- showSetWord -->
      <div v-if="showSetWord && !showSetEmail">
        <van-popup class="set-email-index" v-model="showSetWord" :close-on-click-overlay="false">
          <p>{{ lang.setWordNotice }}</p>
          <van-button type="info" @click="$router.go(-1)">{{ lang.cancel }}</van-button>
          <van-button type="danger" @click="$router.push('/edit-user/')">{{ lang.setNow }}</van-button>
        </van-popup>
      </div>
      <!-- 弹出层 刊登页图片假引导 -->
      <div v-if="!showSetEmail && showGuiY && !showSetWord">
        <van-popup duration="0" v-model="showGuiY" style="width: 100%">
          <div @touchmove.prevent style="width:100% background-color:green margin-top:30px" @click="shishi(1)">
            <img v-if="language == 'zh-hk'" src="../../assets/fan01.png" style="width: 100%" alt="" />
            <img v-else-if="language == 'zh-cn'" src="../../assets/jian01.png" style="width: 100%" alt="" />
            <img v-else src="../../assets/en01.png" style="width: 100%" alt="" />
          </div>
        </van-popup>
      </div>
      <!-- position="bottom" -->
      <van-popup v-model="showGuiE" style="width: 100%">
        <div @touchmove.prevent style="width:100% background-color:green margin-top:30px" @click="shishi(2)">
          <img v-if="language == 'zh-hk'" src="../../assets/fan02.png" style="width: 100%" alt="" />
          <img v-else-if="language == 'zh-cn'" src="../../assets/jian02.png" style="width: 100%" alt="" />
          <img v-else src="../../assets/en02.png" style="width: 100%" alt="" />
        </div>
      </van-popup>
      <van-popup v-model="showGuiS" style="width: 100%">
        <div @touchmove.prevent style="width:100% background-color:green margin-top:30px" @click="shishi(3)">
          <img v-if="language == 'zh-hk'" src="../../assets/fan03.png" style="width: 100%" alt="" />
          <img v-else-if="language == 'zh-cn'" src="../../assets/jian03.png" style="width: 100%" alt="" />
          <img v-else src="../../assets/en03.png" style="width: 100%" alt="" />
        </div>
      </van-popup>
      <van-popup v-model="showGuiF" style="width: 100%">
        <div @touchmove.prevent style="width:100% background-color:green margin-top:30px" @click="shishi(4)">
          <img v-if="language == 'zh-hk'" src="../../assets/fan04.png" style="width: 100%" alt="" />
          <img v-else-if="language == 'zh-cn'" src="../../assets/jian04.png" style="width: 100%" alt="" />
          <img v-else src="../../assets/en04.png" style="width: 100%" alt="" />
        </div>
      </van-popup>
      <van-popup v-model="showGuiW" style="width: 100%">
        <div @touchmove.prevent style="width:100% background-color:green margin-top:30px" @click="shishi(5)">
          <img v-if="language == 'zh-hk'" src="../../assets/fan05.png" style="width: 100%" alt="" />
          <img v-else-if="language == 'zh-cn'" src="../../assets/jian05.png" style="width: 100%" alt="" />
          <img v-else src="../../assets/en05.png" style="width: 100%" alt="" />
        </div>
      </van-popup>
      <!-- 遮罩层 1(付款) 2（续期）不允许修改数据  -->
      <div class="disable" v-if="mode == 1 || mode == 2"></div>
      <div class="warp-tit">
        <div class="title">
          <div class="title-icon"></div>
          <h2 class="title-text">{{ lang.propertyInfo }}</h2>
        </div>
        <p class="tit-tip">*{{ lang.startTip }}</p>
      </div>
      <!-- 樓盤類型 -->
      <cell ref="PropertyCategory" type="select" :title="lang.propertyType" :required="true" attr="PropertyCategory" @get-select="getSelect" @click.native="scrollTo"></cell>
      <!-- 物業編號  当前用户身份是代理的时候必填-->
      <cell ref="propertyNo" max="20" type="text-info" :title="lang.propertyNumber" :required="true" attr="propertyNo" @get-input="getInput" v-show="info.PropertySource == 2"></cell>
      <!-- 屋苑或大廈名稱 -->
      <cell
        v-if="this.$route.query.type != 'edit'"
        ref="estateName"
        :disabled="mode == 'edit'"
        type="select"
        :title="lang.estateOrBuildingName"
        :required="true"
        target="/prop-search/"
        attr="estateName"
        @get-select="getSelect"
        @build-checked="buildCheckedEven"
      ></cell>
      <cell v-else ref="estateName" :disabled="mode == 'edit'" type="select" :title="lang.estateOrBuildingName" :required="true" attr="estateName"></cell>
      <!-- 当楼盘类型为住宅 -->
      <div v-if="info.PropertyCategory == 1 || info.PropertyCategory == 6">
        <div v-if="store.state.estateInfo.estateID != 0 && store.state.estateData && !store.state.estateData.isCutomadded">
          <!-- 期数的展示规则 vuex数据中有选项-->
          <cell
            ref="phaseWithCulture"
            type="select"
            :title="lang.housenum"
            attr="phaseWithCulture"
            :required="true"
            v-show="info.PropertyCategory != 5 && this.store.state.estatePhase.length"
            @get-select="getSelect"
            @estateAddressChange="estateAddressChange"
          ></cell>
          <!-- 新版座数 -->
          <cell
            ref="buildingNameWithCulture"
            type="select"
            :title="lang.buildNum"
            attr="buildingNameWithCulture"
            :required="true"
            v-show="info.PropertyCategory != 5 && this.store.state.estateBuildNum.length > 0 && buildVisible"
            @get-select="getSelect"
          ></cell>
          <cell
            v-if="(this.store.state.estateBuildNum.length <= 0 && this.info.estateName) || (!buildVisible && this.info.estateName && this.info.phaseWithCulture)"
            ref="buildingNameWithCulture"
            max="20"
            type="text-info"
            :title="lang.buildNum"
            :required="false"
            attr="buildingNameWithCulture"
            @get-input="getInput"
          ></cell>
          <!-- 当buildingType为屋苑/單棟 -->
          <div v-if="store.state.buildId.buildingType == 1">
            <!-- 新版楼层  只有当选择了座数才会显示楼层选择 -->
            <cell
              ref="buildFloor"
              type="select"
              :title="lang.height1"
              attr="buildFloor"
              :required="true"
              v-show="Boolean(this.info.buildingNameWithCulture) && this.store.state.floorData.children && this.store.state.floorData.children.length > 0"
              @get-select="getSelect"
            ></cell>
            <!-- 高/中/低層  selectFloorData-->
            <!-- v-show="info.PropertyCategory != 5 && store.state.selectFloorData.unitFloor <= 0 && this.info.buildingNameWithCulture" -->
            <cell ref="unitFloor" type="select" :title="lang.height" :required="true" attr="unitFloor" v-show="Boolean(this.info.buildingNameWithCulture)" @get-select="getSelect"></cell>
            <!-- 单位 -->
            <cell
              ref="roomNoWithCulture"
              type="select"
              :title="lang.unitD"
              attr="roomNoWithCulture"
              v-show="info.PropertyCategory != 5 && store.state.selectFloorData && Boolean(this.info.buildingNameWithCulture) && this.info.buildFloor"
              @get-select="getSelect"
            ></cell>
            <cell
              v-if="this.store.state.floorData.children && this.store.state.floorData.children.length == 0"
              ref="roomNoWithCulture"
              max="20"
              type="text-info"
              :title="lang.unitD"
              :required="false"
              attr="roomNoWithCulture"
              @get-input="getInput"
            ></cell>
          </div>
          <!-- 当buildidngType为屋苑-獨立屋、街道號數-獨立屋、村屋 -->
          <div v-if="store.state.buildId.buildingType == 2 || store.state.buildId.buildingType == 3 || store.state.buildId.buildingType == 4">
            <!-- 高/中/低層 -->
            <cell
              v-if="info.PropertyCategory != 5"
              ref="unitFloor"
              type="select"
              :title="lang.height"
              :required="false"
              :tip="info.PropertyCategory != 4 && info.PropertyCategory != 3 ? lang.require.startRequir : ''"
              attr="unitFloor"
              v-show="info.PropertyCategory != 5 && this.info.buildingNameWithCulture"
              @get-select="getSelect"
            ></cell>
            <cell ref="roomNoWithCulture" max="20" type="text-info" :title="lang.unitD" :required="false" attr="roomNoWithCulture" v-show="info.PropertyCategory != 5" @get-input="getInput"></cell>
          </div>
          <div v-if="!buildVisible && Boolean(this.info.estateName)">
            <cell
              ref="unitFloor"
              type="select"
              :title="lang.height"
              :required="false"
              :tip="info.PropertyCategory != 4 && info.PropertyCategory != 3 ? lang.require.startRequir : ''"
              attr="unitFloor"
              @get-select="getSelect"
            ></cell>
            <cell ref="roomNoWithCulture" max="20" type="text-info" :title="lang.unitD" :required="false" attr="roomNoWithCulture" v-show="info.PropertyCategory != 5" @get-input="getInput"></cell>
          </div>
        </div>
        <!--
        isCutomadded为true代表为村屋-客製
        如果是手动输入的屋苑名称或者是村屋-客製，则只显示座数、楼层、单位
       -->
        <div v-if="store.state.estateInfo.estateID == 0 || (store.state.estateData && store.state.estateData.isCutomadded)">
          <cell ref="buildingNameWithCulture" max="20" type="text-info" :title="lang.buildNum" :required="false" attr="buildingNameWithCulture" @get-input="getInput"></cell>
          <cell
            v-if="info.PropertyCategory != 5"
            ref="unitFloor"
            type="select"
            :title="lang.height"
            :required="false"
            :tip="info.PropertyCategory != 4 && info.PropertyCategory != 3 ? lang.require.startRequir : ''"
            attr="unitFloor"
            @get-select="getSelect"
          ></cell>
          <cell ref="roomNoWithCulture" max="20" type="text-info" :title="lang.unitD" :required="false" attr="roomNoWithCulture" @get-input="getInput"></cell>
        </div>
      </div>
      <!-- 当楼盘类型为车位 -->
      <div v-if="info.PropertyCategory == 4">
        <!-- 期数的展示规则 vuex数据中有选项-->
        <cell
          ref="housenum"
          type="select"
          :title="lang.housenum"
          attr="phaseWithCulture"
          :required="false"
          v-show="info.PropertyCategory != 5 && this.store.state.estatePhase.length"
          @get-select="getSelect"
          @estateAddressChange="estateAddressChange"
        ></cell>
        <!-- 高/中/低層 -->
        <cell
          v-if="info.PropertyCategory != 5"
          ref="unitFloor"
          type="select"
          :title="lang.height"
          :required="false"
          attr="unitFloor"
          v-show="info.PropertyCategory != 5 && info.estateName"
          @get-select="getSelect"
        ></cell>
      </div>
      <!-- 当楼盘类型为工商厦 -->
      <div v-if="info.PropertyCategory == 2">
        <cell
          ref="housenum"
          type="select"
          :title="lang.housenum"
          attr="phaseWithCulture"
          :required="true"
          v-show="info.PropertyCategory != 5 && this.store.state.estatePhase.length"
          @get-select="getSelect"
          @estateAddressChange="estateAddressChange"
        ></cell>
        <cell
          ref="buildNum"
          type="select"
          :title="lang.buildNum"
          attr="buildingNameWithCulture"
          :required="false"
          v-show="info.PropertyCategory != 5 && this.store.state.estateBuildNum.length > 0 && Boolean(this.info.estateName)"
          @get-select="getSelect"
        ></cell>
        <cell
          ref="buildNum"
          max="20"
          type="text-info"
          :title="lang.buildNum"
          :required="false"
          attr="buildingNameWithCulture"
          v-show="info.PropertyCategory != 5 && this.store.state.estateBuildNum.length <= 0 && Boolean(this.info.estateName)"
          @get-input="getInput"
        ></cell>
        <cell v-if="info.PropertyCategory != 5" ref="unitFloor" type="select" :tip="lang.require.startRequir" :title="lang.height" :required="false" attr="unitFloor" @get-select="getSelect"> </cell>
        <cell ref="roomNoWithCulture" max="20" type="text-info" :title="lang.unitD" :required="false" attr="roomNoWithCulture" @get-input="getInput"></cell>
      </div>
      <!-- 当楼盘类型为店铺 -->
      <div v-if="info.PropertyCategory == 3">
        <cell
          ref="housenum"
          type="select"
          :title="lang.housenum"
          attr="phaseWithCulture"
          :required="false"
          v-show="info.PropertyCategory != 5 && this.store.state.estatePhase.length"
          @get-select="getSelect"
          @estateAddressChange="estateAddressChange"
        ></cell>
        <cell ref="buildNum" max="20" type="text-info" :title="lang.buildNum" :required="false" attr="buildingNameWithCulture" v-show="info.PropertyCategory != 5" @get-input="getInput"></cell>
        <cell v-if="info.PropertyCategory != 5" ref="unitFloor" type="select" :title="lang.height" :required="false" attr="unitFloor" @get-select="getSelect"></cell>
        <cell ref="roomNoWithCulture" max="20" type="text-info" :title="lang.unitD" :required="false" attr="roomNoWithCulture" @get-input="getInput"></cell>
      </div>

      <div v-if="!isOldData">
        <!-- 楼盘资料模块 -->
        <div v-if="info.PropertyCategory == 1 || info.PropertyCategory == 6">
          <div class="build-info" style="padding-bottom: 0" v-if="info.rentalType == 1 && store.state.buildId.buildingType == 1">
            <div class="build-info-tips">{{ lang.propertyInformation1 }}</div>
          </div>
          <div class="build-info" style="padding-bottom: 0" v-if="info.rentalType == 2 && store.state.buildId.buildingType == 1">
            <div class="build-info-tips">{{ lang.propertyInformation3 }}</div>
          </div>
          <!-- 屋苑/单栋 -->
          <div
            :class="{ 'build-info': true, marginTop15: !info.buildingNameWithCulture && this.$route.query.type == 'copy' }"
            style="padding-right: 0; margin-top: 0"
            v-if="store.state.estateInfo.estateID != 0 && this.info.estateName && this.store.state.buildId.buildingType == 1"
          >
            <div class="build-info-tips">{{ lang.propertyInformation2 }}</div>

            <van-radio-group v-model="buildChecked" v-if="store.state.estateInfo.gscopeNameWithCulture && info.roomNoWithCulture">
              <van-cell-group inset>
                <van-cell clickable @click="buildChecked = '1'" style="border-bottom: 1px solid #eee; padding-right: 15px; background: #fff">
                  <template #title>
                    <div class="build-info-text">
                      {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? info.estateNameEN : info.estateName }} {{ store.state.phaseText }}
                      <span
                        v-if="
                          !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                            ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                            : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                        "
                        >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
                      >
                      {{ store.state.UnitFloorText }}
                      {{ info.roomNoWithCulture }}
                    </div>
                  </template>
                  <template #right-icon>
                    <van-radio name="1" checked-color="#ee0a24" class="build-radio" />
                  </template>
                </van-cell>
                <van-cell clickable @click="buildChecked = '2'" style="border-bottom: 1px solid #eee; padding-right: 15px; background: #fff">
                  <template #title>
                    <div class="build-info-text">
                      {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? info.estateNameEN : info.estateName }} {{ store.state.phaseText }}
                      <span
                        v-if="
                          !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                            ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                            : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                        "
                        >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
                      >
                      {{ store.state.UnitFloorText }}
                    </div>
                  </template>
                  <template #right-icon>
                    <van-radio name="2" checked-color="#ee0a24" class="build-radio" />
                  </template>
                </van-cell>
                <van-cell clickable @click="buildChecked = '3'" style="border-bottom: 1px solid #eee; padding-right: 15px; background: #fff">
                  <template #title>
                    <div class="build-info-text">
                      {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? info.estateNameEN : info.estateName }} {{ store.state.phaseText }}
                      <span
                        v-if="
                          !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                            ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                            : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                        "
                        >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
                      >
                      {{ info.roomNoWithCulture }}
                    </div>
                  </template>
                  <template #right-icon>
                    <van-radio name="3" checked-color="#ee0a24" class="build-radio" />
                  </template>
                </van-cell>
                <van-cell clickable @click="buildChecked = '4'" style="padding-right: 15px; background: #fff">
                  <template #title>
                    <div class="build-info-text">
                      {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? info.estateNameEN : info.estateName }} {{ store.state.phaseText }}
                      <span
                        v-if="
                          !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                            ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                            : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                        "
                        >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
                      >
                    </div>
                  </template>
                  <template #right-icon>
                    <van-radio name="4" checked-color="#ee0a24" class="build-radio" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
            <van-radio-group v-model="buildChecked" v-if="store.state.estateInfo.gscopeNameWithCulture && !info.roomNoWithCulture">
              <van-cell-group inset>
                <van-cell clickable @click="buildChecked = '1'" style="border-bottom: 1px solid #eee; padding-right: 15px; background: #fff">
                  <template #title>
                    <div class="build-info-text">
                      {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? info.estateNameEN : info.estateName }} {{ store.state.phaseText }}
                      <span
                        v-if="
                          !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                            ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                            : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                        "
                        >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
                      >
                      {{ store.state.UnitFloorText }}
                    </div>
                  </template>
                  <template #right-icon>
                    <van-radio name="1" checked-color="#ee0a24" class="build-radio" />
                  </template>
                </van-cell>
                <van-cell clickable @click="buildChecked = '2'" style="padding-right: 15px; background: #fff">
                  <template #title>
                    <div class="build-info-text">
                      {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? info.estateNameEN : info.estateName }} {{ store.state.phaseText }}
                      <span
                        v-if="
                          !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                            ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                            : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                        "
                        >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
                      >
                    </div>
                  </template>
                  <template #right-icon>
                    <van-radio name="2" checked-color="#ee0a24" class="build-radio" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
          <!-- 屋苑-獨立屋、街道號數-獨立屋、村屋 -->
          <div
            :class="{ 'build-info': true, marginTop15: true }"
            style="padding-right: 0; margin-top: 0; padding-top: 0"
            v-if="store.state.estateInfo.estateID != 0 && this.store.state.buildId.buildingType != 1 && this.info.estateName && store.state.estateData && !store.state.estateData.isCutomadded"
          >
            <div class="build-info-tips" style="margin-bottom: 12px">{{ lang.propertyInformation2 }}</div>
            <div class="build-info-text">
              {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? info.estateNameEN : info.estateName }} {{ store.state.phaseText }} {{ store.state.UnitFloorText }}
              {{ info.roomNoWithCulture }}
            </div>
          </div>
          <!-- 村屋-客製 -->
          <div
            :class="{ 'build-info': true, marginTop15: true }"
            style="padding-right: 0; margin-top: 0; padding-top: 0"
            v-if="(store.state.estateInfo.estateID == 0 || (store.state.estateData && store.state.estateData.isCutomadded)) && this.info.estateName && this.store.state.buildId.buildingType != 1"
          >
            <div class="build-info-tips" style="margin-bottom: 12px">{{ lang.propertyInformation2 }}</div>
            <div class="build-info-text">
              {{ store.state.estateInfo.gscopeNameWithCulture }}
              <span v-if="store.state.estateInfo.estateID == 0">{{ language == 'en-us' ? (info.estateNameEN ? info.estateNameEN : info.estateName) : info.estateName }}</span>
              <span v-else>{{ language == 'en-us' ? info.estateNameEN : info.estateName }}</span>
              <span
                v-if="
                  !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                    ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                    : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                "
                >{{ (store.state.estateData && store.state.estateData.isCutomadded) || store.state.estateInfo.estateID == 0 ? info.buildingNameWithCulture : '' }}</span
              >
              {{ store.state.UnitFloorText }}
              {{ info.roomNoWithCulture }}
            </div>
          </div>
        </div>
        <!-- 楼盘类型为车位 -->
        <div v-if="info.PropertyCategory == 4">
          <div class="build-info" style="padding-right: 0" v-if="this.info.estateName">
            <div class="build-info-tips" style="margin-bottom: 12px">{{ lang.propertyInformation2 }}</div>
            <div class="build-info-text" v-if="store.state.estateInfo.estateID != 0">
              {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? info.estateNameEN : info.estateName }} {{ store.state.phaseText }} {{ store.state.UnitFloorText }}
              {{ info.roomNoWithCulture }}
            </div>
            <div class="build-info-text" v-else>
              {{ store.state.estateInfo.gscopeNameWithCulture }} {{ language == 'en-us' ? (info.estateNameEN ? info.estateNameEN : info.estateName) : info.estateName }}
              <span
                v-if="
                  !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                    ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                    : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                "
                >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
              >
              {{ store.state.UnitFloorText }}
              {{ info.roomNoWithCulture }}
            </div>
          </div>
        </div>
        <!-- 楼盘类型为工商厦 -->
        <div v-if="info.PropertyCategory == 2">
          <div class="build-info" style="padding-right: 0" v-if="this.info.estateName">
            <div class="build-info-tips" style="margin-bottom: 12px">{{ lang.propertyInformation2 }}</div>
            <div class="build-info-text">
              {{ store.state.estateInfo.gscopeNameWithCulture }}
              <span v-if="store.state.estateInfo.estateID == 0">{{ language == 'en-us' ? (info.estateNameEN ? info.estateNameEN : info.estateName) : info.estateName }}</span>
              <span v-else>{{ language == 'en-us' ? info.estateNameEN : info.estateName }}</span> {{ store.state.phaseText }}
              <span
                v-if="
                  !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                    ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                    : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                "
                >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
              >
              {{ store.state.UnitFloorText }}
              {{ info.roomNoWithCulture }}
            </div>
          </div>
        </div>
        <!-- 楼盘类型为店铺 -->
        <div v-if="info.PropertyCategory == 3">
          <div class="build-info" style="padding-right: 0" v-if="this.info.estateName">
            <div class="build-info-tips" style="margin-bottom: 12px">{{ lang.propertyInformation2 }}</div>
            <div class="build-info-text">
              {{ store.state.estateInfo.gscopeNameWithCulture }}
              <span v-if="store.state.estateInfo.estateID == 0">{{ language == 'en-us' ? (info.estateNameEN ? info.estateNameEN : info.estateName) : info.estateName }}</span>
              <span v-else>{{ language == 'en-us' ? info.estateNameEN : info.estateName }}</span>
              <span
                v-if="
                  !(store.state.estateInfo.estateType == 'single' && language == 'en-us'
                    ? store.state.estateInfo.estateNameEN == info.buildingNameWithCulture
                    : store.state.estateInfo.estateName == info.buildingNameWithCulture && info.estateID > 0)
                "
                >{{ store.state.buildId.buildingNameWithCulture ? store.state.buildId.buildingNameWithCulture : info.buildingNameWithCulture }}</span
              >
              {{ store.state.UnitFloorText }}
              {{ info.roomNoWithCulture }}
            </div>
          </div>
        </div>
        <!-- 楼盘类型为土地 -->
        <div v-if="info.PropertyCategory == 5">
          <div class="build-info" style="padding-right: 0" v-if="this.info.estateName">
            <div class="build-info-tips" style="margin-bottom: 12px">{{ lang.propertyInformation2 }}</div>
            <div class="build-info-text">
              {{ store.state.estateInfo.gscopeNameWithCulture }}
              <span v-if="store.state.estateInfo.estateID == 0">{{ language == 'en-us' ? (info.estateNameEN ? info.estateNameEN : info.estateName) : info.estateName }}</span>
              <span v-else>{{ language == 'en-us' ? info.estateNameEN : info.estateName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 15px">
        <!-- 楼盘地址 -->
        <cell v-if="info.estateID > 0" ref="estateAddress" max="20" type="text-info" :title="lang.estateAddress" :required="false" attr="estateAddress" :disabled="true" @get-input="getInput"></cell>
        <cell
          v-if="info.estateID == 0 && mode == 'edit'"
          ref="estateAddress"
          max="20"
          type="text-info"
          :title="lang.estateAddress"
          :required="false"
          attr="estateAddress"
          :disabled="true"
          @get-input="getInput"
        ></cell>
        <cell
          v-if="info.estateID == 0 && mode != 'edit'"
          ref="estateAddress"
          max="20"
          type="text-info"
          :title="lang.estateAddress"
          :required="false"
          attr="estateAddress"
          :disabled="false"
          @get-input="getInput"
        ></cell>
        <!-- 楼龄 -->
        <cell
          v-if="info.estateID > 0"
          ref="buildingAge"
          max="20"
          type="text-info"
          :title="lang.estateYear"
          :required="false"
          attr="buildingAge"
          @get-input="getInput"
          :disabled="true"
          v-show="info.PropertyCategory != 5"
        ></cell>
        <cell
          v-if="info.estateID == 0 && mode == 'edit'"
          ref="buildingAge"
          max="20"
          type="text-info"
          :title="lang.estateYear"
          :required="false"
          attr="buildingAge"
          @get-input="getInput"
          :disabled="true"
          v-show="info.PropertyCategory != 5"
        ></cell>
        <cell
          v-if="info.estateID == 0 && mode != 'edit'"
          ref="buildingAge"
          max="20"
          type="text-info"
          :title="lang.estateYear"
          :required="false"
          attr="buildingAge"
          @get-input="getInput"
          :disabled="false"
          v-show="info.PropertyCategory != 5"
        ></cell>
        <!-- 房间数目 -->
        <cell
          v-if="info.PropertyCategory && (info.PropertyCategory == 1 || info.PropertyCategory == 2 || info.PropertyCategory == 3 || info.PropertyCategory == 6)"
          ref="RoomNumber"
          type="select"
          :title="lang.noOfRooms"
          :tip="info.PropertyCategory != 2 && info.PropertyCategory != 3 ? lang.require.startRequir : ''"
          attr="RoomNumber"
          :hide-border="true"
          @get-select="getSelect"
        ></cell>
        <!-- 洗手间数目 -->
        <cell
          v-if="info.PropertyCategory && (info.PropertyCategory == 1 || info.PropertyCategory == 6)"
          ref="ToiletNumber"
          type="select"
          :title="lang.ToiletRooms"
          :hide-border="true"
          attr="ToiletNumber"
          @get-select="getSelect"
        ></cell>
      </div>
      <!-- 银行估计模块 -->
      <div v-if="info.PropertyCategory == 1 && this.store.state.buildId.buildingType == 1 && this.store.state.selectFloorData && this.store.state.selectFloorData.roomResponses.length > 0 && Boolean(info.roomNoWithCulture) && info.rentalType == 1 && isBocModule">
        <div class="warp-tit mt15">
          <div class="title">
            <div class="title-icon"></div>
            <h2 class="title-text">{{ lang.PropertyValuation }}</h2>
          </div>
        </div>
        <div class="valuation-bank">
          <div>
            <div class="valuation-title">{{ lang.PropertyValuation }}</div>
            <div class="valuation-tips">{{ lang.PropertyValuationTips }}</div>
          </div>
          <div style ='flex:0 0 40px'></div>
          <van-switch size="18px" style="min-width:36px" active-color='#FE5151' v-model="info.isBoc"/>
        </div>
      </div>
      <!-- 放盘资料模块 -->
      <div class="warp-tit mt15">
        <div class="title">
          <div class="title-icon"></div>
          <h2 class="title-text">{{ lang.propertyDetail }}</h2>
        </div>
      </div>
      <!-- 售价 -->
      <cell ref="paidSalePrice" textType="tel" max="12" type="text-info" :title="`${lang.sellPrice}(${lang.sellPriceUnit})`" attr="paidSalePrice" v-if="info.rentalType == 1 && !info.subCategory.includes('6') && !info.subCategory.includes('7')" :required="true"></cell>
      <cell ref="unPaidSalePrice" :tip="lang.MsaleForm" textType="tel" max="12" type="text-info" :title="`${lang.unPaid}`" :titleBeh="`(${lang.sellPriceUnit})`" attr="unPaidSalePrice" v-if="info.rentalType == 1 && (info.subCategory.includes('6') || info.subCategory.includes('7'))" :required="true"></cell>
      <cell ref="paidSalePrice"  textType="tel" max="12" type="text-info" :title="`${lang.alPaid}`" :titleBeh="`(${lang.sellPriceUnit})`" attr="paidSalePrice" v-if="info.rentalType == 1 && (info.subCategory.includes('6') || info.subCategory.includes('7'))" :required="true"></cell>
      
      <!-- 租盘规则  rentalType为2 -->
      <!-- 租价 -->
      <cell v-if="info.rentalType == 2" ref="rentPrice" max="12" type="text-info" :title="lang.mrentPrice" attr="rentPrice" :required="true"></cell>
      <!-- 减价盘 -->
      <div v-if="isReduceUnpaid && showReducePrice" class="valuation-bank">
        <div>
          <div class="valuation-title"><span class="required">*</span>{{lang.evaVau}}({{lang.weibu}})</div>
          <div class="valuation-tips">{{lang.revRatio}}</div>
        </div>
        <van-switch size="18px" active-color='#FE5151'  v-model="info.isReduceUnPaidSalePrice"/>
      </div>
      <div v-if="(isReducePaid || rentReducePrice) && showReducePrice" class="valuation-bank">
        <div>
          <div class="valuation-title"><span class="required">*</span>{{lang.evaVau}}{{info.rentalType == 1 && (info.subCategory.includes('6') || info.subCategory.includes('7')) ? `(${lang.yibu})`:''}}</div>
          <div class="valuation-tips">{{lang.revRatio}}</div>
        </div>
        <van-switch size="18px" active-color='#FE5151' v-if="isReducePaid" v-model="info.isReducePaidSalePrice"/>
        <van-switch size="18px" active-color='#FE5151' v-if="rentReducePrice" v-model="info.isReduceRentPrice"/>
      </div>
      <template v-if="info.rentalType == 2">
        <!-- 起租日 -->
        <cell type="select" :title="lang.startDate" attr="beginRentTime"></cell>
        <!-- 其他选项 車位和土地时隱藏【其他選項】模塊-->
        <cell v-if="!(info.PropertyCategory == 4) && !(info.PropertyCategory == 5)" type="select" :title="lang.otherOps" attr="RentLabel"></cell>
      </template>
      <!-- 面积 -->
      <div v-if="info.PropertyCategory != 4" class="areaWarp" ref="buildingArea">
        <!-- <span :class="language == 'en-us' ? 'enline' : 'line'"></span> -->
        <div class="area">
          <!-- 实用面积 -->
          <cell
            type="text-info"
            v-if="info.PropertyCategory != 4"
            :title="lang.useArea"
            attr="saleableArea"
            :tip="lang.areaPoint"
            :class="language == 'en-us' ? 'enuseArea' : 'useArea'"
            :required="true"
          ></cell>
          <!-- 建筑面积 -->
          <cell type="text-info" v-if="info.PropertyCategory != 4" :title="lang.buildArea" attr="buildingArea" :class="language == 'en-us' ? 'enbuildArea' : 'buildArea'"></cell>
        </div>
        <div class="valuation-bank" v-if="((info.subCategory.includes('11') || info.subCategory.includes('8')) && info.PropertyCategory ==1) || (info.PropertyCategory && info.PropertyCategory!='1' && info.PropertyCategory !='4' && info.PropertyCategory !='6')">
          <div>
            <div class="valuation-title"><span class="required">*</span>{{lang.areaUncheck}}</div>
            <div class="valuation-tips">{{lang.mesUncheck}}</div>
            <div class="valuation-tips">{{lang.houseWebsite}}</div>
          </div>
          <van-switch size="18px" active-color='#FE5151' v-model="isArea"/>
        </div>
      </div>       
      <!-- codeShow == '0' && -->
      <cell
        v-if="info.PropertyCategory == '1' && store.state.buildId.buildingType == 1 && info.buildingNameWithCulture && (info.buildFloor || this.info.roomNoWithCulture) && platimgLengthFlag.length > 0"
        ref="platimg"
        type="platimg"
        attr="platimg"
        :title="lang.choosepropertyPlat"
        target="/platimg/"
      ></cell>
      <!-- 放盘标题(中文) 添加常用词 -->
      <cell ref="titleCN" type="text-info" :title="lang.adsTitleChi" attr="titleCN" :tip="lang.require.starTitCn" :required="true" max="30"></cell>
      <!-- 放盘标题(英文) -->
      <cell type="text-info" :title="lang.adsTitleEng" attr="titleEN" max="50"></cell>
      <!-- 楼盘介绍(中文) -->
      <cell ref="introduceCN" type="textarea" :title="lang.propertyDescriptionChi" attr="introduceCN" :required="true" max="300"></cell>
      <!-- 楼盘介绍(英文) -->
      <cell type="textarea" :title="lang.propertyDescriptionEng" attr="introduceEN" max="600"></cell>
      <template v-if="info.rentalType == 2 && info.subCategory.includes('19')">
        <!-- 設施與服務(中文) -->
        <cell ref="servicesCN" type="textarea" :title="lang.facilitiesAndServicesChi" attr="servicesCN" :required="true" max="300"></cell>
        <!-- 設施與服務(英文) -->
        <cell type="textarea" :title="lang.facilitiesAndServicesEng" attr="servicesEN" max="600"></cell>
      </template>
      <!-- 楼盘标签 ref="PropertyCategory" attr="PropertyCategory" @click.native="scrollTo"-->
      <cell v-if="info.PropertyCategory != '5'" type="tags" :title="lang.propertyTags" target="/tags/"></cell>
      <!-- 图片 -->
      <cell ref="images" type="select" :title="lang.addPic" attr="images" :tip="lang.imageTips" target="/photos/"></cell>
      <!-- VR代拍提示 -->
      <div v-if="info.PropertySource == 1" class="vrTipsLong">
        <div class="vrTips-icon">{{ lang.vrTips1 }}</div>
        <div class="vrTips-icon">{{ lang.vrTips3 }}</div>
        
      </div>
      <!-- 视频 -->
      <cell type="vid-show" :title="lang.vid_title" target="/videos/"></cell>
      <!-- 代理资料 -->
      <div class="warp-tit mt15">
        <div class="title">
          <div class="title-icon"></div>
          <h2 class="title-text">{{ lang.concantDetail }}</h2>
        </div>
      </div>
      <!-- 盤源 -->
      <cell ref="PropertySource" type="select" :title="lang.agent" :required="true" attr="PropertySource" @get-select="getSelect" @update-way="handleUpdateWay" :disabled="userInfo.isPropertyAgent || mode == 'edit'" :tip="info.PropertySource == 1 ? lang.ownerPropertySource : false"></cell>
      <!-- 联络人名称 -->
      <cell ref="contactNameCN" type="text-user" :title="lang.contactNameChi" :required="true" attr="contactNameCN"></cell>
      <!-- 电邮地址 -->
      <cell ref="email" type="text-user" :title="lang.email" :required="true" attr="email"></cell>
      <!-- 联络电话 -->
      <cell ref="telphone" type="telphone" :title="lang.tel" :required="true" attr="telphone"></cell>
      <!-- 显示电话 -->
      <cell ref="isShowTel" type="select" :title="lang.telShow" :required="true" :hide-border="true" attr="isShowTel" @get-select="getSelect"></cell>
      <!-- 代理资料展示 -->
      <div v-show="info.PropertySource == 2">
        <div class="warp-tit mt15">
          <div class="title">
            <div class="title-icon"></div>
            <h2 class="title-text">{{ lang.agencyInformation }}</h2>
          </div>
        </div>
        <!-- 代理公司资料及个人地产代理牌照 -->
        <!-- <cell ref="isHideCompanyInfo" type="select" :title="lang.companyShow" :required="true" attr="isHideCompanyInfo" @get-select="getSelect"></cell> -->
        <cell ref="companyNameCN" :disabled="Source && userInfo.companyNameCN != '' && agentShow.showcompanyNameCN" type="text-user" :title="lang.companyName" :required="true" attr="companyNameCN"></cell>
        <!-- 代理公司名称英文 -->
        <cell type="text-user" :disabled="Source && userInfo.companyNameEN != '' && agentShow.showcompanyNameEN" :title="lang.companyNameEng" attr="companyNameEN"></cell>
        <!-- 代理公司电话 -->
        <!-- {{Source}}--{{  userInfo.companyTel }}--{{ agentShow.showcompanyTel }} -->
        <cell ref="companyTel" :disabled="Source && userInfo.companyTel !='' && agentShow.showcompanyTel" type="text-user" :title="lang.companyPhone" :required="true" attr="companyTel"></cell>
        <!-- 国内联络电话 -->
        <cell type="customerTel" :title="lang.chinaMobile" attr="customerTel"></cell>
        <!-- 代理公司地址 -->
        <cell type="text-user" :title="lang.companyAddress" :hide-border="true" attr="companyAddress"></cell>
        <!-- 公司地产代理牌照 -->
        <cell ref="companyLicenceNumber" :disabled="Source && userInfo.companyLicenceNumber !='' && agentShow.showcompanyLicenceNumber" type="text-user" :title="lang.companyLicense" :required="true" class="mt15" attr="companyLicenceNumber"></cell>
        <!-- 个人地产代理牌照 -->
        <!-- :disabled="Boolean(userInfo.agentCardPath) && Source" -->
        <cell ref="agentLicenceNumber" :disabled="Source && userInfo.agentLicenceNumber !='' && agentShow.showagentLicenceNumber" type="text-user" :title="lang.personalLicense" :required="true" attr="agentLicenceNumber" ></cell>
        <!-- 地產代理證上传  第一次业主=>代理 要上传文件  && !Source-->
        <van-cell style="padding: 15px 15px 5px;" v-show="userInfo.agentCardPath"  ref="agentCardPath" title-style="margin-right: 0;">
          <template slot="title">
            <div>
              <span class="required">*</span>
              <span style="font-size: 15px; font-weight: bold; color: #333333; line-height: 21px; display: inline-block">{{ lang.agentCard }}</span>
            </div>
          </template>
          <template slot="label">
            <div>
              <span style="font-weight: 400; font-size: 12px; color: #ED1C24; letter-spacing: 0;">{{ lang.agentText }}</span>
            </div>
          </template>
          <template slot="label">
            <div class="del" @click="userInfo.agentCardPath = ''" v-if="userInfo.agentCardPath && !Source">
              <i class="van-icon van-icon-cross van-uploader__preview-delete-icon"></i>
            </div>
            <img style="width: 64px; height: 64px; margin-top: 10px; border-radius: 4px;" :src="userInfo.agentCardPath | imgResize('user')" onerror="errorImg(this,'user')" alt="" height="50" />
          </template>
        </van-cell>
        <!-- <van-cell style="padding: 15px" v-show="!userInfo.agentCardPath && !Source" ref="agentCardPath" > -->
        <van-cell style="padding: 15px; align-items: flex-start;" v-show="!userInfo.agentCardPath && info.PropertySource == 2" ref="agentCardPath" title-style="margin-right: 0;">
          <template slot="title">
            <div>
              <span class="required">*</span>
              <span style="font-size: 15px; font-weight: bold; color: #333333; line-height: 21px; display: inline-block">{{ lang.agentCard }}</span>
            </div>
          </template>
          <template slot="default">
            <van-uploader :after-read="onRead" :max-size="5242880" :deletable="true" accept="image/png, image/jpeg, image/jpg">{{ lang.upload }}</van-uploader>
          </template>
          <template slot="label">
            <div style="width: 275px;">
              <span style="font-weight: 400; font-size: 12px; color: #ED1C24; letter-spacing: 0;">{{ lang.agentText }}</span>
            </div>
          </template>
        </van-cell>
        <div style="background-color:#fff">
          <div style="height:0;width:92%;border-bottom:1px solid #eee;margin-left:15px;margin-right:15px">ddd</div>
        </div>
        <!-- 代理证到期时间-->
        <van-cell :class="Source && userInfo.agentCardExpireTime && subedAgenTTime ? 'disCell' : 'cellclass'"  @click="showPopup=true" title-style="margin-right: 0;">
            <template slot="title">
              <div >
                <span class="required">*</span>
                <span style="font-size: 15px; font-weight: bold; color: #181717; line-height: 21px; display: inline-block">{{ lang.agentCardTime }}</span>
              </div>
            </template>
            <template slot="default">
              <div @click.stop>
                <van-popup v-model="showPopup"  class="popup" position="bottom"  @click-overlay="showPopup = false" :close-on-click-overlay="true">
                  <van-datetime-picker
                  v-model="agentCardExpireTime"
                  type="date"
                  @confirm="confirmAgenTime"
                  @cancel="cancelAgenTime" 
                  :confirm-button-text="lang.confirm"
                />
                </van-popup>
              </div>
              <span style=" line-height: 21px; display: inline-block">{{ userInfo.agentCardExpireTime ? new Date(parseInt(userInfo.agentCardExpireTime ) * 1000).toLocaleDateString():lang.pleSelect }}</span>
            </template>
        </van-cell>
      </div>
    </div>
    <div class="warp-tit mt15">
      <div class="title">
        <div class="title-icon"></div>
        <h2 class="title-text">{{ lang.adClass }}</h2>
        <span class="remark" @click="openPreview">{{ lang.remark }}</span>
        <div v-if="image_show" class="close-button" @click="closePreview"></div>
        <van-image-preview v-model="image_show" :images="image_images" :showIndex = "false"></van-image-preview>
      </div>
    </div>
    <!-- 付款方式 -->
    <!-- && !(info.PropertySource == 1 && info.topType.startsWith('Normal')) -->
    <cell
      type="select-pay"
      v-if="mode != 'edit'"
      :hide-border="true"
      attr="way"
      :title="lang.payway"
      @get-select="getSelect"
      :disabled="mode == 'edit'"
      :buyList = 'buyList'
      :rentList = 'rentList'
    ></cell>
    <!-- <cell
      type="select-pay"
      v-if="mode != 'edit' && !(info.PropertySource == 1 && info.topType.startsWith('Normal'))"
      :hide-border="true"
      attr="way"
      :title="lang.payway"
      @get-select="getSelect"
      :disabled="mode == 'edit'"
    ></cell> -->
    <!-- 收费标准 -->
    <div class="charges">
      <div
        :class="[
          'chargeItem',
          { verifi: item.itemName == 'VerifyLabel', verifShow: item.itemName == 'VerifyLabel' },
          { selectItem: info.topType == item.itemName },
          { disableItem: (mode == 'edit' || mode == '1' || mode == '2') && info.topType == item.itemName },
        ]"
        v-for="item in charges"
        :key="item.itemName"
        @click="changeCharge(item.itemName)"
        >
        <div class="charges-up">
          <div class="up-left" v-if="item.itemName == 'Normal' || item.itemName == 'Normal_Agent'">
            <img src="./../../assets/standard.png" alt="" />
            <h3>{{ lang.listingNorl }}</h3>
          </div>
          <div class="up-left" v-if="item.itemName == 'Star_Rent' || item.itemName == 'Star_Buy'">
            <img src="./../../assets/star.png" alt="" />
            <h3>{{ lang.listingStar }}</h3>
          </div>
          <div class="up-left" v-if="item.itemName == 'VerifyLabel'">
            <svg class="icon icon_ver" aria-hidden="true" v-if="language !== 'en-us'">
              <use xlink:href="#icon-kandengloupan1" />
            </svg>
            <h3>{{ lang.verif }}</h3>
          </div>
          <div class="up-right">
            <del v-if="item.itemName == 'Normal' && info.PropertySource == 1 && (way == 'free' || (editIsAddUserFreeProperty && mode !== 'copy' && mode !== 2))">
              <i>{{ item.price }}{{ lang.GoldCoin }}</i>
              <!-- <i v-show="way == 'paypal' || way == 'trans' || way == 'paydollar' || way == 'alipay' || way == 'wepay'">HK$</i>{{ item.price }}<i v-show="way == 'coin'">{{ lang.GoldCoin }}</i> -->
            </del>
            <h4>
              <!--  && (item.itemName !== 'Normal' || info.PropertySource !== 1) -->
              <i v-show="((way == 'free' || way == 'paypal' || way == 'trans' || way == 'paydollar' || way == 'alipay' || way == 'wepay') && !(item.itemName == 'Normal' && info.PropertySource == 1 && (way == 'free' || (editIsAddUserFreeProperty && mode !== 'copy' && mode !== 2))))" class="moeny"
                >HK$</i
              >
              <!-- 業主顯示免費！ -->
              <i v-if="item.itemName == 'Normal' && info.PropertySource == 1 && (way == 'free' || (editIsAddUserFreeProperty && mode !== 'copy' && mode !== 2))" style="font-size: 20px; color: #ed1c24; line-height: 31px;">{{ lang.FreeY }}</i>
              <!-- v-else -->
              <i v-else>
                <i style="font-size: 20px">
                  {{ item.discountPrice }}
                </i>
                <i v-show="way == 'coin'">{{ lang.GoldCoin }}</i>
              </i>
              <!-- {{ item.discountPrice }}
              <i v-show="way == 'coin'">{{ lang.GoldCoin }}</i> -->
            </h4>
          </div>
        </div>
        <div class="charge-tip">
          <i v-if="item.itemName == 'VerifyLabel'" v-html="lang.verifRemark"></i>
          <i v-if="item.itemName == 'Normal' || item.itemName == 'Normal_Agent'">
            <span>{{ lang.Generallisting1 }}:</span>
            {{ lang.span }}{{ chargesApi[0].effectiveDays }}{{ lang.ri }} {{ lang.zpan }}{{ chargesApi[0].rentEffectiveDays }}{{ lang.ri }}
          </i>
          <i v-if="item.itemName == 'Star_Rent' || item.itemName == 'Star_Buy'" class="Star_i">
            <span>{{ lang.Generallisting2 }},</span>
            {{ lang.span }}{{ chargesApi[2].effectiveDays }}{{ lang.ri }} {{ lang.zpan }}{{ chargesApi[3].rentEffectiveDays }}{{ lang.ri }}
          </i>
        </div>
        <van-checkbox
          class="radio"
          :disabled="mode == 'edit' || mode == 1 || (mode == '2' && disVerify)"
          checked-color="#ee0a24"
          v-model="info.isVerify"
          :name="true"
          v-if="item.itemName == 'VerifyLabel'"
        ></van-checkbox>
      </div>
    </div>
    <!-- VR代拍提示 -->
    <div v-if="info.PropertySource == 1" class="vrTips">
      {{ lang.vrTips2 }}
    </div>
    <!-- 验证文件
    1.续期的时候不展示 !(mode == 2 && disVerify)
    2.复制的时候要展示要上传  info.isVerify
    info.isVerify && !disVerify && mode!== 'copy'
    3.修改的时候要展示验证文件入口
    4.只有免费放盘的时候才显示验证文件入口 way == 'free'
    业主 标准盘和星级盘都要求放验证文件
     -->
    <!--
       业主盘 校验条件
        (mode != 2 && info.topType.startsWith('Normal') && info.PropertySource == 1) ||
        (mode == 2 && !disVerify && info.isVerify &&  info.topType.startsWith('Normal') && info.PropertySource == 1) ||
        (mode == 2 && !disVerify && info.isVerify && info.topType.startsWith('Star')) || (mode != 2 && info.isVerify && info.topType.startsWith('Star'))
        starYeZhuverifyImages 用来判断楼盘里面有没有验证文件
 -->
    <!-- 隐藏楼盘验证增值服务 -->
    <div
      class="flexbox verif"
      @click="goVerify()"
      v-show="
        (mode != 2 && (info.topType.startsWith('Normal')) && info.PropertySource == 1 && way =='free') || 
        (mode == 2 && !disVerify && (info.topType.startsWith('Normal')) && info.PropertySource == 1 && way =='free')
      "
    >
    <!-- 无论是何状态都显示验证文件入口 -->
    <!-- v-if="info.approvalStatus !== 1 || (info.approvalStatus === 1 && mode == 'copy') || starYeZhuverifyImages" -->
      <div class="flexbox_title" ref='isVerify'>
        <h3>
        <!-- <h3 v-if="(mode != 2 && (info.topType.startsWith('Normal') || info.topType.startsWith('Star')) && info.PropertySource == 1) || (mode == 2 && !disVerify && (info.topType.startsWith('Normal') || info.topType.startsWith('Star')) && info.PropertySource == 1)"> -->
          <i style="color: #ed1818" v-if="way == 'free' || info.topType.startsWith('Star')"> * </i>
          {{ lang.upYezhufile }}
          <!-- <div class="imgTit">{{lang.imgTit}}</div> -->
        </h3>
        <van-icon name="arrow" class="i-right" :color="(mode == 2 && disV) || (mode == 'edit' && info.approvalStatus == 1) ? '#ccc' : ''" />
      </div>
      <div class="flexbox_tip">
        <span>{{lang.verifyText}}</span>
      </div>
      <div v-if="store.state.yezhuverifyImage && store.state.yezhuverifyImage.length" class="flexbox_img">
        <div class="imgView">{{lang.imgView}}</div>
        <img :src="item | imgResize('full')" width="64px" height="64px" style="border-radius: 4px;" v-for="(item, index) in store.state.yezhuverifyImage" :key="index" @click.stop="addPriceSuffixToImages(index)" />
      </div>
      <van-image-preview
        :start-position="nowIndex"
        v-model="flexbox_show"
        :images="flexbox_images"
        :showIndex=false
      >
      </van-image-preview>
    </div>
    <!-- 业主名称 -->
    <div class="ownerName" v-if="!userInfo.isPropertyAgent && info.PropertySource == 1 && way == 'free'">
      <cell v-if="!userInfo.isPropertyAgent && info.PropertySource == 1 && way == 'free'" ref="ownerName" type="owner-name" :title="lang.ownerName" :disabled="(mode == 2 && disLandlordName) || (mode == 'edit' && info.approvalStatus == 1 && disLandlordName)" :required="way == 'free' || info.topType.startsWith('Star') ? true : false" attr="ownerName" :tip="lang.ownerText"></cell>
    </div>
    <!-- 代理盘提示 -->
    <div class="remarks" v-if="info.PropertySource != 1">{{  lang.remarksText }}</div>
    <!-- 同意放盤條款 -->
    <!-- <van-cell :class="{'mt15': info.PropertySource == 1 }" style="padding-left: 15px; padding-right: 15px" @click="agree = !agree"> -->
    <van-cell style="padding-left: 15px; padding-right: 15px" @click="agree = !agree">
      <template #title>
        <span>{{ lang.Conditions[0] }}</span>
        <span @click.stop="$router.push('/help?id=4')" style="color: #3484fc">{{ lang.Conditions[1] }}</span>
      </template>
      <template #right-icon>
        <van-checkbox :name="true" checked-color="#ee0a24" v-model="agree" ref="checkboxes" class="agrcheck" />
      </template>
    </van-cell>
    <div v-if="mode === 'edit'" :class="['b-l', 'new-b-l', { hideimg: language == 'enus' || smallScreen }]">
      <span>
        {{ lang.needMoeny }}
        <span v-if="!(info.topType.startsWith('Normal') && editIsAddUserFreeProperty)">
          <i v-if="way == 'coin'">（{{ lang.Coin }}）</i>
          <i v-else-if="way == 'paypal'">（paypal）</i>
          <i v-else-if="way == 'paydollar'">（{{ lang.creditCard }}）</i>
          <i v-else>({{ lang.transfer }})</i>
        </span>
      </span>
      <div class="moeny new-moeny">
        <div v-if="info.topType.startsWith('Normal') && info.PropertySource == 1 && editIsAddUserFreeProperty">{{ lang.FreeY }}</div>
        <img src="../../assets/gold.png" alt="" v-if="language !== 'en-us' && !(info.topType.startsWith('Normal') && editIsAddUserFreeProperty)" />
        <h4 v-if="charges.length > 0 && !(info.topType.startsWith('Normal') && editIsAddUserFreeProperty)">
          <i v-show="way == 'paypal' || way == 'trans' || way == 'paydollar'">$</i>{{ disPrice }}<i v-show="way == 'coin'">{{ lang.GoldCoin }}</i>
          <!-- <i v-show="way == 'paypal' || way == 'trans'">$</i>{{ disPrice }}<i v-show="way == 'coin'">{{ lang.GoldCoin }}</i> -->
        </h4>
      </div>
    </div>
    <!-- 提交放盤 -->
    <div :class="['page_btn', { 'new-page-btn': mode === 'edit' }]">
      <div class="freeTit" v-if="info.topType == 'Normal' && info.PropertySource == 1 && mode !== 'edit' && way == 'free'">
        <img src="../../assets/free.svg" alt="" v-if="language !== 'en-us'" />
        {{ lang.FreeY }}
      </div>
      <!-- mode !== 'edit' -->
      <div v-else>
        <div v-if="mode != 'edit'" :class="['b-l', { opcity: mode == 'edit' }, { hideimg: language == 'enus' || smallScreen }]">
          <img src="../../assets/gold.png" alt="" v-if="language !== 'en-us'" />
          <div class="moeny">
            <h4 v-if="charges.length > 0">
              <i v-show="way == 'paypal' || way == 'trans' || way == 'paydollar' || way == 'alipay' || way == 'wepay'">$</i>{{ disPrice }}<i v-show="way == 'coin'">{{ lang.GoldCoin }}</i>
              <!-- <i v-show="way == 'paypal' || way == 'trans'">$</i>{{ disPrice }}<i v-show="way == 'coin'">{{ lang.GoldCoin }}</i> -->
            </h4>
            <span>
              {{ lang.needMoeny }}
              <i v-if="way == 'coin'">（{{ lang.Coin }}）</i>
              <i v-else-if="way == 'paypal'">（paypal）</i>
              <i v-else-if="way == 'paydollar'">（{{ lang.creditCard }}）</i>
              <i v-else-if="way == 'alipay'">（AlipayHK）</i>
              <i v-else-if="way == 'wepay'">（WeChat Pay HK）</i>
              <i v-else>（{{ lang.transfer }}）</i>
            </span>
          </div>
        </div>
      </div>
      <div v-if="mode !== 'edit'" class="b-r">
        <van-button type="danger" @click="validation" :disabled="!agree || disPost">{{ lang.submit }}</van-button>
      </div>
      <div v-else class="new-b-r">
        <van-button class="cancel-btn" type="default" @click="validation('cancelEdit')" v-if="mode == 'edit'">{{ lang.cancelEdit }}</van-button>
        <van-button type="danger" @click="validation" v-if="mode == 'edit'" :disabled="!agree || disPost">{{ lang.subEdit }}</van-button>
        <van-button type="danger" @click="validation" v-else :disabled="!agree || disPost">{{ lang.submit }}</van-button>
        <!-- <van-button type="default" @click="validation('cancelEdit')" v-if="mode == 'edit'" :disabled="!agree || disPost" style="margin-left: 15px;">取消更改</van-button> -->
      </div>
    </div>

    <!-- 弹出层 --- 选择租售  -->
    <div class="popType" v-if="chooseType && !showSetEmail && !showSetWord && (this.mode == 'post' || this.mode == 'copy')">
      <van-popup v-model="chooseType" :close-on-click-overlay="false">
        <div class="chType-h">
          <h4>{{ lang.chooseType }}</h4>
          <span @click="quit">{{ lang.quitChoose }}</span>
        </div>
        <div class="chType-main">
          <div class="m-sale" @click="info.rentalType = 1">
            <h4>{{ lang.saleTitle }}</h4>
            <van-radio :name="1" checked-color="#ee0a24" v-model="info.rentalType"></van-radio>
          </div>
          <div class="m-rent" @click="info.rentalType = 2">
            <h4>{{ lang.rentTitle }}</h4>
            <van-radio :name="2" checked-color="#ee0a24" v-model="info.rentalType"></van-radio>
          </div>
          <van-button type="danger" class="btn" @click="typeConfrim('close')" :disabled="info.rentalType == 0">{{ lang.confirm }} </van-button>
        </div>
      </van-popup>
    </div>
    <!-- 业主盘弹出框 -->
    <div class="yezhuType" v-if="chooseYezhu">
      <van-popup v-model="chooseYezhu" :close-on-click-overlay="false">
        <div class="yzMain">
          <div class="yzType-h">
            <h4>{{ lang.yezhuTit }}</h4>
          </div>
          <div class="yzThree" v-html="lang.yezhuCon"></div>
          <!-- <div class="yzThree">{{ lang.yezhuCon }}</div> -->
          <div @click="changeYezhu" class="yzCon">{{ lang.soonPost }}</div>
          <!-- <van-button size="large" type="danger" @click="changeYezhu" class="btn">{{ lang.soonPost }} </van-button> -->
        </div>
      </van-popup>
    </div>
    <!-- 账户禁用刊登/管理 -->
    <div class="disabledDialog" v-if="disabledDialogType">
      <van-popup v-model="disabledDialogType" :close-on-click-overlay="false">
        <div class="disabledDialogMain">
          <div class="disabledDialogThree" v-html="lang.disabledText"></div>
          <div @click="quit('disabled')" class="disabledDialogCon">{{ lang.confirm }}</div>
        </div>
      </van-popup>
    </div>
    <!-- 弹出层 --- 敏感词提示  內容不符合會員條款-->
    <van-dialog v-model="keywordShow" :confirm-button-text="lang.keyCon" class="dialogWord">
      <p class="keyWord">{{ lang.keyWords }}</p>
      <!-- <p class="mb15" v-if="url.indexOf('en-us') > -1">{{ lang.keyWords2 }}</p> -->
      <p></p>
      <p>{{ lang.cant }}</p>
    </van-dialog>
    <!-- 对话框 确认放盘  -->
    <!-- 确认放盘类型对话框  新增楼盘-->
    <van-dialog v-model="confirm" :title="lang.confrimType" show-cancel-button @cancel="disPost = false" @confirm="addEstate" :confirmButtonText="lang.confirm" :cancelButtonText="lang.cancel">
      <div class="confirmType">
        {{ lang.confrimCate }}:
        {{ info.topType == 'Normal' ? lang.listingNorl : info.topType == 'Normal_Agent' ? lang.listingNorl : lang.listingStar }}
        {{ info.isVerify && info.PropertySource !== 1 ? `、${lang.verif}` : '' }}<br />
        {{ lang.payway }}：{{
          this.info.topType.startsWith('Normal') && store.state.isAllow && this.way == 'free'
            ? lang.Coin
            : this.way == 'paypal'
            ? 'paypal'
            : this.way == 'coin'
            ? lang.Coin
            : this.way == 'paydollar'
            ? lang.creditCard
            : this.way == 'alipay'
            ? 'Alipay HK'
            : this.way == 'wepay'
            ? 'WeChat Pay HK'
            : lang.transfer
        }}<br />
        {{ lang.confrimMoeny }}：
        <!-- && !(info.topType == 'Normal' && info.PropertySource == 1) -->
        <span v-if="this.way == 'coin'">{{ disPrice }} {{ lang.GoldCoin }}</span>
        <span v-else-if="info.topType == 'Normal' && info.PropertySource == 1 && way == 'free'">0{{ lang.GoldCoin }}</span>
        <span v-else>HK${{ disPrice }}</span>
        <p>{{ lang.confrimtxt }}</p>
      </div>
    </van-dialog>
    <!-- 取消按钮弹窗 (需求砍掉暂时隐藏) -->
    <van-dialog v-model="cancelEditFlag" show-cancel-button @confirm="cancelEditConfirm" @cancel="cancelEditEven" :confirmButtonText="lang.confirm" :cancelButtonText="lang.cancel">
      <div class="cancel-title-edite">{{ lang.cancelEditTxt }}</div>
    </van-dialog>
    <!-- 楼盘失效验证提醒 -->
    <!-- <van-dialog
      v-model="verifyFailureFlag"
      show-cancel-button
      class="verify-failure"
      @confirm="verifyFailureConfirm"
      @cancel="verifyFailureCancel"
      :confirmButtonText="lang.yes"
      :cancelButtonText="lang.no"
    >
      <div class="verify-title">{{ lang.propertyVerificationtxt1 }}</div>
      <div class="verify-p2">{{ lang.propertyVerificationtxt2 }}</div>
      <div class="verify-p3">
        <p>• {{ lang.housenum1 }}</p>
        <p>• {{ lang.height1 }}</p>
        <p>• {{ lang.towerAndUnit }}</p>
      </div>
      <div class="verify-p4">{{ lang.propertyVerificationtxt3 }}</div>
    </van-dialog> -->
    <!-- 业主免费盘失效验证提醒 -->
    <van-dialog
      v-model="yezhuverifyFailureFlag"
      class="verify-failure"
      @confirm="yezhuverifyFailureConfirm"
      :confirmButtonText="lang.confirm"
    >
      <div class="verify-title">{{ lang.propertyTitle }}</div>
      <div class="verify-p2" v-html="lang.propertyContent"></div>
      <div><br></div>
      <div class="verify-p2">{{ lang.propertyContent2 }}<br/></div>
      <div><br></div>
      <div class="verify-p3">{{ lang.propertyBottom }}</div>
    </van-dialog>
    <!-- 確定提交樓盤資料弹窗 -->
    <van-dialog v-model="submitHouseInfo" show-cancel-button class="cancel-edit" @confirm="submitConfirm" @cancel="submitCancel" :confirmButtonText="lang.yes" :cancelButtonText="lang.no">
      <div class="cancel-title">{{ lang.submitHouseInfo }}</div>
    </van-dialog>
    <!-- 放盘失败弹窗 -->
    <van-dialog v-model="isSuccess" class="cancel-edit">
      <div class="cancel-title">{{lang.noSuccess}}</div>
    </van-dialog>
    <!-- 取消按钮弹窗 (需求砍掉暂时隐藏) -->
    <!-- <van-dialog v-model="cancelEditFlag" show-cancel-button class="cancel-edit" @confirm="cancelEditConfirm" @cancel="cancelEditEven" :confirmButtonText="cancelEditConfirmText" :cancelButtonText="cancelEditCancelText">
      <div class="cancel-title">你在頁面上有進行過修改，如果離開當前頁面，所做的修改會將丟失</div>
    </van-dialog> -->
  </div>
</template>

<script>
import pub from '../../../common/public';
import lang from './../../../common/language/post';
import cell from './cell';
import { Dialog, Toast, ImagePreview  } from 'vant';
import Cell from './cell.vue';
import _ from 'lodash';
export default {
  data() {
    return {
      normalCoin: null, // 业主盘折扣价 200
      normal_AgentCoin: null, // 代理盘标准价 300
      star_BuyCoin: null, // 星级盘售 1000
      star_RentCoin: null, // 星级盘租 500
      showXQ: true,
      disV: false,
      disLandlordName: false,
      renewalType: false,
      gotoData: null,
      starYeZhuverifyImages: true,
      isSuccess: false,
      approvalStatus: -1,
      editIsAddUserFreeProperty: false,
      buyList: [],
      rentList: [],
      propertys: [],
      agentShow:{
        showcompanyNameCN:false,
        showcompanyNameEN:false,
        showcompanyTel:false,
        showcompanyLicenceNumber:false,
        showagentLicenceNumber:false,
      },
      subedAgenTTime:false,//是否已经提交给过期时间(已提交过情况下禁止修改)
      agentCardExpireTime: new Date(new Date().getFullYear(), 0, 1),
      showPopup:false,
      isBocModule: true, // 银行估价模块总开关
      isShowBuildName: false,
      platimgLength: [],
      platimgLengthFlag: [],
      isEstateAddFlag: true,
      isBuildingAgeFlag: true,
      buildChecked: '1',
      isShowPage: false,
      isPc: false,
      showGuiY: false, //首页引导展示弹框
      showGuiE: false,
      showGuiS: false,
      showGuiF: false,
      showGuiW: false,
      // videos:[],
      orignprice: 0,
      orignUnpaidPrice: 0,
      orignrprice: 0,
      showSetEmail: false,
      showSetWord: false,
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
      lang,
      disPost: false, //禁止刊登。刊登后修改为true 避免重复刊登楼盘
      smallScreen: false,
      hasKeys: false, //是否含有敏感词
      keywordShow: false, //敏感词对话框提示
      agree: false, //同意放盘准则
      orderID: -1,
      way: 'free',
      confirm: false,
      mode: 'post', // post || edit || copy || 1 || 2（1代表立即付款、2代表续期）
      chooseType: false,
      chooseYezhu: false, //保证业主盘提示框出现在选择售租提示后
      disabledDialogType: false, //禁止刊登/管理楼盘
      Yezhupan: false,
      dictionary: {},
      charges: [],
      chargesApi: [],
      esateInfo: false,
      Source: false, // 与代理同步
      disVerify: false, //如果接口中是已校验 那么续期时无法修改
      isReduceUnpaid:false, //是否展示公屋未补减价盘
      isReducePaid:false ,
      rentReducePrice:false,
      showReducePrice:true,
      clearBoc:false,
      // 楼盘信息
      info: {
        propertyTag: [], //楼盘标签
        planImages: [], //平面图
        propertyNo: '',
        unitFloor: '',
        RoomNumber: 0,
        estateName: '',
        PropertySource: 0, //盘源
        topType: 'Normal', // Normal, GoldTop, Top, Star
        isVerify: false, //是否开启楼盘验证
        // isLinkParking: false, //带车位
        rentalType: 0, //1售 2租
        PropertyCategory: '',
        subCategory: [], //小分类In32
        RentLabel: [],
        estateAddress: '',
        estateAddressEN: '',
        buildingName: '',
        estateName: '', // 屋苑名称
        phaseWithCulture: '', //屋苑期数
        buildingAge: '',
        introduceCN: '',
        introduceEN: '',
        servicesCN: '',
        servicesEN: '',
        buildingNameWithCulture: '', //座数
        roomNoWithCulture: '',
        estateAddressWithCulture: '',
        isBoc: true,
        isReducePaidSalePrice:false,//减价盘
        isReduceUnPaidSalePrice:false,
        isReduceRentPrice:false,
        isVerifyArea: false,
        unPaidSalePrice: '',
        paidSalePrice: '',
        firstPaidSalePrice:'',
        firstRentPrice:'',
        firstUnPaidSalePrice:'',
      },
      // 用户信息
      userInfo: {},
      show: true,
      url: document.URL,
      codeShow: '456',
      cancelDiolog: true,
      goBckPath:'',
      editNum: 1,
      dialogHide:true,//售价存在弹出框却退出页面时候 弹出框不予展示
      // verifyFailureFlag: false, // 楼盘失效弹窗是否显示
      yezhuverifyFailureFlag: false, // 业主盘失效弹窗是否显示
      cancelEditFlag: false, // 取消修改弹窗是否显示
      submitHouseInfo: false, // 是否确定提交楼盘资料弹窗是否显示
      openVerifiFlag: false, // 验证文件按钮是否开启
      isOldData: false, // 是否为旧数据（刊登改版之前的数据）
      saveOldData:false,//是否为旧数据（刊登改版之前的数据）
      buildVisible: true,
      editYeZhuverifyImages: [],// 楼盘管理修改页面的业主盘图片
      isapprovalStatus: -1, // 是否审核通过
      image_show: false,
      image_images: [],
      flexbox_show: false, // 预览验证文件
      flexbox_images: [], // 预览验证文件添加后缀
      nowIndex: 0, // 预览图片起始
    };
  },
  created() {
    this.getIsAllowData();
    this.smallScreen = document.body.clientWidth <= 320;
    this.validation = this.debounce(this.validation, 500);
    this.addEstate = this.debounce(this.addEstate, 500);
    this.getTitle();
    /*获取字典*/
    this.pub.getDictionary().then((res) => {
      this.dictionary = res;
    });
    this.mode = this.$route.query.type || 'post';
    this.store.commit('setmode', { mode: this.mode });
    if (this.mode != 'post') {
      this.getEstate();
    } else {
      this.getUserInfo();
    }
    // 获取价格详情
    this.axios.get(this.pub.getApi().SearchPropertyPriceSet).then((res) => {
      const { data, status } = res;
      if (status == 200) {
        data.result = data.result.filter((item, index) => {
          return item.itemName != 'GoldTop';
        });
        data.result.forEach((item, index) => {
          if (item.itemName == 'VerifyLabel') {
            data.result[data.result.length] = item;
            data.result.splice(index, 1);
          }
        });
        this.charges = data.result;
        this.charges.forEach((item, index) => {
          if (item.itemName == 'Normal') {
            this.normalCoin = item.discountPrice;
          }
          if (item.itemName == 'Normal_Agent') {
            this.normal_AgentCoin = item.price;
          }
          if (item.itemName == 'Star_Buy') {
            this.star_BuyCoin = item.price;
          }
          if (item.itemName == 'Star_Rent') {
            this.star_RentCoin = item.price;
          }
        })
        this.chargesApi = data.result;
        this.typeConfrim();
      }
    });
    if (this.mode == 1) {
      this.propertyID = this.$route.query.id;
      this.searchOrder();
    }
    // (mode != 2 && info.topType.startsWith('Normal') && info.PropertySource == 1) ||
    //     (mode == 2 && !disVerify && info.isVerify && info.topType.startsWith('Normal') && info.PropertySource == 1) ||
  },
  watch: {
    $route(to, from) {
      if (from.name == 'editProDetail' && this.mode == 1) {
        this.agree = false; //* 立即付款默认false
        this.disPost = false;
      }
      if (this.$route.name == 'post') {
        // 从这几个页面过来 不做任何操作  其他页面进来要重新获取信息
        if (
          from.name == 'platimg' ||
          from.name == 'tags' ||
          from.name == 'videos' ||
          from.name == 'photos' ||
          from.name == 'searchBuilding' ||
          from.name == 'addressCheck' ||
          from.name == 'commonword' ||
          from.name == 'facilitiesAndServices' ||
          from.name == 'help' ||
          from.name != 'storedValueMoney'
        ) {
          if (from.name == 'searchBuilding') {
            if (!this.store.state.isBackFlag) {
              this.info = Object.assign(this.info, this.store.state.estateInfo);
              if (!Boolean(this.info.estateName) && Boolean(this.info.estateNameEN)) {
                this.info.estateName = this.info.estateNameEN;
              }
              this.buildChecked = '1';
              this.$store.commit('setUnitImage', []);
              this.$store.commit('setFloUrl', []);
              this.platimgLength = [];
              this.platimgLengthFlag = [];
              this.store.commit('setplatimg', { platimg: [] });
              if (this.store.state.estateBuildNum && this.store.state.estateBuildNum.length == 0) {
                this.buildVisible = false;
              } else {
                this.buildVisible = true;
              }
              this.isEstateAddFlag = Boolean(this.info.estateAddress);
              this.isBuildingAgeFlag = Boolean(this.info.buildingAge);
              this.info.isBoc = true;
            }

            // this.axios
            //   .post(this.pub.getApi().GetPropertyPlanSearchParameter, {
            //     estateId: this.store.state.estateInfo.estateID,
            //   })
            //   .then((res) => {
            //     this.codeShow = res.data.code;
            //   });

            this.axios.post(this.pub.getApi().GetStationDuration, { estateId: this.store.state.estateInfo.estateID }).then((res) => {
              this.subway = res.data.result;
              if (this.subway > 15) {
                if (this.store.state.tags.length) {
                  let k = this.store.state.tags[0].hasOwnProperty('key');
                  this.store.state.tags.forEach((ele) => {
                    if (k) {
                      if (ele.key == 23) {
                        this.store.commit('setTagsCount', this.store.state.tagcount - 1);
                      }
                    } else {
                      if (ele.propertyTagValue == 23) {
                        this.store.commit('setTagsCount', this.store.state.tagcount - 1);
                      }
                    }
                  });
                }
              }
            });
          }
          if (from.name == 'commonword') {
            // data中的数据更新了 但是页面没更新 使用$set
            if (this.$store.state.commonwordType) {
              if (from.query.id === 'title') {
                this.$set(this.info, 'titleCN', ((this.info.titleCN ? this.info.titleCN : '') + this.store.state.wordsList.join(' ')).slice(0, 30));
                this.$set(this.info, 'titleEN', ((this.info.titleEN ? this.info.titleEN : '') + this.store.state.enwordsList.join(',')).slice(0, 50));
              } else {
                // data中的数据更新了 但是页面没更新 使用$set
                this.$set(this.info, 'introduceCN', ((this.info.introduceCN ? this.info.introduceCN : '') + this.store.state.introduceWords.join(' ')).slice(0, 300));
                this.$set(this.info, 'introduceEN', ((this.info.introduceEN ? this.info.introduceEN : '') + this.store.state.enintroduceWords.join(',')).slice(0, 600));
              }
            }
          }
          if (from.name == 'facilitiesAndServices') {
            // data中的数据更新了 但是页面没更新 使用$set
            if (from.query.id === 'services') {
              this.$set(this.info, 'servicesCN', ((this.info.servicesCN ? this.info.servicesCN : '') + this.store.state.servicesList.join(' ')).slice(0, 300));
              this.$set(this.info, 'servicesEN', ((this.info.servicesEN ? this.info.servicesEN : '') + this.store.state.enserviceList.join(',')).slice(0, 600));
            } 
          }
          if (from.name == 'platimg') {
            this.platimgLength = this.store.state.platimg;
          }
        } else {
          this.store.commit('clearStore');
        }
      }
    },
  },
  mounted() {
    /*立即付款滚动到页面底部*/
    if (this.mode == 1 || this.mode == 2) {
      this.$nextTick(() => {
        setTimeout(() => {
          let el = document.querySelector('#post');
          if (el) {
            window.scroll({ top: el.offsetHeight, behavior: 'smooth' });
          }
        }, 1000);
      });
    }
    if (this.cancelDiolog) {
      // 监听浏览器的返回按钮
      if (window.history && window.history.pushState && this.$route.query.type == 'edit') {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
      }
    }
  },
  activated() {
    // this.getIsAllowData();
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcPassport}zh-cn/list-property/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcPassport}en-us/list-property/`;
      } else {
        location.href = `${pub.config.pcPassport}list-property/`;
      }
    } else {
      this.isShowPage = true;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (
      from.name == 'platimg' ||
      from.name == 'tags' ||
      from.name == 'videos' ||
      from.name == 'photos' ||
      from.name == 'searchBuilding' ||
      from.name == 'addressCheck' ||
      from.name == 'commonword' ||
      from.name == 'facilitiesAndServices' ||
      from.name == 'help' ||
      from.name != 'storedValueMoney'
    ) {
      next((vm) => {
        vm.goBckPath = from.name
        vm.cancelDiolog = false;
        if(from.name == 'editProDetail' && vm.mode == 1) {
          vm.store.commit('setPayMent', 'coin')
          vm.way = vm.$store.state.payMent
        }
      });
    }
    next();
  },
  computed: {
    isArea:{
      get(){
        return this.info.isVerifyArea ? false : true
      },
      set(newVal){
        this.info.isVerifyArea = !newVal
      }
    },
    disPrice() {
      let price = this.charges;
      if (!price.length) return;
      // if (this.info.topType == 'Normal' && this.info.PropertySource == 1) {
      //   return this.lang.FreeY;
      // }
      if (this.info.topType == 'Normal' || this.info.topType == 'Normal_Agent') {
        return price[0].discountPrice;
      }
      // if (this.info.topType == 'Normal') {
      //   return price[0].discountPrice;
      // }
      if (this.info.topType == 'Star_Buy' || this.info.topType == 'Star_Rent') {
        // 因为去掉了楼盘验证的正式服务
        // if (this.disVerify && (this.mode == 'edit' || this.mode == '2')) {
        //   return price[1].discountPrice;
        // }
        // if (this.info.isVerify) {
        //   return price[1].discountPrice + price[2].discountPrice;
        // }
        return price[1].discountPrice;
      }
    },
  },
  // 组件销毁阶段，解除监听返回按钮的事件
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
  //   getIsAllowData() {
  //   return new Promise((resolve, reject) => {
  //     this.axios.post(this.pub.getApi().GetUserFreePropertyAndCheckPublish).then((res) => {
  //       if (res.data.code === 0 && res.data.result) {
  //         let result = res.data.result;
  //         this.store.commit('setIsAllowType', result.isAllow);
  //         this.propertys = result.propertys;
  //         if (this.propertys && this.propertys.length > 0) {
  //           this.rentList = [];
  //           this.buyList = [];
  //           this.propertys.forEach(i => {
  //             if (i.rentalType === 2) {
  //               this.rentList.push(i);
  //             } else {
  //               this.buyList.push(i);
  //             }
  //           });
  //         }
  //         resolve();
  //       } else {
  //         reject(new Error('Failed to fetch data'));
  //       }
  //     }).catch(error => {
  //       reject(error);
  //     });
  //   });
  // },
    async getIsAllowData() {
      try {
        const res = await this.axios.post(this.pub.getApi().GetUserFreePropertyAndCheckPublish);
        if (res.data.code === 0 && res.data.result) {
            let result = res.data.result;
            this.store.commit('setIsAllowType', result.isAllow);
            this.propertys = result.propertys;
            if (this.propertys && this.propertys.length > 0) {
                this.rentList = [];
                this.buyList = [];
                this.propertys.forEach(i => {
                    if (i.rentalType === 2) {
                        this.rentList.push(i);
                    } else {
                        this.buyList.push(i);
                    }
                });
              }
            return Promise.resolve();
        } else {
            return Promise.reject(new Error('Failed to fetch data'));
        }
      } catch (error) {
          return Promise.reject(error);
      }
    },
    addPriceSuffixToImages(index){
      this.nowIndex = index
      this.flexbox_show = true
      this.flexbox_images = this.$store.state.yezhuverifyImage.map(item => {
        return pub.imgResize(item,'full')
      });
    },
    openPreview() {
      this.image_show = true
      this.image_images = this.language === 'en-us' ? [require('@/assets/remark_en.png')] : this.language === 'zh-cn' ?  [require('@/assets/remark_cn.png')] : [require('@/assets/remark.png')]
    },
    closePreview() {
      this.image_show = false
    },
    cancelAgenTime(){
      this.showPopup = false
      this.userInfo.agentCardExpireTime = 0;
    },
    confirmAgenTime(value){
      this.showPopup = false
      this.userInfo.agentCardExpireTime = parseInt(value.getTime() / 1000)+86399;
    },
    clearBocPro(){
      // 关闭减价盘模块
      this.clearBoc = true
      this.showReducePrice = false
      this.info.isReducePaidSalePrice = false
      this.info.isReduceRentPrice = false
      this.info.isReduceUnPaidSalePrice = false
    },
    Unit(){
      if(this.mode == 'edit'){
        let typePrice = ''
        let firstval =''
        let isShowReduce = ''
        let val= ''
        if(this.info.rentalType == 1){
          typePrice = 'paidSalePrice'
          firstval = 'firstPaidSalePrice'
          isShowReduce = 'isReducePaid'
          val ='isReducePaidSalePrice'
        }else{
          firstval = 'firstRentPrice'
          isShowReduce = 'rentReducePrice'
          val ='isReduceRentPrice'
          typePrice = 'rentPrice'
        }
        this.isShowReaduce(typePrice,firstval,isShowReduce,val)
      }
    },
    isShowReaduce(typePrice,firstval,isShowReduce,val){
      if(this.mode !== 'edit' || this.clearBoc)return;
      let price = this.info.rentalType == 1 ?this.info[typePrice]*10000:this.info[typePrice]
      let reducePirce = (price - this.info[firstval] )/this.info[firstval]
      if(-0.3< reducePirce && reducePirce<0){
        this[isShowReduce] = true
        this.info[val] = true
      }else{
        this[isShowReduce] = false
        this.info[val] = false
      }
    },
    isReducePriceAll(){
      if(this.info.rentalType == 1 ){ 
        let reduceUnPaid = (this.info.unPaidSalePrice*10000 - this.info.firstUnPaidSalePrice )/this.info.firstUnPaidSalePrice
        this.isReduceUnpaid = false 
        if((this.info.subCategory.includes('6') || this.info.subCategory.includes('7'))&& this.info.unPaidSalePrice && this.info.firstUnPaidSalePrice && -0.3< reduceUnPaid && reduceUnPaid<0){
          this.isReduceUnpaid = true 
        }
        let reducePaidPrice =(this.info.paidSalePrice*10000 - this.info.firstPaidSalePrice )/this.info.firstPaidSalePrice
        if( -0.3<reducePaidPrice && reducePaidPrice<0){
          this.isReducePaid = true
        }
      }else{
        let rentReduce = (this.info.rentPrice - this.info.firstRentPrice )/this.info.firstRentPrice
        if(-0.3<rentReduce && rentReduce <0){
          this.rentReducePrice = true
        }else{
          // 关闭租盘 模块
          this.rentReducePrice = false
        }
      }
    },
    jumpStudy() {
      window.location.href = 'https://promotion.house730.com/tutorial/';
    },
    buildCheckedEven() {
      this.buildChecked = '1';
    },
    goBack() {
      // 刊登内部页返回按钮 无须弹出修改提示
      // 从刊登内部页的浏览器返回 无须弹出取消更改提示框
      this.cancelEditFlag = this.goBckPath == 'tags' ? false :true
    },
    /**
     * 刊登楼盘提示框出现规则
     * 1.当用户初次进入刊登时,会出现刊登提示,当提示结束,会出现是否放盘租盘
     * 2.当用户是业主盘的时候 免费放盘刊登提示框会第二个出现
     */
    changeYezhu() {
      this.chooseYezhu = false;
      if (this.mode == 'post') {
        this.chooseType = true;
      }
    },
    // 取消更新按钮相关逻辑
    cancelEditConfirm() {
      this.cancelEditFlag = false;
      if (this.language === 'en-us') {
        window.location.href = `${pub.config.wapPassport}en-us/editProDetail/${this.$route.query.id}/`;
      } else if (this.language === 'zh-cn') {
        window.location.href = `${pub.config.wapPassport}zh-cn/editProDetail/${this.$route.query.id}/`;
      } else {
        window.location.href = `${pub.config.wapPassport}editProDetail/${this.$route.query.id}/`;
      }
    },
    cancelEditEven() {
      this.cancelEditFlag = false;
      // 因为只能监听一次浏览器的返回按钮，所以需要在点击取消的时候在进行一次浏览器的返回按钮监听
      if (window.history && window.history.pushState && this.$route.query.type == 'edit') {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
      }
    },

    // cancelEditConfirm() {
    //   this.cancelEditFlag = false;
    //   this.$router.back(-1);
    // },
    // cancelEditEven() {
    //   this.cancelEditFlag = false;
    //   this.disPost = false;
    // },
    // verifyFailureConfirm() {
    //   this.verifyFailureFlag = false;
    //   this.openVerifiFlag = true;
    //   this.disPost = false;
    //   this.goVerify();
    // },
    yezhuverifyFailureConfirm() {
      this.yezhuverifyFailureFlag = false;
      this.openVerifiFlag = true;
      this.disPost = false;
      this.axios.post(this.pub.getApi().UpdateProperty, this.gotoData).then((res) => {
        if (res.data.code === 0) {
          // Toast.success(lang.updateSuccess);
          setTimeout(() => {
            this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
          }, 500);
        } else {
          Toast.fail(lang.noChance);
        }
      });
      if (this.$route.query.type == 2) {
        let yezhuEditData = [];
        if ((this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star')) && this.info.PropertySource == 1) {
          yezhuEditData = this.store.state.yezhuverifyImage;
        }
        this.axios
          .post(this.pub.getApi().CreatePropertyOrder, {
            propertyId: this.$route.query.id,
            topType: this.info.topType.startsWith('Star') ? 'Star' : 'Normal',
            isVerify: this.info.isVerify,
            verifyImage: yezhuEditData,
            isAddUserFreeProperty: this.way == 'free' ? true : false,
          })
          .then((res) => {
            if (res.data.code == 0 && res.data.result) {
              this.orderID = res.data.result;
              this.showXQ = false;
              this.payway();
            } else if (res.data.code == 1208) {
              /*在有效期内最多续期三次提示*/
              Toast.setDefaultOptions({ className: 'center' });
              this.$toast(this.lang.maxRenewal);
            }
          })
          .catch((err) => {
            this.disPost = false;
            this.orderError();
          });
      }
    },
    // verifyFailureCancel() {
    //   this.submitHouseInfo = true;
    // },
    yezhuverifyFailureCancel() {
      this.submitHouseInfo = true;
    },
    submitConfirm() {
      // Toast.success(lang.updateSuccess);
      this.editEstate();
    },
    submitCancel() {
      this.submitHouseInfo = false;
      this.openVerifiFlag = true;
      this.disPost = false;
    },
    goVerify() {
      if (this.mode == 'edit') {
        this.store.commit('setverifyowner', this.editYeZhuverifyImages);
      }
      if ((this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star')) && this.info.PropertySource == 1) {
        if (this.info.approvalStatus == 1 && ((this.disV && this.mode == 2) || (this.mode == 'edit' && this.disV))) {
          return
        } else {
          this.$router.push({ name: 'addressCheck', query: { owner: 'true' } });
        }
      }
      // else {
      // this.$router.push({ name: 'addressCheck', query: { owner: 'false' } });
      // }
    },
    // 编辑时更改期数，物业地址跟着改变
    estateAddressChange(estateID) {
      this.axios
        .get(this.pub.getApi().GetEstate, {
          params: {
            estateId: estateID,
          },
        })
        .then((res) => {
          if (res.data.code == 0 && res.data.result) {
            let HouseInfo = res.data.result;
            this.$nextTick(() => {
              this.info.estateID = HouseInfo.estateID;
              this.info.estateName = HouseInfo.estateNameWithCulture;
              this.info.estateAddress = HouseInfo.detailAddressWithCulture;
              this.info.gscopeCode = HouseInfo.gscopeCode;
              this.info.buildingAge = HouseInfo.buildingAge > 0 ? HouseInfo.buildingAge : '';
              this.info.estateAddressWithCulture = this.info.estateAddress;
              this.$refs.estateAddress.estateAddressValue = this.info.estateAddress;
            });
          }
        });
    },
    shishi(type) {
      if (type == 1) {
        this.showGuiE = true;
        this.showGuiY = false;
      } else if (type == 2) {
        this.showGuiE = false;
        this.showGuiS = true;
      } else if (type == 3) {
        this.showGuiS = false;
        this.showGuiF = true;
      } else if (type == 4) {
        this.showGuiF = false;
        this.showGuiW = true;
      } else {
        this.showGuiW = false;
        this.chooseType = true;
        if (this.info.PropertySource == 1) {
          // 若为业主盘 还需展示 业主提示
          this.Yezhupan = true;
          this.chooseYezhu = true;
        } else {
          this.chooseType = true;
        }
      }
    },
    changeSwipe(type) {
      if (type == 'down') {
        // this.index += 1;
        this.$refs.swiper.next();
      }
      // this.$refs.swiper.swipeTo(this.index);
    },
    onChange() {
      console.log('xxx');
    },
    scrollTo() {
      window.scroll({ top: 2 });
    },
    // 复用提示框
    dialog(text, quit) {
      Dialog.alert({
        message: text,
        confirmButtonText: this.lang.confirm,
      }).then(() => {
        if (quit) {
          this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
        }
      });
    },
    /*判断标题是否含有敏感词--防抖 避免多次触发*/
    async sensitive(type) {
      let keywords = [this.info.titleCN, this.info.titleEN, this.info.introduceCN, this.info.introduceEN, this.info.servicesCN, this.info.servicesEN];
      if (type == 'post') {
        return this.axios.post(this.pub.getApi().GetKeyword, { keywords });
      }
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setTimeout(() => {
        this.timer = null;
        this.hasKeys = true;
        this.axios.post(this.pub.getApi().GetKeyword, { keywords }).then((res) => {
          if (res.data.code == 0) {
            if (res.data.result) {
              this.hasKeys = true; //有敏感词
              this.keywordShow = true;
            } else {
              this.hasKeys = false; //无敏感词
            }
          }
        });
      }, 500);
    },
    debounce(func, wait) {
      let timer;
      return function () {
        let context = this; // 注意 this 指向
        let args = arguments; // arguments中存着e

        if (timer) clearTimeout(timer);

        timer = setTimeout(() => {
          func.apply(this, args);
        }, wait);
      };
    },
    async validation(type) {
      this.navigationInternalGA();
      if (this.$route.query.type == 1 || this.$route.query.type == 2) {
        this.axios
          .get(this.pub.getApi().VerifyPropertyCanRenewal, {
            params: {
              propertyId: this.$route.query.id,
            },
          })
          .then((res) => {
            if (res.status == 200 && res.data.code == 0) {
              if (res.data.result) {
                // 立即付款 type = 1
                if (this.$route.query.type == 1) {
                  this.addEstate();
                } else {
                  if (this.way == 'free' && this.info.topType.startsWith('Normal') && this.info.PropertySource == 1) {
                    // 续期的时候只判断业主姓名和验证文件
                    let requireObj = {
                      isVerify: this.lang.pYezhufile,
                      ownerName: this.lang.ownerTips,
                    };
                    let errorArr = [];
                    let errorInfo = [];
                    if (this.store.state.yezhuverifyImage && this.store.state.yezhuverifyImage.length > 0 || (this.way != 'free' && this.info.topType.startsWith('Normal'))) {
                      delete requireObj.isVerify;
    
                    }
                    if (this.info.PropertySource == 2 || (this.way != 'free' && this.info.topType.startsWith('Normal'))) {
                      delete requireObj.ownerName;
                    }
                    Object.keys(requireObj).forEach((item) => {
                      if (
                        (this.info.hasOwnProperty(item) && this.info[item] && String(this.info[item]).trim() && this.info[item] != -2) ||
                        (this.userInfo.hasOwnProperty(item) && (this.userInfo[item] || this.userInfo[item] === false) && String(this.userInfo[item]).trim() && this.userInfo[item] != -2)
                      ) {
                      } else {
                        errorArr.push(item);
                      }
                    });
                    // 2 push错误信息
                    errorArr.forEach((item) => {
                      if (requireObj[item]) {
                        errorInfo.push(requireObj[item] + '\n');
                      }
                    });
                    errorInfo = [...new Set(errorInfo)];
                    // 校验通过
                    if (errorInfo.length == 0) {
                      // 付费盘续期免费盘处理
                      let data = this.dataFormat({ 
                        ...this.info,
                        propertyUserInfo: [{ ...this.userInfo }],
                        images: this.store.state.images,
                        video: this.store.state.videos,
                        landlordName: this.userInfo.ownerName,
                      });
                      let PropertyDisPlayType = 0;
                      if (this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) {
                        if (this.info.estateID == 0) {
                          PropertyDisPlayType = 1;
                        }
                        if (this.store.state.estateData && this.store.state.estateData.isCutomadded) {
                          PropertyDisPlayType = 6;
                        } else {
                          if (this.store.state.buildId.buildingType == 1) {
                            PropertyDisPlayType = Number(this.buildChecked);
                          }
                          if (this.store.state.buildId.buildingType == 2 || this.store.state.buildId.buildingType == 3 || this.store.state.buildId.buildingType == 4) {
                            PropertyDisPlayType = this.buildChecked = 5;
                          }
                        }
                      } else if (this.info.PropertyCategory == 4) {
                        PropertyDisPlayType = 7;
                      } else if (this.info.PropertyCategory == 2 || this.info.PropertyCategory == 3) {
                        PropertyDisPlayType = 1;
                      } else {
                        PropertyDisPlayType = 8;
                      }
                      delete data.estateNameWithCulture;
                      delete data.estateNameZH;
                      delete data.gscopeName;
                      delete data.gscopeNameEN;
                      delete data.gscopeNameZH;
                      delete data.phase;
                      delete data.phaseEn;
                      delete data.phaseWithCulture;
                      delete data.phaseZH;
                      delete data.zoneName;
                      delete data.zoneNameEN;
                      delete data.zoneNameWithCulture;
                      delete data.zoneNameZH;
                      data.phaseWithCulture = this.info.phaseWithCulture;
                      // 洗手间数据和房间数据根据楼盘类型单独处理
                      // 类型为土地时 没有房间数目和洗手间数目
                      if (this.info.PropertyCategory == 5 || this.info.propertyCategory == 5) {
                        delete data.toiletNumber;
                        delete data.ToiletNumber;
                        delete data.roomNumber;
                        delete data.RoomNumber;
                        delete data.planImages;
                      }
                      // 类型为车位时 没有房间数目和洗手间数目
                      if (this.info.PropertyCategory == 4 || this.info.propertyCategory == 4) {
                        delete data.toiletNumber;
                        delete data.ToiletNumber;
                        delete data.roomNumber;
                        delete data.RoomNumber;
                        delete data.planImages;
                      }
                      // 类型为店铺时 没有洗手间数目
                      if (this.info.PropertyCategory == 3 || this.info.propertyCategory == 3) {
                        delete data.toiletNumber;
                        delete data.ToiletNumber;
                        delete data.planImages;
                      }
                      // 类型为工商厦时 没有洗手间数目
                      if (this.info.PropertyCategory == 2 || this.info.propertyCategory == 2) {
                        delete data.toiletNumber;
                        delete data.ToiletNumber;
                        delete data.planImages;
                      }
                      if(this.info.subCategory.includes('6') || this.info.subCategory.includes('7')){
                        data.saleForm = 0;
                        data.salePrice = 0;
                      }
                      delete data.propertyCategoryWithCulture;
                      data['PropertyCategory'] = this.info.PropertyCategory
                      data['subCategory'] = this.info.subCategory
                      data['buildingID'] = this.store.state.buildId ? this.store.state.buildId.buildingID : 0; // 座数ID
                      data['buildingName'] =
                        this.store.state.buildId && this.store.state.buildId.buildingName ? this.store.state.buildId.buildingName : this.info.buildingNameWithCulture ? this.info.buildingNameWithCulture : ''; // 座数名称
                      data['buildingNameEN'] = this.store.state.buildId && this.store.state.buildId.buildingNameEN ? this.store.state.buildId.buildingNameEN : '';
                      data['floorName'] =
                        this.store.state.selectFloorData && this.store.state.selectFloorData.floorName ? this.store.state.selectFloorData.floorName : this.info.buildFloor ? this.info.buildFloor : ''; // 楼层
                      data['floorNameEN'] = this.store.state.selectFloorData && this.store.state.selectFloorData.floorNameEN ? this.store.state.selectFloorData.floorNameEN : '';
                      data['roomNo'] =
                        this.store.state.selectRoomNoData && this.store.state.selectRoomNoData.roomNo ? this.store.state.selectRoomNoData.roomNo : this.info.roomNoWithCulture ? this.info.roomNoWithCulture : ''; // 单位名称
                      data['roomNoEN'] = this.store.state.selectRoomNoData && this.store.state.selectRoomNoData.roomNoEN ? this.store.state.selectRoomNoData.roomNoEN : '';
                      data['propertyDisPlayType'] = PropertyDisPlayType;
                      // 续期不可修改期数所以不做处理
                      // data.estateID = this.store.state.phaseData.estateID > 0 ? this.store.state.phaseData.estateID : 0;
                      if (this.store.state.selectFloorData && this.store.state.selectFloorData.unitFloor > 0) {
                        data.unitFloor = this.store.state.selectFloorData.unitFloor;
                      } else {
                        data.unitFloor = this.store.state.unitFloorData.dictionaryValue ? this.store.state.unitFloorData.dictionaryValue : this.info.unitFloor ? this.info.unitFloor : 0;
                      }
                      data['unitFloorWithCulture'] = this.store.state.unitFloorData && Number(this.store.state.unitFloorData.dictionaryValue) > 0 ? this.store.state.unitFloorData.dictionaryNameWithCulture : 0;
                      data.buildingAge = Boolean(data.buildingAge) && data.buildingAge > 0 ? data.buildingAge : 0;
                      data['RoomNumber'] = this.store.state.roomNumberData && this.store.state.roomNumberData.dictionaryValue ? Number(this.store.state.roomNumberData.dictionaryValue) : this.info.RoomNumber;
                      data['toiletNumber'] = this.info.ToiletNumber ? this.info.ToiletNumber : 0;
                      this.editNum++;
                      data['landlordName'] = data.landlordName
                      data['verifyImage'] = data.verifyImages
                      // delete data['verifyImages']
                      data['propertyTag'] = this.store.state.propertyTags;
                      data['isAddUserFreeProperty'] = true;
                      let needVerify = ['verifyImages', 'landlordName']; // 触发楼盘验证失效的字段
                      for (let index = 0; index < needVerify.length; index++) {
                        if(!(_.isEqual(JSON.parse(JSON.stringify(JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]])), JSON.parse(JSON.stringify(data[needVerify[index]]))))) {
                          if (!JSON.parse(JSON.stringify(data[needVerify[index]])) && !JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]]) {
                            this.yezhuverifyFailureFlag = false;
                          } else {
                            this.yezhuverifyFailureFlag = true;
                            break;
                          }
                        } else {
                          this.yezhuverifyFailureFlag = false;
                        }
                      }
                      if (!this.yezhuverifyFailureFlag) {
                        this.addEstate();
                      }
                      this.gotoData = data
                    } else {
                      this.disPost = false;
                      Dialog.alert({
                        message: errorInfo.toString().replace(/,/g, ''),
                        confirmButtonText: this.lang.confirm,
                        theme: 'round-button',
                      });
                    }
                  } else {
                    this.addEstate();
                  }
                }
              } else {
                if (!this.userInfo.isAllowPublishProperty) {
                  this.disabledDialogType = true
                  return
                } else {
                  Dialog.confirm({
                    title: '',
                    message: this.$route.query.type == 1 ? lang.parNowText : lang.noRenewalText,
                    confirmButtonText: lang.keyCon,
                    cancelButtonText: lang.cancel,
                  })
                    .then(() => {})
                    .catch(() => {});
                }
              }
            }
          });
        return;
      }
      if (type === 'cancelEdit') {
        this.cancelEditFlag = true;
        return;
      }
      this.disPost = true;
      let res = await this.sensitive('post');
      if (res.data.result) {
        this.keywordShow = true;
        this.disPost = false;
        return false;
      }
      // 必填校验
      let require = this.lang.require;
      let requireObj = {
        PropertyCategory: require.propertyType /*物业类型*/,
        SubCategory: require.subcgory,
        SubCategoryPark: require.subcgoryParking,
        propertyNo: require.adspropertyNumber /*物业编号 -- 代理必填*/,
        estateName: require.estateOrBuildingName /*楼盘名称*/,
        phaseWithCulture: require.phase, // 期数
        buildingNameWithCulture: require.buildName, // 座数
        buildFloor: require.buildFloorRequire, // 楼层
        unitFloor: this.store.state.buildId && this.store.state.buildId.buildingType == 1 ? require.unitFloorRqueire1 : require.unitFloorRqueire, // 高中低层
        RoomNumber: require.starRoom,
        ToiletNumber: require.toiletNumberRqueire,
        // salePrice: require.sale /*售价*/,
        rentPrice: require.rent /*租价*/,
        platimg: require.plamtImage,
        buildingArea: require.Area,
        saleableArea: require.Area,
        unPaidSalePrice :require.MsaleForm,
        paidSalePrice:this.info.rentalType == 1 && (this.info.subCategory.includes('6') || this.info.subCategory.includes('7'))?require.MsaleForm:require.sale,
        titleCN: require.adsTitleChi,
        introduceCN: require.propertyDescriptionChi,
        servicesCN: require.facilitiesAndServicesChi,
        PropertySource: require.source,
        contactNameCN: require.Cname,
        email: require.email,
        telphone: require.tel,
        isShowTel: require.telShow,
        /*代理资料*/
        // isHideCompanyInfo: require.companyShow,
        companyNameCN: require.companyName,
        companyTel: require.companyPhone,
        companyLicenceNumber: require.companyLicense,
        agentLicenceNumber: require.personalLicense,
        agentCardPath: require.agentCardPath,
        agentCardExpireTime: require.agentCardExpireTime,
        // 星级盘规则
        // unitFloor: require.starHeight,
        titleCNstar: require.starTitCn,
        images: require.starImage,
        normalImages: require.nomalImage,
        isVerify: this.lang.pYezhufile,
        ownerName: this.lang.ownerTips,
      };
      let errorArr = [];
      let errorInfo = [];
      delete requireObj.platimg;
      if (!this.info.PropertyCategory) {
        delete requireObj.phaseWithCulture;
        delete requireObj.buildingNameWithCulture;
        delete requireObj.buildFloor;
        delete requireObj.unitFloor;
      } else {
        // 当楼盘类型为住宅
        if (this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) {
          // 只有服务式住宅的时候才效验设施与服务
          if (!this.info.subCategory.includes('19')) {
            delete requireObj.servicesCN; 
          }
          // 如果屋苑名称没有填写不校验期数座数等
          if (!this.info.estateName) {
            delete requireObj.phaseWithCulture;
            delete requireObj.buildingNameWithCulture;
            delete requireObj.unitFloor;
          }
          if (!this.store.state.buildId || this.store.state.buildId.buildingType == 2 || this.store.state.buildId.buildingType == 3 || this.store.state.buildId.buildingType == 4) {
            delete requireObj.buildFloor;
            // delete requireObj.unitFloor;
          }
          // 如果期数没有就不做校验
          if (this.info.PropertyCategory == 5 || this.store.state.estatePhase.length <= 0) {
            delete requireObj.phaseWithCulture;
          }
          // 如果座数没有联动项则为手动输入，也不做校验
          if (this.store.state.estateBuildNum.length <= 0 || !this.buildVisible) {
            delete requireObj.buildingNameWithCulture;
          }
          // isCutomadded为true代表为村屋-客製 座数不做校验
          if (this.store.state.estateData && this.store.state.estateData.isCutomadded) {
            delete requireObj.buildingNameWithCulture;
          }
          // 如果是屋苑单栋&&座数没有选择的时候，高中低不做校验
          if (this.store.state.buildingType == 1 && !this.info.buildingNameWithCulture) {
            delete requireObj.unitFloor;
          }
          // 如果没有楼层数据就不校验楼层
          if (!Boolean(this.store.state.selectFloorData)) {
            // 暂时注释这段代码用来修改刊登的时候必填框楼盘验证
            // delete requireObj.buildFloor;
          }
        }
        // 当楼盘类型为车位
        if (this.info.PropertyCategory == 4) {
          delete requireObj.platimg;
          delete requireObj.buildingNameWithCulture;
          delete requireObj.buildFloor;
          delete requireObj.unitFloor;
          delete requireObj.phaseWithCulture;
          delete requireObj.servicesCN;
        }
        // 当楼盘类型为工商厦或者店铺
        if (this.info.PropertyCategory == 2 || this.info.PropertyCategory == '3') {
          delete requireObj.phaseWithCulture;
          delete requireObj.buildingNameWithCulture;
          delete requireObj.buildFloor;
          delete requireObj.platimg;
          delete requireObj.servicesCN;
        }
        // 当楼盘类型为土地
        if (this.info.PropertyCategory == 5) {
          delete requireObj.phaseWithCulture;
          delete requireObj.buildingNameWithCulture;
          delete requireObj.buildFloor;
          delete requireObj.RoomNumber;
          delete requireObj.ToiletNumber;
          delete requireObj.unitFloor;
          delete requireObj.platimg;
          delete requireObj.servicesCN;
        }
      }
      if(this.info.PropertyCategory !='1' && this.info.PropertyCategory !='5' ||((this.info.PropertyCategory =='1' || this.info.PropertyCategory =='5')&&this.info.subCategory.length)){
        delete requireObj.SubCategory;
      }
      if(this.info.PropertyCategory !='4' ||((this.info.PropertyCategory =='4')&&this.info.subCategory.length)){
        delete requireObj.SubCategoryPark;
      }
      // 车位不用校验建筑面积和实用面积
      if (this.info.PropertyCategory == '4') {
        delete requireObj.buildingArea;
        delete requireObj.saleableArea;
        delete requireObj.servicesCN;
      }
      /*售盘校验逻辑*/
      if (this.info.rentalType == 1) {
        delete requireObj.rentPrice;
        delete requireObj.servicesCN;
        if(this.info.subCategory.includes('6') || this.info.subCategory.includes('7')){
          if (this.info.unPaidSalePrice > 0 || this.info.paidSalePrice > 0) {
            delete requireObj.paidSalePrice;
            delete requireObj.unPaidSalePrice;
          }
        }else{
          delete requireObj.unPaidSalePrice;
        }
      }
      /*租盘校验逻辑*/
      if (this.info.rentalType == 2) {
        delete requireObj.paidSalePrice;
        delete requireObj.unPaidSalePrice;
      }
      /*个人校验逻辑*/
      if (this.info.PropertySource == 1) {
        delete requireObj.propertyNo;
        // delete requireObj.isHideCompanyInfo;
        delete requireObj.companyNameCN;
        delete requireObj.companyTel;
        delete requireObj.companyLicenceNumber;
        delete requireObj.agentLicenceNumber;
        delete requireObj.agentCardPath;
        delete requireObj.agentCardExpireTime;
      }
      if (this.info.PropertySource == 2 || (this.way != 'free' && this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star'))) {
        delete requireObj.ownerName;
      }
      // 1.遍历数组
      //1.1 如果对象中含有数组项 && 不为空 "校验通过"
      //1.2 如果对象中不含数组项 ”校验不通过“
      Object.keys(requireObj).forEach((item) => {
        if (
          (this.info.hasOwnProperty(item) && this.info[item] && String(this.info[item]).trim() && this.info[item] != -2) ||
          (this.userInfo.hasOwnProperty(item) && (this.userInfo[item] || this.userInfo[item] === false) && String(this.userInfo[item]).trim() && this.userInfo[item] != -2)
        ) {
        } else {
          errorArr.push(item);
        }
      });
      /*星级盘校验*/
      if (this.info.topType.startsWith('Star')) {
        delete requireObj.normalImages;
        // 住宅1 工商厦2 车位4 店铺3 土地5
        if (this.info.PropertyCategory == '1' || this.info.PropertyCategory == '6') {
          if (this.store.state.estateInfo.estateID == 0) {
            delete requireObj.phaseWithCulture;
            delete requireObj.buildingNameWithCulture;
            delete requireObj.buildFloor;
          }
        } else if (this.info.PropertyCategory == '2') {
          delete requireObj.RoomNumber;
          delete requireObj.ToiletNumber;
        } else if (this.info.PropertyCategory == '3') {
          delete requireObj.RoomNumber;
          delete requireObj.ToiletNumber;
          delete requireObj.unitFloor;
        } else if (this.info.PropertyCategory == 4) {
          delete requireObj.ToiletNumber;
          delete requireObj.RoomNumber;
        } else if (this.info.PropertyCategory == 5) {
          delete requireObj.phaseWithCulture;
          delete requireObj.buildingNameWithCulture;
          delete requireObj.buildFloor;
          delete requireObj.RoomNumber;
          delete requireObj.ToiletNumber;
          delete requireObj.unitFloor;
        }
        delete requireObj.ToiletNumber;
        // if (this.info.unitFloor && this.info.unitFloor != -1) {
        //   delete requireObj.unitFloor;
        // } else {
        //   errorArr.push('unitFloor');
        // }
        if (this.info.RoomNumber && (this.info.RoomNumber != -2 || this.info.RoomNumber == 0)) {
          delete requireObj.RoomNumber;
        } else {
          errorArr.push('RoomNumber');
        }
        if (this.info.ToiletNumber && this.info.ToiletNumber != -2) {
          delete requireObj.ToiletNumber;
        } else {
          errorArr.push('ToiletNumber');
        }
        if (this.info.titleCN && this.info.titleCN.length >= 8) {
          delete requireObj.titleCNstar;
        } else {
          errorArr.push('titleCNstar');
        }
        if (this.store.state.images && this.store.state.images.length >= 3) {
          delete requireObj.images;
          // let type = [];
          // this.store.state.images.forEach((item) => {
          //   if (item.imageType) {
          //     type.push(item.imageType);
          //   }
          // });
          // if (new Set(type).size >= 3) {
          //   delete requireObj.images;
          //   let idx = errorArr.indexOf('images');
          //   errorArr.splice(idx, 1);
          // } else {
          //   errorArr.push('images');
          // }
        } else {
          errorArr.push('images');
        }
      } else {
        if (this.store.state.images && this.store.state.images.length >= 1) {
          delete requireObj.normalImages;
        } else {
          errorArr.push('normalImages');
        }
        if (this.store.state.estateInfo.estateID == 0) {
          delete requireObj.phaseWithCulture;
          delete requireObj.buildingNameWithCulture;
          delete requireObj.buildFloor;
          delete requireObj.unitFloor;
        }
        if ((this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) && (this.store.state.buildId.buildingType == 2 || this.store.state.buildId.buildingType == 3 || this.store.state.buildId.buildingType == 4)) {
          delete requireObj.unitFloor;
        }
        if ((this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) && this.store.state.estateData && this.store.state.estateData.isCutomadded) {
          delete requireObj.unitFloor;
        }
        if (this.info.PropertyCategory == 2 || this.info.PropertyCategory == '3') {
          delete requireObj.unitFloor;
        }
        delete requireObj.unitFloor;
        delete requireObj.ToiletNumber;
        delete requireObj.RoomNumber;
        delete requireObj.titleCNstar;
        delete requireObj.images;
      }
      // 编辑时旧数据仍生效楼盘不用强制补回必填项
      if (this.isOldData && this.$route.query.type == 'edit') {
        delete requireObj.phaseWithCulture;
        delete requireObj.buildingNameWithCulture;
        delete requireObj.buildFloor;
        delete requireObj.unitFloor;
        delete requireObj.RoomNumber;
        delete requireObj.ToiletNumber;
      }
      /*建筑面积&&实用面积校验*/
      if (this.info.buildingArea > 0 || this.info.saleableArea > 0) {
        delete requireObj.buildingArea;
        delete requireObj.saleableArea;
      }
      if (this.info.buildingArea && this.info.saleableArea) {
        if (Number(this.info.saleableArea) > Number(this.info.buildingArea)) {
          requireObj.areaTip = this.lang.require.areaTip;
          errorArr.push('areaTip');
        }
      }
      /*电邮格式判断*/
      if (this.userInfo.email && this.userInfo.email.trim()) {
        let checkEmail = /^[a-zA-Z0-9]+([\.a-zA-Z0-9_-]*)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (!checkEmail.test(this.userInfo.email.trim())) {
          requireObj.emailFormat = this.lang.require.emailFormat;
          errorArr.push('emailFormat');
        }
      }
      // 隐藏楼盘验证增值服务
      /*楼盘校验文件上传判断*/
      //* 业主盘 复制楼盘付款时弹出框出现验证文件
      if (this.info.PropertySource == 1 && (this.info.topType.startsWith('Normal') ||this.info.topType.startsWith('Star'))) {
        this.info.isVerify = false;
      }
      // 隐藏楼盘校验需求
      // // && !(this.info.PropertySource == 1 && this.info.topType.startsWith('Normal'))
      // if (this.info.isVerify && this.store.state.verifyImage.length == 0) {
      //   if ((this.disVerify && this.mode == '2') || this.mode == 'edit' || this.mode == '1') {
      //   } else {
      //     // *bugfix 业主盘付款时出现验证文件问题 (this.mode == 'copy' || this.mode == '1')
      //     if (this.info.topType.startsWith('Normal')) {
      //     } else {
      //       requireObj.isVerify = this.lang.addRequ;
      //       errorArr.push('isVerify');
      //     }
      //   }
      // }
      // 業主盤樓盤校驗文件必上傳
      if (this.store.state.yezhuverifyImage.length > 0 || (this.way != 'free' && this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star'))){
        delete requireObj.isVerify;
      }
      // if (this.info.PropertySource == 1 && this.store.state.yezhuverifyImage.length == 0 && (this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star'))) {
      //   requireObj.isVerify = this.lang.yezhuRequ;
      //   errorArr.push('isVerify');
      //   // if ((this.disVerify && this.mode == '2') || (this.approvalStatus !== 1 && this.mode == 'edit')) {
      //   //   console.log("qqq是不是进入进来了222",)
      //   // } else {
      //   // }
      // }
      // 2 push错误信息
      errorArr.forEach((item) => {
        if (requireObj[item]) {
          errorInfo.push(requireObj[item] + '\n');
        }
      });
      errorInfo = [...new Set(errorInfo)];
      if (errorInfo.length == 0) {
        // 校验通过
        if (this.mode == 'post' || this.mode == 'copy') {
          this.confirm = true;
        } else if (this.mode == '1' || this.mode == '2') {
          this.addEstate();
        } else if (this.mode == 'edit') {
          this.editEstate();
        }
      } else {
        this.disPost = false;
        Dialog.alert({
          message: errorInfo.toString().replace(/,/g, ''),
          confirmButtonText: this.lang.confirm,
          theme: 'round-button',
        }).then(() => {
          let scrollele = '';
          try {
            errorArr.forEach((item, index) => {
              if (requireObj[item]) {
                scrollele = item;
                throw new Error('End');
              }
            });
          } catch (err) {}
          if (scrollele == 'titleCNstar') {
            scrollele = 'titleCN';
          }
          if (scrollele) {
            let offsetTop;
            if (scrollele == 'phaseWithCulture' || scrollele == 'PropertyCategory') {
              offsetTop = this.$refs['PropertyCategory'].offsetTop || this.$refs['PropertyCategory'].$el.offsetTop;
            } else {
              offsetTop = this.$refs[scrollele].offsetTop || this.$refs[scrollele].$el.offsetTop;
            }

            window.scroll({ top: offsetTop });
          }
        });
        // return false;
      }
    },
    /**代理证上传*/
    onRead(file) {
      let formData = new FormData();
      formData.append('file', file.file);
      if (!file.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
        this.$notify(lang.fileError);
        return;
      }
      this.axios
        .post(this.pub.getApi().Upload, formData)
        .then((res) => {
          if (res.data.code === 0 && res.data.result) {
            this.userInfo.agentCardPath = res.data.result[0].url;
          } else {
            this.$notify(lang.picfailure);
          }
        })
        .catch((e) => {
          /**上传失败 */
          this.$notify(lang.picfailure);
        });
    },
    /*确认租售类型 价格列表过滤*/
    typeConfrim(type) {
      if (type == 'close') {
        this.chooseType = false;
      }
      // 售盘去除连家电
      if (this.info.rentalType == 1) {
        this.info.propertyTag.forEach((ele) => {
          if (ele.propertyTagValue == 24) {
            this.store.commit('setTagsCount', this.info.propertyTag.length - 1);
          }
        });
      }

      this.store.commit('setRentalType', this.info.rentalType);
      if (this.info.rentalType == 1) {
        if (this.info.topType.startsWith('Star')) {
          this.info.topType = 'Star_Buy';
        }
      }
      if (this.info.rentalType == 2) {
        if (this.info.topType.startsWith('Star')) {
          this.info.topType = 'Star_Rent';
        }
      }
      this.charges = this.chargesApi.filter((item, index) => {
        let include = true; // 默认包含所有项

        if (this.info.PropertySource == 1) {
          include = include && item.itemName != 'Normal_Agent';
        }
        if (this.info.PropertySource == 2) {
          include = include && item.itemName != 'Normal';
        }
        if (this.info.rentalType == 1) {
          include = include && item.itemName != 'Star_Rent';
        }
        if (this.info.rentalType == 2) {
          include = include && item.itemName != 'Star_Buy';
        }
        return include; // 只有当所有相关条件都为真时，才包含该项
      });
    },
    getUserInfo() {
      /*获取用户信息*/
      this.axios.get(this.pub.getApi().GetUserInfo).then((res) => {
        let { status, data } = res;
        if (status == 200) {
          let userInfo = data.result;
          if (!userInfo.email) {
            this.showSetEmail = true;
          }
          if (userInfo.isSetPassWord == false) {
            this.showSetWord = true;
          }
          this.userInfo = {
            remainderPropertyCoin: userInfo.remainderPropertyCoin,
            isPropertyAgent: userInfo.isPropertyAgent,
            userID: userInfo.userID,
            contactNameCN: userInfo.nickName,
            email: userInfo.email,
            telphone: userInfo.telephone,
            companyNameCN: userInfo.companyNameCN,
            companyNameEN: userInfo.companyNameEN,
            companyTel: userInfo.companyTelephone,
            companyAddress: userInfo.companyAddress,
            companyLicenceNumber: userInfo.companyLicense,
            agentLicenceNumber: userInfo.license,
            // isShowTel: userInfo.isShowTel,
            // isHideCompanyInfo: userInfo.isHideCompanyInfo,
            agentCardPath: userInfo.agentCardPath ? userInfo.agentCardPath : '' /*代理证图片*/,
            customerTel: '',
            agentCardExpireTime:userInfo.agentCardExpireTime && userInfo.agentCardExpireTime>0?userInfo.agentCardExpireTime:'',
            ownerName: ''
          };
          this.pageViewGA();
          for (let key in this.userInfo) {
          if (this.userInfo.hasOwnProperty(key)) {
            const showKey = 'show' + key;
            this.agentShow[showKey] = this.userInfo[key] === '' ? false : true;
          }
        }

          if(this.userInfo.agentCardExpireTime){
            this.subedAgenTTime = true
            this.agentCardExpireTime = new Date(new Date(parseInt(userInfo.agentCardExpireTime) * 1000).toLocaleDateString());
          }
          if (userInfo.isPropertyAgent) {
            this.info.PropertySource = 2;
            //如果当前用户是代理 禁止修改为业主盘
            if (!userInfo.agentCardPath) {
              this.Source = false;
            } else {
              this.Source = true;
            }
          } else {
            this.info.PropertySource = 1;
            this.Yezhupan = true;
            this.Source = false;
          }
          //  else {
          //   this.info.PropertySource = 1;
          //   this.Yezhupan = true;
          // }
          // 刊登页加引导
          if (!this.showSetEmail && !this.showSetWord) {
            this.axios.get(this.pub.getApi().GetUserGuidanceTip, { params: { tipType: 1 } }).then((res) => {
              if (res.data.result == false) {
                this.showGuiY = true;
                this.chooseType = false;
              } else {
                this.chooseType = true;
                if(!userInfo.isAllowPublishProperty) {
                  this.disabledDialogType = true
                  return
                }
                if (this.Yezhupan) {
                  this.chooseYezhu = true;
                  this.chooseType = false;
                } else {
                  this.chooseType = true;
                }
              }
            });
          }
        }
      });
    },
    getTitle() {
      if (this.mode == 'edit') {
        return lang.edittitle;
      } else if (this.mode == 'copy') {
        return lang.copytitle;
      } else if (this.$route.query.type == 1) {
        return lang.paytitle;
      } else if (this.$route.query.type == 2) {
        return lang.addSuntitle;
      } else {
        return lang.toptitle;
      }
    },
    /*页面展示时机*/
    showPage() {
      if (this.mode == 'post') {
        if (JSON.stringify(this.userInfo) != '{}' && JSON.stringify(this.dictionary) != '{}') return true;
      } else {
        if (this.esateInfo && JSON.stringify(this.dictionary) != '{}') {
          return true;
        }
      }
    },
    /*数据格式化方法*/
    dataFormat(data) {
      const typeList = {
        buildingAge: 'int',
        buildingArea: 'int',
        saleableArea: 'int',
        paidSalePrice: 'int',
        unPaidSalePrice:'int',
        rentPrice: 'int',
        unitFloor: 'int',
        RoomNumber: 'int',
        rentLabel: 'Array',
        subCategory: 'Array',
      };
      // 如果是业主盘 就删除代理人信息
      if (data.PropertySource == 1) {
        delete data.propertyUserInfo[0].companyNameCN;
        delete data.propertyUserInfo[0].companyNameEN;
        delete data.propertyUserInfo[0].companyTel;
        delete data.propertyUserInfo[0].customerTel;
        delete data.propertyUserInfo[0].companyAddress;
        delete data.propertyUserInfo[0].companyLicenceNumber;
        delete data.propertyUserInfo[0].agentLicenceNumber;
        delete data.propertyUserInfo[0].agentCardPath;
        delete data.propertyUserInfo[0].agentCardExpireTime
      }

      // 如果类型是 车位 删除 多余信息
      if (data.propertyCategory == 4) {
        delete data.buildingArea;
        delete data.saleableArea;
        if (data.rentalType == 1 || data.rentalType == 'sale') {
          delete data.unPaidSalePrice;
          delete data.isLinkParking;
        } else {
          delete data.rentLabel;
        }
      }
      // 如果是售 就删除租信息
      if (data.rentalType == 1 || data.rentalType == 'sale') {
        delete data.rentPrice;
        delete data.beginRentTime;
        delete data.rentLabel;
        delete data.servicesCN;
        delete data.servicesEN;
      }
      // 如果是租 就删除信息
      if (data.rentalType == 2 || data.rentalType == 'rent') {
        if (data.beginRentTime == 0) {
          delete data.beginRentTime;
        }
        // if (data.beginRentTime > 0) {
        //   data.beginRentTime = parseInt(data.beginRentTime / 1000);
        // }
        delete data.paidSalePrice;
        delete data.unPaidSalePrice;
        delete data.isLinkParking;
      }
      // 清空楼盘验证图片
      // if (!data.isVerify) {
      //     delete data.verifyImage;
      //     console.log(data.isVerify, 'nnnnnnnn', data);
      //   }
      // 业主盘 必填楼盘验证图片
      if ((this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star')) && this.info.PropertySource == 1) {
        data.isVerify = true;
        this.info.isVerify = true;
      } else {
        if (!data.isVerify) {
          delete data.verifyImage;
          delete data.yezhuverifyImage;
        }
      }
      // }
      // 图片处理
      if (data.images && data.images.length > 0) {
        data.images.forEach((item, index) => {
          if (item.imageDesc == '') {
            delete data.images[index].imageDesc;
          }
          if (item.imageType == '') {
            delete data.images[index].imageType;
          }
          if (index == 0) {
            data.images[index].isDefault = true;
          } else {
            data.images[index].isDefault = false;
          }
        });
      }
      // 遍历格式化楼盘信息
      for (let key in data) {
        if (key === 'similar') {
          data.PropertySimilar = data[key];
        }
        if (key === 'topType') {
          if (data[key].startsWith('Star')) {
            data[key] = 'Star';
          }
        }
        if (key === 'paidSalePrice' || key === 'unPaidSalePrice') {
          data[key] = parseInt(data[key] * 10000);
        }
        if (key === 'subCategory') {
          if (data[key] instanceof Array) {
            data[key] = data[key].map(Number);
          } else {
            data[key] = [data[key]].map(Number);
          }
        }
        if (typeList[key] === 'Array' && data[key] && key != 'subCategory') {
          data[key] = data[key].map(Number);
        }
        if (typeList[key] === 'int') {
          data[key] = Number(data[key]);
        }
        if (data[key] === '' || data[key] === -1 || data[key] === null || JSON.stringify(data[key]) === '{}' || JSON.stringify(data[key]) === '[]') {
          delete data[key];
          continue;
        }
      }

      return data;
    },
    /*刊登楼盘*/
    async addEstate() {
      this.info.titleCN = this.info.titleCN ? this.info.titleCN.replace(/(^\s*)|(\s*$)/g, '') : '';
      this.info.titleEN = this.info.titleEN ? this.info.titleEN.replace(/(^\s*)|(\s*$)/g, '') : '';
      this.info.titleWithCulture = this.info.titleWithCulture ? this.info.titleWithCulture.replace(/(^\s*)|(\s*$)/g, '') : '';
      this.info.introduceCN = this.info.introduceCN ? this.info.introduceCN.replace(/(^\s*)|(\s*$)/g, '') : '';
      this.info.introduceEN = this.info.introduceEN ? this.info.introduceEN.replace(/(^\s*)|(\s*$)/g, '') : '';
      this.info.servicesCN = this.info.servicesCN ? this.info.servicesCN.replace(/(^\s*)|(\s*$)/g, '') : '';
      this.info.servicesEN = this.info.servicesEN ? this.info.servicesEN.replace(/(^\s*)|(\s*$)/g, '') : '';
      this.info.introduceWithCulture = this.info.introduceWithCulture ? this.info.introduceWithCulture.replace(/(^\s*)|(\s*$)/g, '') : '';
      /*立即付款逻辑*/
      if (this.mode == 1) {
        this.payway();
        return;
      }
      /*续期逻辑*/
      let yezhuEditData = [];
      // if (this.info.topType.startsWith('Star')) {
      //   yezhuEditData = this.store.state.verifyImage;
      // } else 
      if ((this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star')) && this.info.PropertySource == 1) {
        yezhuEditData = this.store.state.yezhuverifyImage;
      }
      if (this.mode == 2) {
        this.axios
          .post(this.pub.getApi().CreatePropertyOrder, {
            propertyId: this.$route.query.id,
            topType: this.info.topType.startsWith('Star') ? 'Star' : 'Normal',
            isVerify: this.info.isVerify,
            verifyImage: yezhuEditData,
            isAddUserFreeProperty: this.way == 'free' ? true : false,
          })
          .then((res) => {
            if (res.data.code == 0 && res.data.result) {
              this.orderID = res.data.result;
              this.payway();
            } else if (res.data.code == 1208) {
              /*在有效期内最多续期三次提示*/
              Toast.setDefaultOptions({ className: 'center' });
              this.$toast(this.lang.maxRenewal);
            }
          })
          .catch((err) => {
            this.disPost = false;
            this.orderError();
          });

        return;
      }
      /*刊登逻辑*/
      // delete this.info.salePrice;
      this.info.saleForm = 0;
      this.info.salePrice = 0;
      delete this.info.videos;
      delete this.info.phaseWithCulture;
      if (this.store.state.videos.length !== 0) {
        if (this.store.state.videos[0].videoPath == '') {
          let temp = [];
          this.store.commit('setVideoimg', temp);
        }
      }
      if ((!this.info.subCategory.includes('6') && !this.info.subCategory.includes('7')) || this.info.rentalType == 2) {
        this.info.unPaidSalePrice = ''; 
      }
      this.info.propertyTag = this.store.state.propertyTags;
      // 平面图
      this.info.planImages = this.store.state.platimg;
      let kanyezhuEditData = [];
      // if (this.info.topType.startsWith('Star')) {
      //   kanyezhuEditData = this.store.state.verifyImage;
      // } else 
      if ((this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star')) && this.info.PropertySource == 1) {
        kanyezhuEditData = this.store.state.yezhuverifyImage;
      }
      // else if (this.info.topType.startsWith('Normal') && this.info.PropertySource == 1) {
      //   kanyezhuEditData = this.store.state.yezhuverifyImage;
      // }
      let PropertyDisPlayType = 0;
      if (this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) {
        if (this.info.estateID == 0) {
          PropertyDisPlayType = 1;
        }
        if (
          (this.store.state.estateData && this.store.state.estateData.isCutomadded) ||
          (this.store.state.estateBuildNum.length <= 0 && this.store.state.estateData && !this.store.state.estateData.isCutomadded) ||
          !this.buildVisible
        ) {
          PropertyDisPlayType = 6;
        } else {
          if (this.store.state.buildId.buildingType == 1) {
            PropertyDisPlayType = Number(this.buildChecked);
          }
          if (this.store.state.buildId.buildingType == 2 || this.store.state.buildId.buildingType == 3 || this.store.state.buildId.buildingType == 4) {
            PropertyDisPlayType = 5;
          }
        }
      } else if (this.info.PropertyCategory == 4) {
        PropertyDisPlayType = 7;
      } else if (this.info.PropertyCategory == 2 || this.info.PropertyCategory == 3) {
        PropertyDisPlayType = 1;
      } else {
        PropertyDisPlayType = 8;
      }
      if (!((this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) && this.store.state.buildId.buildingType == 1 && this.store.state.selectFloorData && this.store.state.selectFloorData.roomResponses.length > 0 && Boolean(this.info.roomNoWithCulture))) {
        this.info.isBoc = false;
      }
      if (this.info.rentalType == 2) {
        this.info.isBoc = false;
      }
      if (!this.isBocModule) {
        this.info.isBoc = false;
      }
      if((!(this.info.subCategory.includes('11') || this.info.subCategory.includes('8')) && this.info.PropertyCategory ==1) || ( this.info.PropertyCategory =='4')){
        this.info.isVerifyArea = true
      }
      if (this.info.topType.startsWith('Normal')) {
        this.info.topType = 'Normal'
      }
      let data = this.dataFormat({
        ...this.info,
        propertyUserInfo: [{ ...this.userInfo }],
        images: this.store.state.images,
        verifyImage: kanyezhuEditData,
        video: this.store.state.videos,
        isAddUserFreeProperty: this.way == 'free'? true : false,
        landlordName: this.userInfo.ownerName
      });

      if (this.$route.query.type == 'copy') {
        delete data.estateAddressWithCulture;
        delete data.estateNameWithCulture;
        delete data.estateNameZH;
        delete data.gscopeName;
        delete data.gscopeNameEN;
        delete data.gscopeNameZH;
        delete data.phase;
        delete data.phaseEn;
        delete data.phaseWithCulture;
        delete data.phaseZH;
        delete data.zoneName;
        delete data.zoneNameEN;
        delete data.zoneNameWithCulture;
        delete data.zoneNameZH;
      }
      // 洗手间数据和房间数据根据楼盘类型单独处理
      // 类型为土地时 没有房间数目和洗手间数目
      if (this.info.PropertyCategory == 5 || this.info.propertyCategory == 5) {
        delete data.toiletNumber;
        delete data.ToiletNumber;
        delete data.roomNumber;
        delete data.RoomNumber;
        delete data.planImages;
      }
      // 类型为车位时 没有房间数目和洗手间数目
      if (this.info.PropertyCategory == 4 || this.info.propertyCategory == 4) {
        delete data.toiletNumber;
        delete data.ToiletNumber;
        delete data.roomNumber;
        delete data.RoomNumber;
        delete data.planImages;
      }
      // 类型为店铺时 没有洗手间数目
      if (this.info.PropertyCategory == 3 || this.info.propertyCategory == 3) {
        delete data.toiletNumber;
        delete data.ToiletNumber;
        delete data.planImages;
      }
      // 类型为工商厦时 没有洗手间数目
      if (this.info.PropertyCategory == 2 || this.info.propertyCategory == 2) {
        delete data.toiletNumber;
        delete data.ToiletNumber;
        delete data.planImages;
      }
      if(this.info.subCategory.includes('6') || this.info.subCategory.includes('7')){
        data.saleForm = 0;
        data.salePrice = 0;
      }
      
      data.phaseWithCulture = this.info.phaseWithCulture;
      // 删除每月管理费字段
      delete data.propertyManagementFee;
      data['buildingID'] = this.store.state.buildId ? this.store.state.buildId.buildingID : 0; // 座数ID
      data['buildingName'] =
        this.store.state.buildId && this.store.state.buildId.buildingName ? this.store.state.buildId.buildingName : this.info.buildingNameWithCulture ? this.info.buildingNameWithCulture : ''; // 座数名称
      data['buildingNameEN'] = this.store.state.buildId && this.store.state.buildId.buildingNameEN ? this.store.state.buildId.buildingNameEN : '';
      data['floorName'] =
        this.store.state.selectFloorData && this.store.state.selectFloorData.floorName ? this.store.state.selectFloorData.floorName : this.info.buildFloor ? this.info.buildFloor : ''; // 楼层
      data['floorNameEN'] = this.store.state.selectFloorData && this.store.state.selectFloorData.floorNameEN ? this.store.state.selectFloorData.floorNameEN : '';
      data['roomNo'] =
        this.store.state.selectRoomNoData && this.store.state.selectRoomNoData.roomNo ? this.store.state.selectRoomNoData.roomNo : this.info.roomNoWithCulture ? this.info.roomNoWithCulture : ''; // 单位名称
      data['roomNoEN'] = this.store.state.selectRoomNoData && this.store.state.selectRoomNoData.roomNoEN ? this.store.state.selectRoomNoData.roomNoEN : '';
      data['propertyDisPlayType'] = PropertyDisPlayType;
      data.estateID = this.store.state.phaseData.estateID
        ? this.store.state.phaseData.estateID
        : this.store.state.estateData && this.store.state.estateData.estateID
        ? this.store.state.estateData.estateID
        : 0;
      data.estateName = this.store.state.estateInfo.estateName;
      data.estateNameEN = this.store.state.estateInfo.estateNameEN;
      if (this.store.state.selectFloorData && this.store.state.selectFloorData.unitFloor > 0) {
        data.unitFloor = this.store.state.selectFloorData.unitFloor;
      } else {
        data.unitFloor = this.store.state.unitFloorData.dictionaryValue ? this.store.state.unitFloorData.dictionaryValue : 0;
      }
      if (this.way != 'free' && this.mode == 'copy') {
        data['verifyImage'] = []
        data['verifyImages'] = []
        data['landlordName'] = ''
      }
      let addResult = await this.axios.post(this.pub.getApi().AddProperty, data).catch((err) => {
        this.Success = true;
        this.disPost = false;
      });
      if (addResult.data.code == 0 && addResult.data.result) {
        this.propertyID = addResult.data.result;
        this.searchOrder();
      }
      if (addResult.data.code != 0) {
        Toast.fail(lang.noChance);
      }
    },
    /*搜索订单*/
    searchOrder() {
      this.axios
        .post(this.pub.getApi().SearchOrderRecord, {
          sourceID: this.propertyID,
          sourceType: 'property',
          orderStatus: 'notPaid',
          pageIndex: 1,
          pageCount: 10,
        })
        .then((res) => {
          if (res.data.code == 0) {
            /*搜索到订单直接使用当前订单*/
            if (res.data.result.data.length) {
              this.orderID = res.data.result.data[0].orderID;
              if (this.mode == 'post' || this.mode == 'copy') {
                this.payway();
              }
              /*搜索不到订单创建订单*/
            } else {
              if (this.info.paymentStatus == 1) {
                this.dialog(this.lang.tipStatus, true);
                return;
              }
              let seayezhuEditData = [];
              // if (this.info.topType.startsWith('Star')) {
              //   seayezhuEditData = this.store.state.verifyImage;
              // } else 
              if ((this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star')) && this.info.PropertySource == 1) {
                seayezhuEditData = this.store.state.yezhuverifyImage;
              }
              // else if (this.info.topType.startsWith('Normal') && this.info.PropertySource == 1) {
              //   seayezhuEditData = this.store.state.yezhuverifyImage;
              // }
              this.axios
                .post(this.pub.getApi().CreatePropertyOrder, {
                  propertyId: this.$route.query.id,
                  topType: this.info.topType.startsWith('Star') ? 'Star' : 'Normal',
                  isVerify: this.info.isVerify,
                  verifyImage: seayezhuEditData,
                  isAddUserFreeProperty: this.way == 'free' ? true : false,
                })
                .then((res) => {
                  if (res.data.code == 0 && res.data.result) {
                    this.orderID = res.data.result;
                  } else if (res.data.code == 1208) {
                    /*在有效期内最多续期三次提示*/
                    Toast.setDefaultOptions({ className: 'center' });
                    this.$toast(this.lang.maxRenewal);
                  }
                })
                .catch((err) => {
                  // this.submit = false;
                  this.orderError();
                });
            }
          }
        });
    },
    /*付款方式判断*/
    payway() {
      if (this.way == 'paypal') {
        this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'paypal', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
      } else if (this.info.topType.startsWith('Normal') && this.info.PropertySource == 1 && this.way == 'free') {
        // 业主免费盘 刊登时候 不调用接口
        if ((this.mode == 'post' || this.mode == 'copy' || this.mode == 2 || this.mode ==1) && this.info.topType.startsWith('Normal') && this.info.PropertySource == 1 && this.way == 'free') {
          this.axios
            .post(this.pub.getApi().PropertyCoinPaymentOrder, {
              orderId: this.orderID,
            })
            .then((result) => {
              if (result.data.code === 0 && result.data.result) {
                let tips = '';
                if (this.info.topType == 3 || this.info.topType.startsWith('Star')) {
                  tips = lang.payDone + '\n' + lang.payDownStar;
                } else {
                  // tips = lang.payDone;
                  tips = lang.address11+'\n'+lang.address12+'\n'+'\n'+lang.address13+'\n'+'\n'+lang.address14;
                }
                if (this.showXQ) {
                  Dialog.confirm({
                    className:'post-yezhu-dia',
                    title: this.mode == '2' ? '' : lang.submitSuc,
                    message: this.mode == '2' ? lang.payAdd : tips,
                    messageAlign: this.mode == '2' ? '' : 'left',
                    confirmButtonText: this.lang.confirm,
                    showCancelButton	: false,
                  });
                
                  /**
                   *  message:`<div style="white-space:normal;color:red">
                    <div style="">自定义内容</div>
                    </div>`,
                    allowHtml:true,
                  */
                  // Dialog.alert({
                  //   title: lang.thanks,
                  //   message: this.mode == '2' ? lang.payAdd : tips,
                  //   messageAlign:'left',
                  //   confirmButtonText: this.lang.confirm,
                  //   cancelButtonText: this.lang.cancel,
                  // });
                  setTimeout(() => {
                    this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
                  }, 500);
                }
              }
            });
        }
      } else if (this.way == 'coin' && (this.info.PropertySource == 1 || this.info.PropertySource == 2)) {
        this.axios
          .post(this.pub.getApi().PropertyCoinPaymentOrder, {
            orderId: this.orderID,
          })
          .then((result) => {
            /*屋币不足*/
            if (result.data.code == 1707) {
              return Dialog.confirm({
                title: lang.noGold,
                message: lang.noGoldText,
                confirmButtonText: lang.addGold,
                cancelButtonText: lang.cancel,
              })
                .then(() => {
                  this.$router.push({ name: 'storedValueMoney', query: { from: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
                })
                .catch(() => {
                  this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
                });
            }
            // code17开头提示 状态不正确
            if (String(result.data.code).startsWith('17')) {
              return this.orderError();
            }
            //付款成功
            if (result.data.code === 0 && result.data.result) {
              let tips = '';
             if (this.info.topType == 3 || this.info.topType.startsWith('Star')) {
                tips = lang.payDone + '\n' + lang.payDownStar;
              } else {
                tips = lang.payDone;
              }
                Dialog.alert({
                  title: this.mode == '2' ? '' : lang.thanks,
                  message: this.mode == '2' ? lang.payAdd : tips,
                  confirmButtonText: this.lang.confirm,
                  cancelButtonText: this.lang.cancel,
                });
              setTimeout(() => {
                this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
              }, 500);
            }
          });
      } else if (this.info.PropertySource == 1 || this.info.PropertySource == 2) {
        if (this.way == 'trans') {
          this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'transfer', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
        }
        if (this.way == 'paydollar') {
          this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'paydollar', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
        }
        if (this.way == 'alipay') {
          this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'lpay', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
        }
        if (this.way == 'wepay') {
          this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'wpay', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
        }
      }
      if (this.way == 'alipay') {
        this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'lpay', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
      }
      if (this.way == 'wepay') {
        this.$router.push({ name: 'pay', query: { orderid: this.orderID, type: 'wpay', source: 'post', fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
      }
    },
    /*修改楼盘*/
    async editEstate(type) {
      delete this.info.videos;
      // delete this.info.salePrice
      this.info.saleForm = 0;
      this.info.salePrice = 0;
      if (this.store.state.videos.length !== 0) {
        if (this.store.state.videos[0].videoPath == '') {
          let temp = [];
          this.store.commit('setVideoimg', temp);
        }
      }
      if ((!this.info.subCategory.includes('6') && !this.info.subCategory.includes('7')) || this.info.rentalType == 2) {
        this.info.unPaidSalePrice = '';
      }
      this.info.propertyTag = this.store.state.propertyTags;
      this.info.planImages = this.store.state.platimg;
      if (!((this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) && this.store.state.buildId.buildingType == 1 && this.store.state.selectFloorData && this.store.state.selectFloorData.roomResponses.length > 0 && Boolean(this.info.roomNoWithCulture))) {
        this.info.isBoc = false;
      }
      if (this.info.rentalType == 2) {
        this.info.isBoc = false;
      }
      if (!this.isBocModule) {
        this.info.isBoc = false;
      }
      if((!(this.info.subCategory.includes('11') || this.info.subCategory.includes('8')) && this.info.PropertyCategory ==1  && this.info.isVerifyArea) || ( this.info.PropertyCategory =='4' && this.info.isVerifyArea)){
          this.info.isVerifyArea = true
      }
      // 这两段代码是处理修改电话选中显示WhatsApp的时候楼盘详情页正常回显WhatsApp
      delete this.userInfo.whatsApp
      delete this.userInfo.whatsAppCode
      if (this.info.topType.startsWith('Normal')) {
        this.info.topType = 'Normal'
      }
      let data = this.dataFormat({ 
        ...this.info,
        propertyUserInfo: [{ ...this.userInfo }],
        images: this.store.state.images,
        video: this.store.state.videos,
        landlordName: this.userInfo.ownerName,
      });
      let PropertyDisPlayType = 0;
      if (this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) {
        if (this.info.estateID == 0) {
          PropertyDisPlayType = 1;
        }
        if (this.store.state.estateData && this.store.state.estateData.isCutomadded) {
          PropertyDisPlayType = 6;
        } else {
          if (this.store.state.buildId.buildingType == 1) {
            PropertyDisPlayType = Number(this.buildChecked);
          }
          if (this.store.state.buildId.buildingType == 2 || this.store.state.buildId.buildingType == 3 || this.store.state.buildId.buildingType == 4) {
            PropertyDisPlayType = this.buildChecked = 5;
          }
        }
      } else if (this.info.PropertyCategory == 4) {
        PropertyDisPlayType = 7;
      } else if (this.info.PropertyCategory == 2 || this.info.PropertyCategory == 3) {
        PropertyDisPlayType = 1;
      } else {
        PropertyDisPlayType = 8;
      }
      delete data.estateNameWithCulture;
      delete data.estateNameZH;
      delete data.gscopeName;
      delete data.gscopeNameEN;
      delete data.gscopeNameZH;
      delete data.phase;
      delete data.phaseEn;
      delete data.phaseWithCulture;
      delete data.phaseZH;
      delete data.zoneName;
      delete data.zoneNameEN;
      delete data.zoneNameWithCulture;
      delete data.zoneNameZH;
      data.phaseWithCulture = this.info.phaseWithCulture;
      // 洗手间数据和房间数据根据楼盘类型单独处理
      // 类型为土地时 没有房间数目和洗手间数目
      if (this.info.PropertyCategory == 5 || this.info.propertyCategory == 5) {
        delete data.toiletNumber;
        delete data.ToiletNumber;
        delete data.roomNumber;
        delete data.RoomNumber;
        delete data.planImages;
      }
      // 类型为车位时 没有房间数目和洗手间数目
      if (this.info.PropertyCategory == 4 || this.info.propertyCategory == 4) {
        delete data.toiletNumber;
        delete data.ToiletNumber;
        delete data.roomNumber;
        delete data.RoomNumber;
        delete data.planImages;
      }
      // 类型为店铺时 没有洗手间数目
      if (this.info.PropertyCategory == 3 || this.info.propertyCategory == 3) {
        delete data.toiletNumber;
        delete data.ToiletNumber;
        delete data.planImages;
      }
      // 类型为工商厦时 没有洗手间数目
      if (this.info.PropertyCategory == 2 || this.info.propertyCategory == 2) {
        delete data.toiletNumber;
        delete data.ToiletNumber;
        delete data.planImages;
      }
      if(this.info.subCategory.includes('6') || this.info.subCategory.includes('7')){
        data.saleForm = 0;
        data.salePrice = 0;
      }
      delete data.propertyCategoryWithCulture;
      data['verifyImages'] = this.info.verifyImages
      data['PropertyCategory'] = this.info.PropertyCategory
      data['subCategory'] = this.info.subCategory
      data['buildingID'] = this.store.state.buildId ? this.store.state.buildId.buildingID : 0; // 座数ID
      data['buildingName'] =
        this.store.state.buildId && this.store.state.buildId.buildingName ? this.store.state.buildId.buildingName : this.info.buildingNameWithCulture ? this.info.buildingNameWithCulture : ''; // 座数名称
      data['buildingNameEN'] = this.store.state.buildId && this.store.state.buildId.buildingNameEN ? this.store.state.buildId.buildingNameEN : '';
      data['floorName'] =
        this.store.state.selectFloorData && this.store.state.selectFloorData.floorName ? this.store.state.selectFloorData.floorName : this.info.buildFloor ? this.info.buildFloor : ''; // 楼层
      data['floorNameEN'] = this.store.state.selectFloorData && this.store.state.selectFloorData.floorNameEN ? this.store.state.selectFloorData.floorNameEN : '';
      data['roomNo'] =
        this.store.state.selectRoomNoData && this.store.state.selectRoomNoData.roomNo ? this.store.state.selectRoomNoData.roomNo : this.info.roomNoWithCulture ? this.info.roomNoWithCulture : ''; // 单位名称
      data['roomNoEN'] = this.store.state.selectRoomNoData && this.store.state.selectRoomNoData.roomNoEN ? this.store.state.selectRoomNoData.roomNoEN : '';
      data['propertyDisPlayType'] = PropertyDisPlayType;
      data.estateID = this.store.state.phaseData.estateID > 0 ? this.store.state.phaseData.estateID : 0;
      if (this.store.state.selectFloorData && this.store.state.selectFloorData.unitFloor > 0) {
        data.unitFloor = this.store.state.selectFloorData.unitFloor;
      } else {
        data.unitFloor = this.store.state.unitFloorData.dictionaryValue ? this.store.state.unitFloorData.dictionaryValue : this.info.unitFloor ? this.info.unitFloor : 0;
      }
      data['unitFloorWithCulture'] = this.store.state.unitFloorData && Number(this.store.state.unitFloorData.dictionaryValue) > 0 ? this.store.state.unitFloorData.dictionaryNameWithCulture : 0;
      data.buildingAge = Boolean(data.buildingAge) && data.buildingAge > 0 ? data.buildingAge : 0;
      data['RoomNumber'] = this.store.state.roomNumberData && this.store.state.roomNumberData.dictionaryValue ? Number(this.store.state.roomNumberData.dictionaryValue) : this.info.RoomNumber;
      data['toiletNumber'] = this.info.ToiletNumber ? this.info.ToiletNumber : 0;
      this.editNum++;
      data['landlordName'] = data.landlordName
      // console.log("sessionStorage.getItem('infoData')",sessionStorage.getItem('infoData'))
      if (type === 'cancelEdit') {
        // 对比所有数据，看表单提交时是否有修改（需求已砍掉，注释以免后期需要加上
        // let arr = Object.keys(this.dataFormat(JSON.parse(sessionStorage.getItem('infoData'))));
        // for (let index = 0; index < arr.length; index++) {
        //   if (data[arr[index]]) {
        //     if (JSON.stringify(data[arr[index]]) === JSON.stringify(this.dataFormat(JSON.parse(sessionStorage.getItem('infoData')))[arr[index]])) {
        //       console.log('没有修改');
        //     } else {
        //       console.log(arr[index]);
        //       console.log('有修改');
        //       break;
        //     }
        //   }
        // }
      } else {
        // 业主盘盘验证失效需求，（1.只有在修改审核通过且免费刊登的业主盘时才触发;2.只有在刊登星级盘的时候勾选了楼盘验证才会触发，isVerify为true）---废弃，现在是只要是业主盘修改楼盘类型，期数，地址，单位和业主验证图片都触发，在审核通过且为免费刊登的情况下
        if (this.way == 'free' && this.info.PropertySource == 1 && this.approvalStatus == 1 && this.mode == 'edit') {
          let needVerify = ['PropertyCategory', 'subCategory', 'phaseWithCulture', 'buildingName', 'unitFloorWithCulture', 'verifyImages', 'floorName', 'roomNo', 'landlordName']; // 触发楼盘验证失效的字段
          for (let index = 0; index < needVerify.length; index++) {
            // console.log("toiletNumber",data['unitFloorWithCulture'])
            // console.log("JSON.parse(JSON.stringify(JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]])",
            // JSON.parse(
            // JSON.stringify(
            // JSON.parse(
            // sessionStorage.getItem('infoData')
            // )['unitFloorWithCulture']))
            // )
            if(!(_.isEqual(JSON.parse(JSON.stringify(JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]])), JSON.parse(JSON.stringify(data[needVerify[index]]))))) {
              if (!JSON.parse(JSON.stringify(data[needVerify[index]])) && !JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]]) {
                this.yezhuverifyFailureFlag = false;
              } else {
                this.yezhuverifyFailureFlag = true;
                break;
              }
            } else {
              this.yezhuverifyFailureFlag = false;
            }
          }
        }
        // 星级盘修改楼盘补回验证文件不需要提示弹窗
        // if (this.info.PropertySource == 1 && this.approvalStatus == 1 && this.mode == 'edit' && data.topType === 'Star') {
        //   let needVerify = ['PropertyCategory', 'subCategory', 'phaseWithCulture', 'buildingName', 'unitFloorWithCulture', 'floorName', 'roomNo']; // 触发楼盘验证失效的字段
        //   for (let index = 0; index < needVerify.length; index++) {
        //     if(!(_.isEqual(JSON.parse(JSON.stringify(JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]])), JSON.parse(JSON.stringify(data[needVerify[index]]))))) {
        //       if (!JSON.parse(JSON.stringify(data[needVerify[index]])) && !JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]]) {
        //         this.yezhuverifyFailureFlag = false;
        //       } else {
        //         this.yezhuverifyFailureFlag = true;
        //         break;
        //       }
        //     } else {
        //       this.yezhuverifyFailureFlag = false;
        //     }
        //   }
        // }
        // 楼盘验证失效需求，（1.只有在修改时，并且为星级盘才触发;2.只有在刊登星级盘的时候勾选了楼盘验证才会触发，isVerify为true）
        // if (data.isVerify) {
        //   let needVerify = ['phaseWithCulture', 'buildingName', 'unitFloor']; // 触发楼盘验证失效的字段
        //   for (let index = 0; index < needVerify.length; index++) {
        //     if (data[needVerify[index]] !== JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]]) {
        //       if (!data[needVerify[index]] && !JSON.parse(sessionStorage.getItem('infoData'))[needVerify[index]]) {
        //         this.verifyFailureFlag = false;
        //       } else {
        //         this.verifyFailureFlag = true;
        //         break;
        //       }
        //     } else {
        //       this.verifyFailureFlag = false;
        //     }
        //   }
        // }
      }
      // if (this.info.topType.startsWith('Star')) {
      //   data.verifyImage = this.store.state.verifyImage;
      // } else 
      if ((this.info.topType.startsWith('Normal') || this.info.topType.startsWith('Star')) && this.info.PropertySource == 1) {
        data.verifyImage = this.store.state.yezhuverifyImage;
      }
      if (!data.phaseWithCulture) {
        data.phase = '';
        data.phaseEn = '';
        data.phaseZH = '';
        data['phaseWithCulture'] = '';
        data.parentEstateID > 0 && data.estateID <= 0 ? (data.estateID = data.parentEstateID) : (data.estateID = data.estateID);
      }
      this.gotoData = data
      if (!this.yezhuverifyFailureFlag) {
        this.axios.post(this.pub.getApi().UpdateProperty, data).then((res) => {
          if (res.data.code === 0) {
            Toast.success(lang.updateSuccess);
            setTimeout(() => {
              this.$router.push({ name: 'editProperties', query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version } });
            }, 500);
          } else {
            Toast.fail(lang.noChance);
          }
        });
      }
    },
    /*复制 || 修改获取楼盘信息*/
    getEstate() {
      let query = this.$route.query;
      // var getTimestamp=new Date().getTime();
      // ,timeStamp: getTimestamp
      if (query.type && query.id) {
        this.way = this.$store.state.payMent
        let userInfo = this.axios.get(this.pub.getApi().GetUserInfo);
        let propertyUser = this.axios.get(this.pub.getApi().GetPropertyUserInfoFullById, { params: { propertyId: query.id } });
        let propertyInfo = this.axios.get(this.pub.getApi().GetPropertyFullById, { params: { propertyId: query.id, isCopy: query.type == 'copy' } });
        let isOldData = this.axios.get(this.pub.getApi().VerifyPropertyInfoIsOld, { params: { propertyId: query.id } });
        Promise.all([userInfo, propertyUser, propertyInfo, isOldData]).then((res) => {
          this.editYeZhuverifyImages = res[2].data.result.verifyImages
          if(this.editYeZhuverifyImages && this.editYeZhuverifyImages.length > 0) {
            this.starYeZhuverifyImages = false
          } else {
            this.starYeZhuverifyImages = true
          }
          if (this.editYeZhuverifyImages && this.editYeZhuverifyImages.length > 0) {
            this.disV = true
          }
          if (res[2].data.result.landlordName) {
            this.disLandlordName = true
          }
          if(query.type == 'copy' || query.type == 2) {
            if (this.propertys && this.propertys.length > 0 && query.type == 2) {
              this.renewalType = this.propertys.some(property => property.propertyID == query.id);
            }
            // let datalistNumber  = this.buyList.length + this.rentList.length;
            if (!this.$store.state.isAllow && this.info.PropertySource == 1) {
              this.store.commit('setPayMent', 'free')
            } else {
              if (this.renewalType) {
                this.$store.commit('setPayMent', 'free');
              } else {
                if (res[2].data.result.topType == 3) {
                  if(res[2].data.result.rentalType == 1 && res[0].data.result.remainderPropertyCoin < this.star_BuyCoin) {
                    this.store.commit('setPayMent', 'paydollar')
                  } else if (this.info.rentalType == 2 && res[0].data.result.remainderPropertyCoin < this.star_RentCoin) {
                    this.store.commit('setPayMent', 'paydollar')
                  } else {
                    this.store.commit('setPayMent', 'coin')
                  }
                } else {
                  if ((this.info.PropertySource == 1 && res[0].data.result.remainderPropertyCoin < this.normalCoin) || (this.info.PropertySource == 2 && res[0].data.result.remainderPropertyCoin < this.normal_AgentCoin)) {
                    this.store.commit('setPayMent', 'paydollar')
                  } else {
                    this.store.commit('setPayMent', 'coin')
                  }
                }
                // if(res[0].data.result.remainderPropertyCoin < 200 || (res[2].data.result.topType == 3 && res[0].data.result.remainderPropertyCoin < 500)) {
                //   this.store.commit('setPayMent', 'paydollar')
                //   console.log("999",this.$store.state.payMent)
                //   console.log("999222",this.$store.state)
                // } else this.store.commit('setPayMent', 'coin')
              }
            }
          } else {
            if (res[2].data.result.isAddUserFreeProperty && this.mode == 'edit') {
              this.store.commit('setPayMent', 'free') 
            } else {
              if (res[2].data.result.topType == 3) {
                  if(res[2].data.result.rentalType == 1 && res[0].data.result.remainderPropertyCoin < this.star_BuyCoin) {
                    this.store.commit('setPayMent', 'paydollar')
                  } else if (this.info.rentalType == 2 && res[0].data.result.remainderPropertyCoin < this.star_RentCoin) {
                    this.store.commit('setPayMent', 'paydollar')
                  } else {
                    this.store.commit('setPayMent', 'coin')
                  }
                } else {
                  if ((this.info.PropertySource == 1 && res[0].data.result.remainderPropertyCoin < this.normalCoin) || (this.info.PropertySource == 2 && res[0].data.result.remainderPropertyCoin < this.normal_AgentCoin)) {
                    this.store.commit('setPayMent', 'paydollar')
                  } else {
                    this.store.commit('setPayMent', 'coin')
                  }
                }
              // if(res[0].data.result.remainderPropertyCoin < 200 || (res[2].data.result.topType == 3 && res[0].data.result.remainderPropertyCoin < 500)) {
              //   this.store.commit('setPayMent', 'paydollar')
              // } else this.store.commit('setPayMent', 'coin')
            }
          }
          this.store.commit("setverifyowner", this.editYeZhuverifyImages)
          // this.$store.state.yezhuverifyImage = this.editYeZhuverifyImages
          this.isapprovalStatus = res[2].data.result.approvalStatus
          this.isReduceUnpaid_show = Object.keys(res[2].data.result.subCategory)
          this.isReduceUnpaid_phase = res[2].data.result.phaseWithCulture
          this.editIsAddUserFreeProperty = res[2].data.result.isAddUserFreeProperty
          this.approvalStatus = res[2].data.result.approvalStatus
          /*获取用户注册信息*/
          let userInfo = res[0].data.result;
          this.userInfo = {
            remainderPropertyCoin: userInfo.remainderPropertyCoin,
            isPropertyAgent: userInfo.isPropertyAgent,
            userID: userInfo.userID,
            contactNameCN: userInfo.nickName,
            email: userInfo.email,
            telphone: userInfo.telephone,
            companyNameCN: userInfo.companyNameCN,
            companyNameEN: userInfo.companyNameEN,
            companyTel: userInfo.companyTelephone,
            companyAddress: userInfo.companyAddress,
            companyLicenceNumber: userInfo.companyLicense,
            agentLicenceNumber: userInfo.license,
            agentCardPath: userInfo.agentCardPath ? userInfo.agentCardPath : '' /*代理证图片*/,
            agentCardExpireTime: userInfo.agentCardExpireTime && userInfo.agentCardExpireTime>0 ? userInfo.agentCardExpireTime : '' ,
            customerTel: '',
            ownerName: res[2].data.result.landlordName,
            isAllowPublishProperty: userInfo.isAllowPublishProperty,
          };
          for (let key in this.userInfo) {
            if (this.userInfo.hasOwnProperty(key)) {
              const showKey = 'show' + key;
              this.agentShow[showKey] = this.userInfo[key] === '' ? false : true;
            }
          }
          if(this.userInfo.agentCardExpireTime){
            this.subedAgenTTime = true
            this.agentCardExpireTime = new Date(new Date(parseInt(userInfo.agentCardExpireTime) * 1000).toLocaleDateString());
          }
          if (userInfo.isPropertyAgent) {
            this.info.PropertySource = 2;
            if (!userInfo.agentCardPath) {
              this.Source = false;
            } else {
              this.Source = true;
            }
          } else {
            this.info.PropertySource = 1;
            if (this.mode == 'edit' && !userInfo.isAllowPublishProperty) {
              this.disabledDialogType = true
            }
            if (this.mode == 'copy' && res[2].data.result.topType == 0) {
              if(!userInfo.isAllowPublishProperty) {
                this.disabledDialogType = true
                this.chooseYezhu = false;
                // return
              } else {
                this.chooseYezhu = true;
              }
              this.Yezhupan = true;
              this.Source = false;
            }
          }
          var isProperrty = {};
          // puserinfo 获取的是刊登楼盘时填写的个人信息  this.userinfo 是获取注册时用户信息
          // 用户如果是从业主盘变更为代理盘   代理盘规则：复制+修改 ==>代理    付款+续期==>业主
          let puserInfo = res[1].data.result[0];
          if ((this.mode == 'edit' || this.mode == 'copy') && this.userInfo.isPropertyAgent) {
            isProperrty = { propertySource: 2 };
          }
          this.axios
            .get(this.pub.getApi().SearchDictionaryInfo, {
              params: {
                itemName: 'unitFloor',
              },
            })
            .then((res) => {
              if (res.data.code == 0 && res.data.result) {
                res.data.result.forEach((item) => {
                  if (item.dictionaryNameWithCulture == this.info.unitFloorWithCulture) {
                    this.store.commit('setUnitFloorData', item);
                  }
                });
              }
            });
          this.userInfo = Object.assign(this.userInfo, puserInfo);
          this.info = Object.assign(res[2].data.result, isProperrty);
          if (!Boolean(this.info.roomNoWithCulture) && !this.info.isBoc && this.info.propertyCategory == 1 && this.info.buildingType == 1) {
            this.info.isBoc = true;
          }
          if (this.info.rentalType == 2) {
            this.info.isBoc = false;
          }
          this.isOldData = res[3].data.result;
          this.saveOldData = res[3].data.result;
          if (this.isOldData && this.$route.query.type == 'copy') {
            this.info.buildingName = '';
            this.info.buildingNameEN = '';
            this.info.buildingNameWithCulture = '';
          }
          this.dictionary['ToiletNumber'].children.forEach((item) => {
            if (item.itemName == this.info.toiletNumber) {
              this.store.commit('setToiletNumberData', item);
              this.store.commit('setToiletNumberText', item.dictionaryNameWithCulture);
              this.info.ToiletNumber = this.info.toiletNumber;
            }
          });
          this.dictionary['RoomNumber'].children.forEach((item) => {
            if (item.itemName == this.info.roomNumber) {
              this.store.commit('setRoomNumberData', item);
              this.store.commit('setRoomNumberText', item.dictionaryNameWithCulture);
              this.info.roomNumber = this.info.roomNumber;
            }
          });
          this.store.commit('setCategoryType', this.info.propertyCategory);
          this.info.unitFloor = Boolean(this.info.unitFloorWithCulture) ? this.info.unitFloorWithCulture : '';
          if (this.info.buildingArea == 0) {
            this.info.buildingArea = '';
          }
          if (this.info.saleableArea == 0) {
            this.info.saleableArea = '';
          }
          this.info.estateName = this.info.estateNameWithCulture
            ? this.info.estateNameWithCulture
            : this.language == 'en-us'
            ? this.info.estateNameEN
            : this.info.estateName
            ? this.info.estateName
            : this.info.estateNameEN;
          this.info.estateAddress = this.info.estateAddressWithCulture;
          this.store.commit('setUnitFloorSelctText', this.info.unitFloor);
          // this.store.state.UnitFloorText = this.info.unitFloorWithCulture;
          this.info.buildingAge = this.info.buildingAge > 0 ? this.info.buildingAge : '';
          this.isBuildingAgeFlag = Boolean(this.info.buildingAge);
          this.store.commit('setUnitFloorData', { dictionaryNameWithCulture: this.info.unitFloorWithCulture, dictionaryValue: this.info.unitFloor + '', itemName: this.info.unitFloor + '' });

          // 编辑时获取期数等信息
          this.axios
            .get(this.pub.getApi().GetPhasesAndBuildingForPublish, {
              params: {
                estateId: this.info.parentEstateID != 0 ? this.info.parentEstateID : this.info.estateID,
                categoryId: this.info.propertyCategory ? this.info.propertyCategory : '',
              },
            })
            .then((res) => {
              if (res.data.code == 0 && res.data.result) {
                if (this.info.PropertyCategory == 1 || this.info.PropertyCategory == 2 || this.info.PropertyCategory == 6) {
                  if (res.data.result.buildingResponses && res.data.result.buildingResponses.length > 0) {
                    if (this.info.buildingID <= 0) {
                      // this.info.buildingNameWithCulture = this.info.buildingNameWithCulture;
                      this.store.commit('setBuildSelectText', this.info.buildingNameWithCulture);
                    } else {
                      res.data.result.buildingResponses.forEach((data) => {
                        if (data.buildingID == this.info.buildingID) {
                          this.info.buildingNameWithCulture = data.phaseAndBuildingNameWithCulture;
                          this.store.commit('setBuildSelectId', data);
                          this.store.commit('setBuildSelectText', data.phaseAndBuildingNameWithCulture);
                        }
                      });
                      let buildingNameByphase = res.data.result.buildingResponses.filter((item) => {
                        return item.estateID == this.info.estateID;
                      });
                      this.store.commit('setBuildNumByPhase', buildingNameByphase);
                    }
                  } else {
                    this.info.buildingNameWithCulture = this.info.buildingNameWithCulture;
                    this.store.commit('setBuildSelectText', this.info.buildingNameWithCulture);
                    if (this.info.propertyCategory == 1 || this.info.PropertyCategory == 1 || this.info.PropertyCategory == 6) {
                      this.buildVisible = false;
                    }
                  }
                } else {
                  this.store.commit('setBuildSelectText', this.info.buildingNameWithCulture);
                }
                if (res.data.result.estatePhases && res.data.result.estatePhases.length > 0) {
                  res.data.result.estatePhases.forEach((data) => {
                    if (data.estateID == this.info.estateID) {
                      this.store.commit('setPhaseData', data);
                    }
                  });
                }

                this.store.commit('setPhase', res.data.result.estatePhases);
                this.store.commit('setBuildNum', res.data.result.buildingResponses);
                this.store.commit('setEstateData', res.data.result.estate);
              } else {
                this.store.commit('setBuildSelectText', this.info.buildingNameWithCulture);
              }
            });
          this.store.commit('setPhaseSelectText', this.info.phaseWithCulture);
          this.store.commit('setFloorSelectText', this.info.floorNameWithCulture);
          this.store.commit('setroomNoWithCulture', this.info.roomNoWithCulture);

          // 获取楼层信息
          this.axios
            .get(this.pub.getApi().GetBuildingFloorPublish, {
              params: {
                buildingId: this.info.buildingID,
              },
            })
            .then((res) => {
              if (res.data.code == 0 && res.data.result) {
                this.store.commit('setFloorData', { title: this.lang.height1, children: res.data.result });
                res.data.result &&
                  res.data.result.length > 0 &&
                  res.data.result.forEach((res) => {
                    if (res.floorName == this.info.floorName) {
                      this.info.buildFloor = res.floorNameWithCulture;
                      this.store.commit('setFloorSelectText', res.floorNameWithCulture);
                      this.store.commit('setSelectFloorData', res);
                    }
                  });
              }
            });
          this.store.commit('setSelectRoomNoData', { roomNo: this.info.roomNo, roomNoEN: this.info.roomNoEN, roomNoWithCulture: this.info.roomNoWithCulture });
          this.buildChecked = this.info.propertyDisPlayType + '';
          if(this.info.PropertySource != 1){
            this.info.isVerify = false
          }
          this.disVerify = this.info.isVerify;
          // 获取平面图信息
          let sAttr = ['propertyCategory', 'roomNumber', 'rentLabel', 'propertySource', 'saleForm'];
          for (let key in this.info) {
            if (sAttr.includes(key)) {
              let sKey = key.charAt(0).toUpperCase() + key.slice(1);
              this.info[sKey] = this.info[key];
              delete this.info[key];
            }
            if (key === 'images') {
              if (this.info[key] && this.info[key].length) {
                this.info[key].forEach((item, index) => {
                  this.info[key][index].imageType = String(item.imageType);
                });
                this.store.commit('setImages', this.info[key]);
              }
            }
            if (key === 'videos') {
              if (this.info[key] && this.info[key].length) {
                this.store.commit('setVideoimg', this.info[key]);
              }
            }
            if (key === 'propertyTag') {
              // let arrs = Object.keys(this.info[key]);
              this.store.commit('setTagsCount', this.info[key].length);
              if (this.info[key] && this.info[key].length) {
                let arrtag = [];
                for (let i = 0; i < this.info[key].length; i++) {
                  arrtag.push(this.info[key][i].propertyTagValue);
                }
                this.store.commit('setTagsConfig', { propertyTags: arrtag });
                this.store.commit('setTags', this.info[key]);
              }
            }
            // 平面图
            if (key === 'planImages') {
              this.axios
                .post(this.pub.getApi().SearchPropertyPlanImage, {
                  estateID: this.info.parentEstateID,
                  buildingId: this.info.buildingID,
                  phaseEstateId: this.info.estateID,
                  floorName: this.store.state.floorText,
                  roomNo: this.store.state.roomNoWithCulture,
                  pageCount: 1,
                  pageIndex: 1,
                  imageType: 101,
                })
                .then((res) => {
                  if (res.data.code == 0 && res.data.result.data.length > 0) {
                    this.$store.commit('setUnitImage', res.data.result.data);
                    this.platimgLengthFlag.push(res.data.result.data[0]);
                  }
                });
              this.axios
                .post(this.pub.getApi().SearchPropertyPlanImage, {
                  estateID: this.info.parentEstateID,
                  buildingId: this.info.buildingID,
                  phaseEstateId: this.info.estateID,
                  floorName: this.store.state.floorText,
                  roomNo: this.store.state.roomNoWithCulture,
                  pageCount: 1,
                  pageIndex: 1,
                  imageType: 100,
                })
                .then((res) => {
                  if (res.data.code == 0 && res.data.result.data.length > 0) {
                    this.$store.commit('setFloUrl', res.data.result.data);
                    this.platimgLengthFlag.push(res.data.result.data[0]);
                  }
                });
              if (this.info[key].length > 0) {
                this.store.commit('setplatimg', { platimg: this.info[key] });
                this.info[key].forEach((item, index) => {
                  if (item.imageType == 100) {
                    this.$store.commit('setFloUrl', [item]);
                  }
                  if (item.imageType == 101) {
                    this.$store.commit('setUnitImage', [item]);
                  }
                });
              }
            }
            if (key === 'paidSalePrice' || key === 'unPaidSalePrice') {
              this.info[key] = parseInt(this.info[key] / 10000);
              this.orignprice = this.info['paidSalePrice'];
              this.orignUnpaidPrice = this.info['unPaidSalePrice'] ? this.info['unPaidSalePrice'] :0
            }
            if (key === 'rentPrice') {
              this.orignrprice = this.info[key];
            }
            // 楼盘类型处理
            if (key === 'subCategory') {
              if (JSON.stringify(this.info[key]) == '{}') {
                this.info[key] = [];
              } else {
                this.info[key] = Object.keys(this.info[key]);
                // if (this.info[key].length > 1 && this.info.PropertyCategory != '5') {
                //   this.info[key].splice(0, 1);
                // }
                // if (this.info.PropertyCategory == '1') {
                //   this.info[key] = this.info[key][0];
                // }
              }
            }
            if (key === 'topType') {
              if (this.info[key] == 3) {
                if (this.info.rentalType == 1) {
                  this.info[key] = 'Star_Buy';
                }
                if (this.info.rentalType == 2) {
                  this.info[key] = 'Star_Rent';
                }
              }
              if (this.info[key] == 0 || this.info[key] == 1) {
                this.info[key] = 'Normal';
              }
            }
            if (key === 'estateAddressWithCulture') {
              this.info.estateAddress = this.info[key];
              if (this.$refs.estateAddress) {
                this.$refs.estateAddress.estateAddressValue = this.info.estateAddress;
              }
            }
          }
          // 楼盘标签需修改时的楼盘类型和租售类型
          this.store.commit('setEditCate', { editPropertyCategory: this.info['PropertyCategory'] });
          this.store.commit('setCategory', { warpData: this.info['PropertyCategory'] });
          this.store.commit('setsaleableArea', { saleableArea: this.info['saleableArea'] });
          this.esateInfo = true;
          this.info.RentLabel = Object.keys(this.info.RentLabel);
          this.typeConfrim();
          this.axios
            .get(this.pub.getApi().GetEstate, {
              params: {
                estateId: this.info.parentEstateID ? this.info.parentEstateID : this.info.estateID,
              },
            })
            .then((res) => {
              if (res.data.code == 0 && res.data.result) {
                this.info['estateType'] = res.data.result && res.data.result.estateType ? res.data.result.estateType : '';
                this.info.parentEstateID = res.data.result.parentEstateID > 0 ? res.data.result.parentEstateID : res.data.result.estateID;
                this.store.commit('setEstate', {
                  buildingAge: this.info.buildingAge > 0 ? this.info.buildingAge : '',
                  estateID: this.info.estateID || 0,
                  parentEstateID: this.info.parentEstateID || 0,
                  parentID: this.info.parentID || 0,
                  gscopeCode: this.info.gscopeCode, //板块id
                  estateName: this.info.estateName, // 屋苑名称
                  estateNameEN: this.info.estateNameEN, // 屋苑名称英文
                  gscopeCodeText: this.info.zoneNameWithCulture,
                  gscopeNameWithCulture: this.info.gscopeNameWithCulture,
                  estateType: this.info.estateType,
                });
              }
            });
          this.store.commit('setEstate', {
            buildingAge: this.info.buildingAge > 0 ? this.info.buildingAge : '',
            estateID: this.info.estateID || 0,
            parentEstateID: this.info.parentEstateID || 0,
            parentID: this.info.parentID || 0,
            gscopeCode: this.info.gscopeCode, //板块id
            estateName: this.info.estateName, // 屋苑名称
            estateNameEN: this.info.estateNameEN, // 屋苑名称英文
            gscopeCodeText: this.info.zoneNameWithCulture,
            gscopeNameWithCulture: this.info.gscopeNameWithCulture,
            estateType: this.info.estateType,
          });
          // 在刊登楼盘页面调用GetPropertyFullById接口时copy一份数据存储在store，用于在取消修改时做数据对比
          // console.log({...res[2].data.result});
          // this.store.commit('setInfoData', {...res[2].data.result, ...isProperrty});
          // // sessionStorage.setItem('infoData', )
          sessionStorage.setItem('infoData', JSON.stringify(this.info));
          if(this.mode == 'edit'){
            this.isReducePriceAll()
          }else{
            this.info.isReducePaidSalePrice = false
            this.info.isReduceRentPrice = false
            this.info.isReduceUnPaidSalePrice = false
          }
          
        });
      }
    },
    handleUpdateWay (atm) {
      this.way = this.$store.state.payMent
      this.way = atm.way;
      if (atm.PropertySource === 2 && !this.info.topType.startsWith('Star')) {
        this.info.topType = 'Normal_Agent'
      }
    },
    // 获取子组件数据
    getSelect(attr, data) {
      if (attr == 'buildingNameWithCulture') {
        this.info.isBoc = true;
        this.buildChecked = '1';
        this.$store.commit('setUnitImage', []);
        this.$store.commit('setFloUrl', []);
        this.platimgLength = [];
        this.platimgLengthFlag = [];
        this.store.commit('setplatimg', { platimg: [] });
        let buildingId = this.$store.state.buildId.buildingID;
        this.info.buildingNameWithCulture = this.store.state.buildText;
        // if(this.info.buildingNameWithCulture){
        //   this.isOldData = false;
        // }
        // 老数据且不存在座数时-不需要校验必填  输入座数后校验必填
        this.isOldData = this.saveOldData && !this.info.buildingNameWithCulture ?true : false
        this.info.buildingAge =
          this.store.state.buildId.buildingAge > 0
            ? this.store.state.buildId.buildingAge
            : this.store.state.phaseData && this.store.state.phaseData.buildingAge > 0
            ? this.store.state.phaseData.buildingAge
            : this.store.state.estateData && this.store.state.estateData.buildingAge > 0
            ? this.store.state.estateData.buildingAge
            : '';
        // 当座数清空的时候楼盘地址为期数地址 期数地址没有则为屋苑地址  座数清空楼龄则为期数楼龄，期数没有则为屋苑楼龄
        if (!Boolean(this.store.state.buildText)) {
          if (this.store.state.phaseData && JSON.stringify(this.store.state.phaseData) != '{}') {
            this.info.estateAddress = this.store.state.phaseData.detailAddressWithCulture;
            this.$refs.estateAddress.estateAddressValue = this.store.state.phaseData.detailAddressWithCulture;
          } else {
            this.info.estateAddress = this.store.state.estateData && this.store.state.estateData.detailAddressWithCulture;
            this.$refs.estateAddress.estateAddressValue = this.store.state.estateData && this.store.state.estateData.detailAddressWithCulture;
          }
          if (this.info.estateID > 0) {
            if (this.store.state.phaseData && this.store.state.phaseData.buildingAge > 0) {
              this.info.buildingAge = this.store.state.phaseData.buildingAge;
            } else {
              this.info.buildingAge = this.store.state.estateData && this.store.state.estateData.buildingAge > 0 ? this.store.state.estateData.buildingAge : '';
            }
          }
        } else {
          this.$refs.estateAddress.estateAddressValue = this.info.estateAddress;
        }

        this.axios
          .get(this.pub.getApi().GetBuildingFloorPublish, {
            params: {
              buildingId,
            },
          })
          .then((res) => {
            if (res.data.code == 0 && res.data.result) {
              this.store.commit('setFloorData', { title: this.lang.height1, children: res.data.result });
              if (res.data.result.length == 1) {
                this.store.commit('setFloorSelectText', res.data.result[0].floorNameWithCulture);
                this.store.commit('setSelectFloorData', res.data.result[0]);
                this.info.buildFloor = this.store.state.floorText;
                if (res.data.result[0].unitFloor > 0) {
                  this.info.unitFloor = res.data.result[0].unitFloorWithCulture;
                  this.store.commit('setUnitFloorSelctText', res.data.result[0].unitFloorWithCulture);
                }
              }
            }
          });
        // this.isEstateAddFlag = false;

        this.isEstateAddFlag = Boolean(this.info.estateAddress);
        this.isBuildingAgeFlag = Boolean(this.info.buildingAge);
      } else if (attr == 'phaseWithCulture') {
        this.info.isBoc = true;
        this.buildChecked = '1';
        this.$store.commit('setUnitImage', []);
        this.$store.commit('setFloUrl', []);
        this.platimgLength = [];
        this.platimgLengthFlag = [];
        this.store.commit('setplatimg', { platimg: [] });
        if (!Boolean(this.store.state.phaseText)) {
          if (this.info.estateID > 0) {
            this.info.buildingAge = this.store.state.estateData && this.store.state.estateData.buildingAge > 0 ? this.store.state.estateData.buildingAge : '';
            this.info.estateAddress = this.store.state.estateData && this.store.state.estateData.detailAddressWithCulture;
            this.$refs.estateAddress.estateAddressValue = this.store.state.estateData && this.store.state.estateData.detailAddressWithCulture;
          }
        }
        this.isEstateAddFlag = Boolean(this.info.estateAddress);
        this.isBuildingAgeFlag = Boolean(this.info.buildingAge);
        if (this.store.state.phaseText !== this.isReduceUnpaid_phase) {
          this.clearBocPro()
        }
      } else if (attr == 'PropertyCategory') {
        this.info.isBoc = true;
        // 刊登的时候切换楼盘类型的时候清空楼盘地址 || (this.$route.query.type && this.$route.query.type == 'copy')
        const { isAllow } = this.$store.state;
        const { PropertySource, topType } = this.info;
        const { remainderPropertyCoin } = this.userInfo;
        const isStarBuy = topType === 'Star_Buy';
        const isStarRent = topType === 'Star_Rent';
        const isShopOrCommercial = data.warpData == '2' || data.warpData == '3';
        // 判断是否需要使用金币支付
        const needPayDollar = () => {
          if(isStarBuy && remainderPropertyCoin < this.star_BuyCoin) return true;
          if(isStarRent && remainderPropertyCoin < this.star_RentCoin) return true;
          if(PropertySource == 1 && remainderPropertyCoin < this.normalCoin) return true;
          if(PropertySource == 2 && remainderPropertyCoin < this.normal_AgentCoin) return true;
          return false;
        }
        if (!this.$route.query.type) {
          this.isEstateAddFlag = false;
          this.isBuildingAgeFlag = false;
          if (this.info.PropertyCategory && data.warpData && this.info.PropertyCategory != data.warpData) {
            this.info.estateID = 0;
          } 
          this.buildChecked = '1';
          this.$store.commit('setUnitImage', []);
          this.$store.commit('setFloUrl', []);
          this.platimgLength = [];
          this.platimgLengthFlag = [];
          this.store.commit('setplatimg', { platimg: [] });
          this.buildVisible = true;
          // 切换楼盘类型时同时清掉标签信息(切换二级楼盘类型时更新注释)
          // this.store.commit('setTags', []);
          // this.store.commit('setTagsCount', []);
          // this.store.commit('setEditCate', { editPropertyCategory: '' });
          // this.store.commit('setProCate', { propertyCategory: '' });
          // this.store.commit('setTagsConfig', { propertyTags: '' });
          this.info.estateAddress = '';
          this.info.buildingAge = '';
          // this.store.commit('setPayMent', 'coin')
          // 店铺或商厦
          if(isShopOrCommercial) {
            this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
          } 
          // 其他类型
          else {
            // 业主盘
            if(PropertySource == 1) {
              if(isAllow) {
                this.store.commit('setPayMent', this.info.topType.startsWith('Star') ? needPayDollar() ? 'paydollar' : 'coin' : 'free');
              } else {
                this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
              }
            }
            // 代理盘 
            else if(PropertySource == 2) {
              this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
            }
          }
          this.way = this.$store.state.payMent;
          // this.$store.state.payMent = 'coin';
          if (this.$refs.estateAddress) {
            this.$refs.estateAddress.estateAddressValue = '';
          }
        } else {
          // 复制和修改的时候修改了楼盘类型，楼盘地址应该为屋苑的地址
          if (this.info.estateID > 0) {
            if(isShopOrCommercial) {
              this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
            } 
            // 其他类型
            else {
              // 业主盘
              if(PropertySource == 1) {
                if(isAllow) {
                  this.store.commit('setPayMent', this.info.topType.startsWith('Star') ? needPayDollar() ? 'paydollar' : 'coin' : 'free');
                } else {
                  this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
                }
              }
              // 代理盘 
              else if(PropertySource == 2) {
                this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
              }
            }
            if (this.$route.query.type == 'edit' && this.way == 'free') {
              this.store.commit('setPayMent', 'free')
              this.way = this.$store.state.payMent;
            } else {
              this.way = this.$store.state.payMent;
            }
            // this.store.commit('setPayMent', 'coin')
            // this.way = this.$store.state.payMent;
            this.info.buildingAge = this.store.state.estateData && this.store.state.estateData.buildingAge > 0 ? this.store.state.estateData.buildingAge : '';
            this.info.estateAddress = this.store.state.estateData && this.store.state.estateData.detailAddressWithCulture;
            if (this.$refs.estateAddress) {
              this.$refs.estateAddress.estateAddressValue = this.store.state.estateData && this.store.state.estateData.detailAddressWithCulture;
            }
            this.isEstateAddFlag = Boolean(this.info.estateAddress);
            this.isBuildingAgeFlag = Boolean(this.info.buildingAge);
            if (data.warpData == 1) {
              if (this.store.state.estatePhase.length == 1) {
                this.store.commit('setPhaseSelectText', this.store.state.estatePhase[0].phaseWithCulture);
                this.store.commit('setPhaseWarpData', this.store.state.estatePhase[0].phaseWithCulture);
                this.store.commit('setPhaseData', this.store.state.estatePhase[0]);
                this.store.commit('setBuildNumByPhase', this.store.state.estateBuildNum);
              }
              if (this.store.state.estateBuildNum.length == 1) {
                this.store.commit('setBuildSelectText', this.store.state.estateBuildNum[0].phaseAndBuildingNameWithCulture);
                this.store.commit('setBuildSelectId', this.store.state.estateBuildNum[0]);
                this.info.buildingNameWithCulture = this.store.state.buildText;
                if (this.store.state.estatePhase && this.store.state.estatePhase.length > 1) {
                  let phaseByBuildName = this.store.state.estatePhase.filter((item) => {
                    return item.estateID == this.store.state.estateBuildNum[0].estateID;
                  });
                  this.store.commit('setPhaseData', phaseByBuildName);
                  this.store.commit('setPhaseSelectText', phaseByBuildName.length > 0 ? phaseByBuildName[0].phaseAndBuildingNameWithCulture : '');
                  this.store.commit('setPhaseWarpData', phaseByBuildName.length > 0 ? phaseByBuildName[0].phaseAndBuildingNameWithCulture : '');
                }
                if (this.store.state.estatePhase && this.store.state.estatePhase.length == 0) {
                  this.store.commit('setPhaseData', '');
                  this.store.commit('setPhaseSelectText', '');
                  this.store.commit('setPhaseWarpData', '');
                }
                this.axios
                  .get(this.pub.getApi().GetBuildingFloorPublish, {
                    params: {
                      buildingId: this.store.state.estateBuildNum[0].buildingID,
                    },
                  })
                  .then((res) => {
                    if (res.data.code == 0 && res.data.result) {
                      if (res.data.result.length > 0) {
                        this.store.commit('setFloorData', { title: this.lang.height1, children: res.data.result });
                      } else {
                        this.store.commit('setFloorData', { title: this.lang.height1, children: [] });
                      }

                      if (res.data.result.length == 1) {
                        this.store.commit('setFloorSelectText', res.data.result[0].floorNameWithCulture);
                        this.store.commit('setSelectFloorData', res.data.result[0]);
                        if (res.data.result[0].unitFloor > 0) {
                          this.store.commit('setUnitFloorSelctText', res.data.result[0].unitFloorWithCulture);
                        }
                      }
                    }
                  });
              }
            }
          } else {
            this.info.estateAddress = this.info.estateAddressWithCulture;
            if (this.$refs.estateAddress) {
              this.$refs.estateAddress.estateAddressValue = this.info.estateAddressWithCulture;
            }
          }
        }
        if (this.store.state.estateBuildNum.length > 0) {
          this.buildVisible = true;
        } else {
          this.buildVisible = false;
        }
        // if (this.$route.query.type == 'copy') {
        //   this.info.estateSrcList = [1, 2, 3, 4, 5];
        // }
        if (data.childData.includes('19')) {
          this.info['propertyNo'] = '--'
        }
        this.info[attr] = data.warpData;
        this.info.subCategory = data.childData;
        if (this.info.subCategory !== this.isReduceUnpaid_show) {
          this.clearBocPro()
        }
      } else if (attr == 'way') {
        this.way = this.$store.state.payMent;
        // this.way = data.warpData;
      } else if (attr == 'estateName') {
      } else if (attr == 'isShowTel' || attr == 'isHideCompanyInfo') {
        this.userInfo[attr] = data.warpData;
        if (attr == 'isShowTel') {
          if (data.childData.length != 0) {
            this.userInfo.isShowWhatsApp = false;
            this.userInfo.isShowWeChat = false;
            if (data.childData.includes(1) && this.userInfo.isShowTel) {
              this.userInfo.isShowWhatsApp = true;
            }
            if (data.childData.includes(2) && this.userInfo.isShowTel) {
              this.userInfo.isShowWeChat = true;
            }
          } else {
            this.userInfo.isShowWhatsApp = false;
            this.userInfo.isShowWeChat = false;
          }
        }
      } else if (attr == 'buildFloor') {
        this.info.isBoc = true;
        this.buildChecked = '1';
        this.$store.commit('setUnitImage', []);
        this.$store.commit('setFloUrl', []);
        this.platimgLength = [];
        this.platimgLengthFlag = [];
        this.store.commit('setplatimg', { platimg: [] });
        if (this.store.state.buildId.buildingType == 1 && Boolean(this.store.state.floorText)) {
          this.axios
            .post(this.pub.getApi().SearchPropertyPlanImage, {
              estateID: this.store.state.estateInfo.estateID,
              buildingId: this.store.state.buildId.buildingID,
              phaseEstateId: this.store.state.phaseData.estateID,
              floorName: this.store.state.floorText,
              roomNo: this.store.state.roomNoWithCulture,
              pageCount: 1,
              pageIndex: 1,
              imageType: 101,
            })
            .then((res) => {
              if (res.data.code == 0 && res.data.result.data.length > 0) {
                this.$store.commit('setUnitImage', res.data.result.data);
                this.platimgLength.push(res.data.result.data[0]);
                this.platimgLengthFlag = this.platimgLength;
                this.store.commit('setplatimg', { platimg: this.platimgLength });
              }
            });
        }
      } else if (attr == 'roomNoWithCulture') {
        this.info.isBoc = true;
        this.buildChecked = '1';
        Boolean(this.store.state.roomNoWithCulture) &&
          this.platimgLength.length > 0 &&
          this.platimgLength.forEach((item, index) => {
            if (item.imageType == 100) {
              this.platimgLength.splice(index, 1);
            }
          });
        if (!Boolean(this.store.state.roomNoWithCulture) && this.platimgLength.length > 0) {
          this.platimgLength.forEach((item, index) => {
            if (item.imageType == 100) {
              this.platimgLength.splice(index, 1);
              this.store.commit('setplatimg', { platimg: this.platimgLength });
              this.$store.commit('setFloUrl', []);
            }
          });
        }

        if (this.store.state.buildId.buildingType == 1 && Boolean(this.store.state.roomNoWithCulture)) {
          this.axios
            .post(this.pub.getApi().SearchPropertyPlanImage, {
              estateID: this.store.state.estateInfo.estateID,
              buildingId: this.store.state.buildId.buildingID,
              phaseEstateId: this.store.state.phaseData.estateID,
              floorName: this.store.state.floorText,
              roomNo: this.store.state.roomNoWithCulture,
              pageCount: 1,
              pageIndex: 1,
              imageType: 100,
            })
            .then((res) => {
              if (res.data.code == 0 && res.data.result.data.length > 0) {
                this.$store.commit('setFloUrl', res.data.result.data);
                this.platimgLength.push(res.data.result.data[0]);
                this.platimgLengthFlag = this.platimgLength;
                this.store.commit('setplatimg', { platimg: this.platimgLength });
              }
            });
        }
      } else if (attr == 'unitFloor') {
        this.info[attr] = this.store.state.UnitFloorText;
      } else if (attr == 'RoomNumber') {
        this.info[attr] = Boolean(this.store.state.roomNumberData.dictionaryValue) ? this.store.state.roomNumberData.dictionaryValue : 0;
      } else if (attr == 'ToiletNumber') {
        this.info[attr] = Boolean(this.store.state.toiletNumberData.dictionaryValue) ? this.store.state.toiletNumberData.dictionaryValue : 0;
      } else if (attr == 'PropertySource') {
        this.info[attr] = data.warpData;
        if (data.warpData === '1') {
          this.info.topType = 'Normal'
        } else {
          this.info.topType = 'Normal_Agent'
        }
        if (data.warpData === '2' || data.warpData === '1') {
          this.typeConfrim()
          this.way = this.$store.state.payMent;
        }
      } else {
        this.info[attr] = data.warpData;
        // 刊登时候盘源切换后要清空用户信息
        // if(attr = 'PropertySource' && this.info[attr] == 1 && this.mode == 'post'){
        //   this.resetUserInfo()
        // }
        /*获取到选择值后强制重新渲染页面*/
        this.$forceUpdate();
      }
      if(this.info.subCategory && this.info.RentLabel && this.info.subCategory.includes('19') && this.info.RentLabel.includes('8')){
        for (let index = 0; index < this.info.RentLabel.length; index++) {
          if( this.info.RentLabel[index] == 8){
            this.info.RentLabel.splice(index,1)
          }
        }
      }
      if(!this.info.subCategory.includes('19')) {
        this.info.servicesCN = ''
        this.info.servicesEN = ''
        // this.info['propertyNo'] = ''
      }
    },
    resetUserInfo(){
      this.userInfo = {
            telphone: '',
            companyNameCN: '',
            companyNameEN:'',
            companyTel: '',
            companyAddress: '',
            companyLicenceNumber:'',
            agentLicenceNumber:'',
            agentCardPath:'' /*代理证图片*/,
            customerTel: '',
            agentCardExpireTime:''
          };
    },
    getInput(attr, data, type) {
      this.info[attr] = data;
      if (attr == 'roomNoWithCulture' || attr == 'buildingNameWithCulture') {
        this.buildChecked = '1';
      }
    },
    /*切换价格选择*/
    changeCharge(type) {
      console.log("type", type)
      // 如果是业主盘，在切换选择的时候显示业主盘免费的弹窗
      if (this.mode == 'edit' || this.mode == '1') {
        return;
      } else if (this.mode == '2') {
        if (type == 'VerifyLabel') {
          if (this.disVerify) return;
          this.info.isVerify = !this.info.isVerify;
        }
      } else {
        if (type == 'VerifyLabel') {
          this.info.isVerify = !this.info.isVerify;
        } else {
          this.info.topType = type;
          this.info.isVerify = false; //*bugfix 选中验证后切换标准盘 会显示楼盘验证问题
        }
        // this.way = 'coin'
        const { isAllow } = this.$store.state;
        const { PropertySource, topType, PropertyCategory } = this.info;
        const { remainderPropertyCoin } = this.userInfo;
        const isStarBuy = topType === 'Star_Buy';
        const isStarRent = topType === 'Star_Rent';
        const isShopOrCommercial = PropertyCategory == '2' || PropertyCategory == '3';
        // 判断是否需要使用金币支付
        const needPayDollar = () => {
          if(isStarBuy && remainderPropertyCoin < this.star_BuyCoin) return true;
          if(isStarRent && remainderPropertyCoin < this.star_RentCoin) return true;
          if(PropertySource == 1 && remainderPropertyCoin < this.normalCoin) return true;
          if(PropertySource == 2 && remainderPropertyCoin < this.normal_AgentCoin) return true;
          return false;
        }
        // 店铺或商厦
        if(isShopOrCommercial) {
          this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
        }
        // 其他类型
        else {
          // 业主盘
          if(PropertySource == 1) {
            if(isAllow) {
              this.store.commit('setPayMent', this.info.topType.startsWith('Star') ? needPayDollar() ? 'paydollar' : 'coin' : 'free');
            } else {
              this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
            }
          }
          // 代理盘 
          else if(PropertySource == 2) {
            this.store.commit('setPayMent', needPayDollar() ? 'paydollar' : 'coin');
          }
        }
        this.way = this.$store.state.payMent;
      }
    },
    /*退出放盘*/
    prev() {
      // if(this.userInfo.remainderPropertyCoin < 200 || (this.info.topType.startsWith('Star') && this.userInfo.remainderPropertyCoin < 500)) {
      //   if(this.$store.state.isAllow && !this.info.topType.startsWith('Star')) {
      //     this.store.commit('setPayMent', 'free')
      //   } else {
      //     this.store.commit('setPayMent', 'paydollar')
      //   }
      // } else this.store.commit('setPayMent', 'coin')
      this.store.state.saleableArea = '';
      if (this.mode === 'edit') {
        this.cancelEditFlag = true;
      } else {
        this.$router.go(-1);
      }
    },
    quit(type) {
      if (type === 'disabled') {
        let app = this.$route.query.fromapp
        if (app) {
          const ua = navigator.userAgent.toLowerCase();
          let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; //android终端
          try {
            if (isAndroid) {
              window.house730.closePage();
            } else {
              window.webkit.messageHandlers.closePage.postMessage(JSON.stringify({}));
            }
          } catch (error) {}
        } else {
          this.$router.push('/');
        }
        return
      }
      if (this.$route.query && this.$route.query.type) {
        // this.$router.push(`/editProDetail/${this.$route.query.id}/`);
      } else {
        let app = this.$route.query.fromapp
        if (app) {
          const ua = navigator.userAgent.toLowerCase();
          let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; //android终端
          try {
            if (isAndroid) {
              window.house730.closePage();
            } else {
              window.webkit.messageHandlers.closePage.postMessage(JSON.stringify({}));
            }
          } catch (error) {}
        } else {
          this.$router.push('/');
        }
      }
    },
    pageViewGA () {
      if(window.dataLayer) {
        window.dataLayer.push({
          "event": "pageview",
          "source": "LPP",
          "target": '',
          "user":  {
            "language": this.language,
            "id": `${this.userInfo.userID}`,
          }
        })
      }
    },
    navigationInternalGA () {
      if(window.dataLayer) {
        window.dataLayer.push({
          "event": "navigationInternal",
          "source": "LPP",
          "target": "Property Listing",
          "user":  {
            "language": this.language,
            "id": `${this.userInfo.userID}`,
          }
        })
      }
    },
  },
  components: {
    cell,
    [Toast.name]: Toast,
  },
  metaInfo() {
    return {
      title: this.getTitle(),
    };
  },
  /*如果去到这些指定页面 保持缓存  如果去到别的页面 取消当前keep-alive缓存*/
  beforeRouteLeave: function (to, from, next) {
    // if (!['searchBuilding', 'photos', 'addressCheck', 'help', 'storedValueMoney', 'commonword'].includes(to.name)) {
    if (
      to.name != 'platimg' &&
      to.name != 'searchBuilding' &&
      to.name != 'tags' &&
      to.name != 'videos' &&
      to.name != 'photos' &&
      to.name != 'addressCheck' &&
      to.name != 'help' &&
      to.name != 'storedValueMoney' &&
      to.name != 'commonword' &&
      to.name != 'facilitiesAndServices'
    ) {
      this.dialogHide = false 
      this.store.commit('clearStore');
      if (this.$vnode && this.$vnode.data.keepAlive) {
        if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
          if (this.$vnode.componentOptions) {
            var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key;
            var cache = this.$vnode.parent.componentInstance.cache;
            var keys = this.$vnode.parent.componentInstance.keys;
            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key);
                if (index > -1) {
                  keys.splice(index, 1);
                }
              }
              delete cache[key];
            }
          }
        }
      }
      this.$destroy();
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.required {
  color: #ed1818;
}
.cellclass{
  padding:15px !important;
}
.disCell{
  padding:15px !important;
  pointer-events:none !important;
}
.consulting-box {
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #fff;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #ED1C24;
  letter-spacing: 0;
  line-height: 22px;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.del {
  position: absolute;
  top: 0;
  right: 0;
  width: 17px;
  height: 17px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 0 0 0 12px;
}
.dialogWord {
  box-sizing: border-box;
  text-align: center;
  /deep/.van-dialog__content {
    padding: 25px;
  }
  .keyWord {
    line-height: 25px;
  }
}

.opcity {
  opacity: 0.6;
}
/deep/.van-cell--required::before {
  top: 7px;
  left: 14px;
}
/deep/.van-cell {
  padding: 10px 20px;
  .van-cell__title {
    font-size: 15px;
    font-weight: 500;
    color: #333333;
    line-height: 21px;
    display: inline-block;
  }
}
.dis-warp {
  position: relative;
  .vrTipsLong {
    padding: 8px 15px 1px;
    font-weight: 400;
    font-size: 12px;
    color: #ED1C24;
    background-color: #ffffff;
    line-height: 17px;
  }
}
.vrTips {
  padding: 0px 15px 16px;
  font-weight: 400;
  font-size: 12px;
  color: #ED1C24;
  line-height: 17px;
}
.disable {
  opacity: 0;
  position: absolute;
  z-index: 999;
  background: #000;
  cursor: not-allowed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.yezhuType {
  /deep/.van-popup {
    width: 90%;
    border-radius: 10px;
  }
  .yzMain {
    padding: 24px;
    .yzType-h {
      text-align: center;
      h4 {
        font-size: 16px;
        font-weight: 700;
      }
    }
    .yzThreeadd{
      padding-bottom: 15px;
      font-size:14px;
      line-height: 28px;
    }
    .yzCon{
      border-top: 1px solid #f0f0f0;
      text-align:center;
      font-size:17px;
      color:#3391FF;
      height:20px;
      line-height:40px;
    }

    .yzThree {
      padding: 30px 0;
      // min-height: 60px;
      line-height: 28px;
      font-size:14px;
    }
  }
}
.disabledDialog {
  /deep/.van-popup {
    width: 90%;
    border-radius: 10px;
  }
  .disabledDialogMain {
    // padding: 24px;
    // .yzThreeadd{
    //   padding-bottom: 15px;
    //   font-size:14px;
    //   line-height: 28px;
    // }
    .disabledDialogCon{
      border-top: 1px solid #f0f0f0;
      text-align:center;
      font-size:17px;
      color:#3391FF;
      line-height: 44px;
      height: 44px;
    }

    .disabledDialogThree {
      margin: 24px;
      // min-height: 60px;
      line-height: 28px;
      font-size:14px;
    }
  }
}
.popType {
  /deep/.van-popup {
    width: 90%;
    border-radius: 5px;
  }
  height: 210px;
  padding: 15px 0;
  .chType-h {
    display: flex;
    justify-content: space-between;
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #eee;
    h4 {
      margin-left: 20px;
      font-size: 17px;
      font-weight: 600;
      color: #333333;
      display: inline-block;
    }
    span {
      margin-right: 20px;
      font-size: 12px;
      font-weight: 400;
      color: #0076ff;
      letter-spacing: 0px;
    }
  }
  .chType-main {
    padding: 0 20px;
    padding-bottom: 20px;
    .m-sale,
    .m-rent {
      display: flex;
      justify-content: space-between;
      height: 44px;
      font-size: 15px;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 44px;
      border-bottom: 1px solid #eee;
      h4 {
        font-size: 15px;
        font-weight: 500;
        text-align: left;
        color: #333333;
        // color: #ed1818;
        line-height: 44px;
        letter-spacing: 0px;
      }
    }
    .btn {
      width: 100%;
      height: 44px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
#post {
  text-align: left;
  background: #f5f6f7;
}
.warp-tit {
  background: #fff;
  padding: 15px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ::v-deep .van-image-preview__image {
      height: 496px !important;
      width: 327px !important;
    }
    .title-icon {
      width: 14px;
      height: 14px;
      border: 4px solid #ff1616;
      background: #ffffff;
      border-radius: 50%;
      box-sizing: border-box;
      margin-right: 10px;
    }
    .title-text {
      font-size: 20px;
      font-weight: 500;
      text-align: left;
      color: #333333;
      line-height: 28px;
      margin-right: auto;
    }
    .remark {
      margin-left: auto;
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 14px;
      color: #106FC4;
      letter-spacing: 0;
      text-decoration: underline;
    }
    .close-button {
      z-index: 9999;
      position: fixed;
      width: 38px;
      height: 38px;
      background: url(./../../assets/close@2x.png) center/contain no-repeat;
      top: 88%;
      left: 50%;
      transform: translateX(-50%);
    }
    .van-image-preview__image {
      border-radius: 4px;
    }
  }
  .tit-tip {
    font-size: 12px;
    font-weight: 400;
    color: #f73343;
    line-height: 17px;
    margin-left: 20px;
  }
}
.mt15 {
  margin-top: 15px;
}
.areaWarp {
  position: relative;
  .enline {
    width: 1px;
    height: 60px;
    background: #eee;
    position: absolute;
    top: 28px;
    right: 40%;
  }
  .line {
    width: 1px;
    height: 38px;
    background: #eee;
    position: absolute;
    top: 28px;
    right: 40%;
  }

  .area {
    display: flex;
    .buildArea {
      min-width: 30%;
      box-sizing: border-box;
      padding-right: 0;
      position: relative;
      /deep/.cell-head {
        margin-bottom: 17px;
      }
    }
    .enbuildArea {
      /deep/.cell-head {
        margin-bottom: 34px;
      }
    }
    .useArea {
      flex: 1;
      padding-left: 0;
      display: inline-block;
      min-width: 60%;
      // /deep/.cell-head {
      //   margin-bottom: 17px;
      // }
    }
    // .enuseArea {
    //   /deep/.cell-head {
    //     margin-bottom: 35px;
    //   }
    // }
  }
}
.content {
  .i-right {
    position: relative;
    top: -5px;
    margin-left: 15px;
  }
}
.agree,
.payway,
.verif,
.carpos {
  padding: 15px;
  background: #fff;
}
.flexbox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding: 15px 15px;
  .flexbox_content {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    font-size: 15px;
    font-weight: 400;
    color: #b2b2b2;
    line-height: 21px;
  }
  .flexbox_title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 4px;
    // padding-bottom: 15px;
    h3 {
      font-size: 15px;
      font-weight: 700;
    }
  }
  .flexbox_tip{
    span {
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #f73343;
      line-height: 17px;
    }
  }
  .flexbox_img {
    border-top: 1px solid #DDDDDD;
    margin-top: 4px;
    img {
      margin-right: 10px;
      // object-fit: cover;
    }
    .imgView {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      padding: 16px 0;
    }
  }
}
.ownerName {
  padding: 15px 0;
  /deep/ .cell {
    .cell-head {
      margin-bottom: 4px;
    }
  }
}
.remarks {
  padding: 0px 16px 15px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  line-height: 20px;
}
.imgTit{
  font-size:13px;
  display:block;
  margin-left:13px;
}
.charges {
  padding: 0 15px 12px;
  .chargeItem {
    margin-top: 15px;
    border: 1px solid #d8d8d8;
    background: #fff;
    height: 100px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    .charges-up {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
      margin: 17px 17px 10px 17px;
      .up-left {
        h3 {
          display: inline-block;
          font-size: 20px;
          font-weight: 500;
          color: #333333;
          margin-left: 8px;
        }
        img,
        .icon_ver {
          position: relative;
          top: 5px;
          font-size: 30px;
        }
      }
      .up-right {
        h4 {
          font-size: 20px;
          font-weight: 600;
          color: #333333;
          line-height: 28px;
          display: inline-block;
          i {
            font-size: 12px;
          }
        }
        del {
          font-size: 12px;
          color: #b2b2b2;
          line-height: 17px;
        }
        i.moeny {
          font-size: 16px;
        }
      }
    }
    .charge-tip {
      width: 100%;
      position: absolute;
      bottom: 0;
      i {
        display: inline-block;
        height: 40px;
        font-size: 13px;
        font-weight: 500;
        color: #333333;
        margin-left: 17px;
        padding-top: 12px;
        box-sizing: border-box;
      }
      .Star_i {
        margin: 0 26px 16px 15px;
        padding-top: 12px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        height: 53px;
      }
    }
  }
  .verifShow {
    display: none !important;
  }
  .verifi {
    display: block;
    padding-right: 65px;
    .charges-up {
      border: none;
    }
    .radio {
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }
  .selectItem {
    border: 1px solid #f73343;
    border-radius: 4px;
    .charge-tip {
      background: linear-gradient(311deg, #ff7979 7%, #ed1818);
      i {
        display: inline-block;
        color: #ffffff;
      }
    }
  }
  .disableItem {
    border: 1px solid #eb9393 !important;
    .charge-tip {
      background: linear-gradient(311deg, #eb9396 7%, #eb9393);
    }
  }
}
.charges > div:nth-child(2) {
  height: 129px;
}
.new-page-btn {
  margin-top: 0 !important;
}
.page_btn {
  margin-top: 26px;
  padding: 10px 15px;
  background: #001a33;
  display: flex;
  justify-content: space-between;
  height: 64px;
  box-sizing: border-box;
  .freeTit {
    font-size: 22px;
    color: #fff;
    text-align: left;
    width: 50%;
    line-height: 41px;
    img {
      vertical-align: text-bottom;
    }
  }
  .b-l {
    img {
      position: relative;
      top: -18px;
      left: -5px;
    }
    .moeny {
      display: inline-block;
      h4 {
        height: 27px;
        font-size: 22px;
        font-weight: 500;
        color: #ffffff;
      }
      span {
        font-size: 12px;
        font-weight: 400;
        color: #b2b2b2;
        line-height: 17px;
      }
    }
  }
  .b-r {
    .van-button {
      margin-top: 0;
      width: 105px;
    }
  }
  .new-b-r {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 0 auto;
    .van-button {
      margin-top: 0;
      // width: 164px;
      width: 100%;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0.22px;
      text-align: center;
      line-height: 20px;
    }
    .cancel-btn {
      margin-right: 16px;
      background: rgba(0, 0, 0, 0);
    }
  }
  .hideimg {
    img {
      display: none;
    }
  }
}
.confirmType {
  margin: 20px 0 20px 0;
  text-align: center;
  font-size: 15px;
  color: #333;
  line-height: 30px;
}
/deep/ .van-dialog__header {
  color: #000;
}
/deep/ .van-dialog {
  border-radius: 10px ;
}
/deep/.van-button--danger {
  margin: 0 !important;
}
.set-email-index.van-popup {
  text-align: center;
  border-radius: 4px;
  box-sizing: border-box;
  width: 70%;
  padding: 24px;
  p {
    color: #333;
    font-size: 15px;
    line-height: 21px;
    margin: 12px 0 24px;
  }
  .van-button {
    width: 95px;
    height: 40px;
    line-height: 40px;
    margin-right: 5px;
    // background-color: #ed1c24;
    // border: #ed1c24;
    font-size: 15px;
  }
}
.vid-show {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 400;
  color: #b2b2b2;
  line-height: 21px;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}
.agrcheck {
  width: 23px;
}
.agrcheck /deep/.van-icon {
  border: 1px solid #979797;
  border-radius: 50%;
}
.new-moeny {
  display: flex;
  align-items: center;
}
.new-b-l {
  height: 54px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  span {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.17px;
  }
  h4 {
    font-family: PingFangSC-Medium;
    font-weight: bold;
    font-size: 22px;
    color: #333333;
    letter-spacing: 0;
    margin-left: 6px;
  }
}
.cancel-title-edite {
  padding: 48px 52px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 1.5;
}
.cancel-edit {
  width: 296px;
  padding: 17px 21px 0 21px;
  text-align: center;
  line-height: 1.2;
  .cancel-title {
    padding: 48px 0;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}
.yezhu-payDone{
  padding:15px 20px 0 20px; 
  width:80%;
  .yezhu-tit{
    text-align:Center;
    font-size:20px;
    color:#333;
    margin-bottom:20px;
  }
  .yezhu-con1{
    margin-bottom:20px;
    font-size:14px;
    color:#929292;
    line-height:20px;
  }
}
.verify-failure {
  width: 296px;
  padding: 17px 21px 0 21px;
  .verify-title {
    font-weight: 600;
    font-size: 16px;
    color: #171725;
    letter-spacing: 0;
    text-align: center;
    margin-bottom: 28px;
  }
  .verify-p2,
  .verify-p3 {
    font-weight: 400;
    font-size: 14px;
    color: #171725;
    line-height: 26px;
  }
  .verify-p3 {
    margin-bottom: 28px;
  }
  .verify-p4 {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-bottom: 37px;
  }
}
.build-info {
  margin-top: 15px;
  background: #fff;
  padding: 12px 16px;
  .build-info-tips {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #ed1c24;
  }
  .build-info-text {
    padding-right: 15px;
    font-family: PingFangSC-Medium;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
  }
  .build-radio {
    /deep/.van-radio__icon {
      line-height: 16px !important;
    }
    /deep/.van-radio__icon .van-icon {
      width: 16px;
      height: 16px;
    }
  }
}
.study-icon {
  height: 44px;
  width: 44px;
  vertical-align: middle;
}
/deep/.van-cell:not(:last-child)::after {
  border: none !important;
}
/deep/.van-hairline--top-bottom::after {
  border: none !important;
}
/deep/.van-cell {
  align-items: center;
  padding-left: 0;
  padding-right: 0;
}
/deep/.van-cell .van-cell__title {
  margin-right: 35px;
}
/deep/.van-nav-bar__right {
  right: 0;
}
.marginTop15 {
  padding-top: 12px !important;
  margin-top: 15px !important;
}
// 银行估价样式
.valuation-bank {
  background: #fff;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .valuation-title {
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    line-height: 21px;
    display: inline-block;
    .required{
      color: #ed1818;
    }
  }
  .valuation-tips {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #ED1C24;
    line-height: 20px;
  }
}
</style>
